// react and js

// mui

// components
import { TradeBasicsDefaults, } from "../pages/ExpertAdvisorBuilder/actions/HandleTradeBasics";
import { InitialStopLossDefaults, } from "../pages/ExpertAdvisorBuilder/actions/HandleInitialStopLoss";
import { StopLossTrailingsDefaults, getTypeDisplay as stlGetTypeDisplay } from "../pages/ExpertAdvisorBuilder/actions/HandleStopLossTrailings";
import { InitialTakeProfitDefaults, } from "../pages/ExpertAdvisorBuilder/actions/HandleInitialTakeProfit";
import { TakeProfitDynamicsDefaults, getTypeDisplay as tpdGetTypeDisplay } from "../pages/ExpertAdvisorBuilder/actions/HandleTakeProfitDynamics";
import { SymbolAndTimeframeDefaults, SymbolAndTimeframeSymbolMappingsDefaults, } from "../pages/ExpertAdvisorBuilder/actions/HandleSymbolAndTimeframe";
import { VolumeCalculationDefaults, } from "../pages/ExpertAdvisorBuilder/actions/HandleVolumeCalculation";
import { PendingOrderSettingsDefaults, } from "../pages/ExpertAdvisorBuilder/actions/HandlePendingOrderSettings";
import { TradeSplittingDefaults, } from "../pages/ExpertAdvisorBuilder/actions/HandleTradeSplittings";
import { TimingDefaults, } from "../pages/ExpertAdvisorBuilder/actions/HandleTiming";
import { MonitoringDefaults, } from "../pages/ExpertAdvisorBuilder/actions/HandleMonitoring";
import { DataFeedbackDefaults, } from "../pages/ExpertAdvisorBuilder/actions/HandleDataFeedback";
import { MiscellaneousDefaults, } from "../pages/ExpertAdvisorBuilder/actions/HandleMiscellaneous";
import { NotificationsDefaults, } from "../pages/ExpertAdvisorBuilder/actions/HandleNotifications";
import { IndicatorDefaults, IndicatorsBuildName, IndicatorsBuildSubtitle, ALL_CONFIGS, } from "../pages/ExpertAdvisorBuilder/actions/HandleIndicators";
import { IndicatorCombinationsDefaults, IndicatorCombinationsBuildName, IndicatorCombinationsBuildSubtitle, } from "../pages/ExpertAdvisorBuilder/actions/HandleIndicatorCombinations";
import { ChartAnalyzersDefaults, ChartAnalyzersSwingConfigurationsDefaults, ChartAnalyzersBuildName, ChartAnalyzersBuildSubtitle, } from "../pages/ExpertAdvisorBuilder/actions/HandleChartAnalyzers";
import { NewsDefaults, NewsValueRelationsDefaults, NewsTitleFiltersDefaults, } from "../pages/ExpertAdvisorBuilder/actions/HandleNews";
import { CandlePatternsDefaults, } from "../pages/ExpertAdvisorBuilder/actions/HandleCandlePatterns";
import { ChartPatternsDefaults, } from "../pages/ExpertAdvisorBuilder/actions/HandleChartPatterns";
import { FibonacciPatternsDefaults, } from "../pages/ExpertAdvisorBuilder/actions/HandleFibonacciPatterns";

// hooks

// layouts

// pages

// theme

// utils

// widgets

// ----------------------------------------------------------------------
// Constants
// ----------------------------------------------------------------------
const DEBUG_LEVEL = 2;

// ----------------------------------------------------------------------
// Helper Functions
// ----------------------------------------------------------------------
function deepSortKeys(obj) {
  if (Array.isArray(obj)) {
    return obj.map(deepSortKeys);
  }
  if (obj !== null && typeof obj === `object`) {
    return Object.keys(obj)
      .sort()
      .reduce((sorted, key) => {
        sorted[key] = deepSortKeys(obj[key]);
        return sorted;
      }, {});
  }
  return obj;
}

const formatTo8Digits = (value, defaultValue = 0) => 
  /*
  // Handle null, undefined, or empty string
  if (value === null || value === undefined || value === '') {
    return defaultValue.toFixed(8);
  }
  
  // Convert to number
  const numericValue = parseFloat(value);
  
  // Check if conversion was successful
  if (Number.isNaN(numericValue)) {
    return defaultValue.toFixed(8);
  }
  
  // Return formatted value
  return numericValue.toFixed(8);
  */
   value
;

const parseFromFormattedDigits = (value, defaultValue = 0) => 
  /*
  // Handle null, undefined, or empty string
  if (value === null || value === undefined || value === '') {
    return defaultValue.toString();
  }
  
  // Convert to number
  const numericValue = parseFloat(value);
  
  // Check if conversion was successful
  if (Number.isNaN(numericValue)) {
    return defaultValue.toString();
  }
  
  // Convert back to string and remove trailing zeros
  return numericValue.toString();
  */
   value
;

// ----------------------------------------------------------------------
// Main Conversion Functions
// ----------------------------------------------------------------------
export const ModuleDataToTxtData = (moduleData) => {
  const useJson = false;
  let txtData = ``;

  const {professionalMode} = JSON.parse(localStorage.getItem(`expertAdvisorBuilderGuiState`));

  if (moduleData === undefined) {
    return;
  }

  if (useJson) {
    txtData = JSON.stringify(moduleData, null, 2);
  } else {
    const lines = [];

    // ----------------------------------------------------------------------
    // INOS_X
    // ----------------------------------------------------------------------
    const indicatorIdToNumber = {};
    if (moduleData.indicators !== undefined) {
      moduleData.indicators.forEach((indicator, index) => {
        const {config} = indicator;
        if (config === undefined || config === null) {
          return;
        }
        if (config.nSignalInUse === undefined || config.nSignalInUse === null) {
          return;
        }
        indicatorIdToNumber[indicator.id] = index + 1;
      });
    }

    // ----------------------------------------------------------------------
    // CA_X
    // ----------------------------------------------------------------------
    const chartAnalyzerIdToNumber = {};
    if (moduleData.chartAnalyzers !== undefined) {
      moduleData.chartAnalyzers.forEach((chartAnalyzer, index) => {
        const {config} = chartAnalyzer;
        if (config === undefined || config === null) {
          return;
        }
        if (config.nSignalInUse === undefined || config.nSignalInUse === null) {
          return;
        }
        chartAnalyzerIdToNumber[chartAnalyzer.id] = index + 1;
      });
    }

    // ----------------------------------------------------------------------
    // Meta
    // ----------------------------------------------------------------------
    lines.push(`[module_file]`);
    switch (moduleData.basics.nTradingState) {
      case `0`:
        lines.push(`[EXCLUDED]`);
        break;
      case `1`:
        lines.push(`[ENABLED]`);
        break;
      case `2`:
        lines.push(`[DISABLED_WITHOUT_CLOSING]`);
        break;
      case `3`:
        lines.push(`[DISABLED_WITH_CLOSING]`);
        break;
      default:
        lines.push(`[EXCLUDED]`);
    }
    lines.push(`#`);
    lines.push(
      `# Only files containing [module_file] in the first lines are read and interpreted as valid module files. If a file is recognized as a valid configuration, it must contain the state information in the second line of the file.`
    );
    lines.push(`#`);
    lines.push(`# A module file can have the following trading states and can be modified even when the trading module is already active:`);
    lines.push(`#`);
    lines.push(`#   [EXCLUDED]: The module is neither registered nor active.`);
    lines.push(`#   [ENABLED]: The module is registered and active. Trades will be placed if signals are detected.`);
    lines.push(`#   [DISABLED_WITHOUT_CLOSING]: The module is inactive, but existing trades won't be closed when this state is set.`);
    lines.push(`#   [DISABLED_WITH_CLOSING]: The module is inactive, and existing trades will be closed immediately when this state is set.`);
    lines.push(`#`);

    // ----------------------------------------------------------------------
    // MTA_1
    // ----------------------------------------------------------------------
    if (moduleData.basics === undefined) {
      return;
    }
    lines.push(`# +++++++++++++++++++++++++++++++++++++++++++++`);
    lines.push(`# Input group`);
    lines.push(`# +++++++++++++++++++++++++++++++++++++++++++++`);
    lines.push(`MTA_1_dVersion=${moduleData.basics.dVersion}`);
    const sanitizedDescription = (moduleData.basics.strIdeaOutputDescription || '').replace(/\r?\n/g, '').trim();
    if(sanitizedDescription === "")
    {
      lines.push(`MTA_1_strIdeaOutputDescription=Description not set!`);
    }
    else
    {
      lines.push(`MTA_1_strIdeaOutputDescription=${sanitizedDescription}`);
    }

    // ----------------------------------------------------------------------
    // RIM_1
    // ----------------------------------------------------------------------
    if (moduleData.volumeCalculation === undefined) {
      return;
    }
    lines.push(`# +++++++++++++++++++++++++++++++++++++++++++++`);
    lines.push(`# Input group`);
    lines.push(`# +++++++++++++++++++++++++++++++++++++++++++++`);
    lines.push(`RIM_1_nRiskProfile=${moduleData.volumeCalculation.nRiskProfile}`);
    lines.push(`RIM_1_nVolumeCalculation=${moduleData.volumeCalculation.nVolumeCalculation}`);
    lines.push(`RIM_1_dFixLots=${formatTo8Digits(moduleData.volumeCalculation.dFixLots)}`);
    lines.push(`RIM_1_dFixRelRisk=${formatTo8Digits(moduleData.volumeCalculation.dFixRelRisk)}`);
    lines.push(`RIM_1_dFixAbsRisk=${formatTo8Digits(moduleData.volumeCalculation.dFixAbsRisk)}`);
    if (professionalMode) { lines.push(`RIM_1_nMaxSpread=${moduleData.volumeCalculation.bMaxSpread ? moduleData.volumeCalculation.nMaxSpread : "0"}`) };
    if (professionalMode) { lines.push(`RIM_1_nInosUsedForValueInjection=${moduleData.volumeCalculation.nInosUsedForValueInjection !== "0" ? indicatorIdToNumber[moduleData.volumeCalculation.nInosUsedForValueInjection] : "0"}`) };
    if (professionalMode) { lines.push(`RIM_1_dCommissionPerLot=${formatTo8Digits(moduleData.volumeCalculation.dCommissionPerLot)}`) };

    // ----------------------------------------------------------------------
    // STF_1
    // ----------------------------------------------------------------------
    if (moduleData.symbolAndTimeframe === undefined) {
      return;
    }
    lines.push(`# +++++++++++++++++++++++++++++++++++++++++++++`);
    lines.push(`# Input group`);
    lines.push(`# +++++++++++++++++++++++++++++++++++++++++++++`);
    lines.push(`STF_1_strSymbol=${moduleData.symbolAndTimeframe.strSymbol === "Current" ? "CURRENT" : moduleData.symbolAndTimeframe.strSymbol}`);
    lines.push(`STF_1_nTimeframe=${moduleData.symbolAndTimeframe.nTimeframe}`);

    // ----------------------------------------------------------------------
    // STF_1_SMP_Y
    // ----------------------------------------------------------------------
    if (moduleData.symbolAndTimeframe.symbolMappings !== undefined) {
      if(moduleData.symbolAndTimeframe.symbolMappings.length !== 0)
      {
        lines.push(`# +++++++++++++++++++++++++++++++++++++++++++++`);
        lines.push(`# Input group`);
        lines.push(`# +++++++++++++++++++++++++++++++++++++++++++++`);
      }
      moduleData.symbolAndTimeframe.symbolMappings.forEach((symbolMapping, index) => {
        let writeValue = ``;
        if (symbolMapping.useLive === true) {
          writeValue += `L`;
        }
        if (symbolMapping.useStrategy === true) {
          writeValue += `T`;
        }
        writeValue += `;`;
        writeValue += symbolMapping.stringToReplace;
        writeValue += `;`;
        writeValue += symbolMapping.replacementString;
        lines.push(`STF_1_SMP_${index + 1}_strMapping=${writeValue}`);
      });
    }

    // ----------------------------------------------------------------------
    // ORM_1
    // ----------------------------------------------------------------------
    if (moduleData.tradeBasics === undefined || moduleData.notifications === undefined || moduleData.miscellaneous === undefined) {
      return;
    }
    lines.push(`# +++++++++++++++++++++++++++++++++++++++++++++`);
    lines.push(`# Input group`);
    lines.push(`# +++++++++++++++++++++++++++++++++++++++++++++`);
    if(professionalMode === true)
    {
      lines.push(`ORM_1_nOperation=${moduleData.tradeBasics.nOperation}`);
    }
    else
    {
      switch (moduleData.tradeBasics.nOrderType) {
        case "0": // buy
          lines.push(`ORM_1_nOperation=0`);
          break;
        case "1": // buy limit
          lines.push(`ORM_1_nOperation=0`);
          break;
        case "2": // buy stop
          lines.push(`ORM_1_nOperation=0`);
          break;
        case "3": // sell
          lines.push(`ORM_1_nOperation=1`);
          break;
        case "4": // sell limit
          lines.push(`ORM_1_nOperation=1`);
          break;
        case "5": // sell stop
          lines.push(`ORM_1_nOperation=1`);
          break;
        default:
          break;
      }
    }
    if (professionalMode) { lines.push(`ORM_1_nSignalLogic=${moduleData.tradeBasics.nSignalLogic}`) };
    lines.push(`ORM_1_strSymbol=${moduleData.tradeBasics.strSymbol === "Current" ? "CURRENT" : moduleData.tradeBasics.strSymbol}`);
    if (professionalMode) { lines.push(`ORM_1_strExclusion=${moduleData.tradeBasics.strExclusion}`) };
    if (professionalMode) { lines.push(`ORM_1_nTimeframe=${moduleData.tradeBasics.nTimeframe}`) };
    lines.push(`ORM_1_nComfortVisualization=${moduleData.tradeBasics.nComfortVisualization === true ? `1` : `0`}`);
    lines.push(`ORM_1_nOneTrade=${moduleData.tradeBasics.nOneTrade}`);
    lines.push(`#`);
    lines.push(`ORM_1_nNotificationLogs=${moduleData.notifications.nNotificationLogs === true ? `1` : `0`}`);
    lines.push(`ORM_1_nNotificationMails=${moduleData.notifications.nNotificationMails === true ? `1` : `0`}`);
    lines.push(`ORM_1_nNotificationProtection=${moduleData.notifications.nNotificationProtection === true ? `1` : `0`}`);
    lines.push(`ORM_1_nNotificationOpen=${moduleData.notifications.nNotificationOpen === true ? `1` : `0`}`);
    lines.push(`ORM_1_nNotificationClose=${moduleData.notifications.nNotificationClose === true ? `1` : `0`}`);
    lines.push(`ORM_1_nNotificationReportDaily=${moduleData.notifications.nNotificationReportDaily === true ? `1` : `0`}`);
    lines.push(`ORM_1_nNotificationReportWeekly=${moduleData.notifications.nNotificationReportWeekly === true ? `1` : `0`}`);
    lines.push(`ORM_1_nNotificationReportMonthly=${moduleData.notifications.nNotificationReportMonthly === true ? `1` : `0`}`);
    lines.push(`ORM_1_nNotificationReportEnd=${moduleData.notifications.nNotificationReportEnd === true ? `1` : `0`}`);
    lines.push(`#`);
    if (professionalMode) { lines.push(`ORM_1_nMaxSlippage=${moduleData.tradeBasics.nMaxSlippage}`) };
    lines.push(`ORM_1_nWaitingBetweenTrades=${moduleData.tradeBasics.nWaitingBetweenTrades}`);
    if (professionalMode) { lines.push(`#`) };
    if (professionalMode) { lines.push(`ORM_1_nLocalLimits=${moduleData.tradeBasics.nLocalLimits === true ? `1` : `0`}`) };
    if (professionalMode) { lines.push(`ORM_1_nLocalPending=${moduleData.pendingOrderSettings.nLocalPending === true ? `1` : `0`}`) };


    // ----------------------------------------------------------------------
    // ISL_1
    // ----------------------------------------------------------------------
    if (moduleData.initialStopLoss === undefined) {
      return;
    }
    lines.push(`# +++++++++++++++++++++++++++++++++++++++++++++`);
    lines.push(`# Input group`);
    lines.push(`# +++++++++++++++++++++++++++++++++++++++++++++`);
    lines.push(`ISL_1_nSelection=${moduleData.initialStopLoss.nSelection}`);
    lines.push(`ISL_1_nFixPipsMin=${moduleData.initialStopLoss.bFixPipsMin ? moduleData.initialStopLoss.nFixPipsMin : "0"}`);
    lines.push(`ISL_1_nFixPipsActual=${moduleData.initialStopLoss.nFixPipsActual}`);
    lines.push(`ISL_1_nFixPipsMax=${moduleData.initialStopLoss.bFixPipsMax ? moduleData.initialStopLoss.nFixPipsMax : "0"}`);
    lines.push(`ISL_1_dRateOfChangeMin=${moduleData.initialStopLoss.bRateOfChangeMin ? formatTo8Digits(moduleData.initialStopLoss.dRateOfChangeMin) : "0.00000000"}`);
    lines.push(`ISL_1_dRateOfChangeActual=${formatTo8Digits(moduleData.initialStopLoss.dRateOfChangeActual)}`);
    lines.push(`ISL_1_dRateOfChangeMax=${moduleData.initialStopLoss.bRateOfChangeMax ? formatTo8Digits(moduleData.initialStopLoss.dRateOfChangeMax) : "0.00000000"}`);
    if (professionalMode) { lines.push(`ISL_1_nInosUsedForValueInjection=${moduleData.initialStopLoss.nInosUsedForValueInjection !== "0" ? indicatorIdToNumber[moduleData.initialStopLoss.nInosUsedForValueInjection] : "0"}`) };
    if (professionalMode) { lines.push(`ISL_1_nCaSupResUsedForValueInjection=${moduleData.initialStopLoss.nCaSupResUsedForValueInjection !== "0" ? chartAnalyzerIdToNumber[moduleData.initialStopLoss.nCaSupResUsedForValueInjection] : "0"}`) };

    // ----------------------------------------------------------------------
    // SLT_X
    // ----------------------------------------------------------------------
    if (moduleData.stopLossTrailings !== undefined && moduleData.initialStopLoss.nSelection !== "0") {
      // Create temporary sorted array based on nChangePosition (smaller items first)
      const tempSortedData = moduleData.stopLossTrailings
        .slice()
        .sort((a, b) => {
          const aChangePos = a.config?.nChangePosition || 0;
          const bChangePos = b.config?.nChangePosition || 0;
          return aChangePos - bChangePos;
        });

      tempSortedData.forEach((stopLossTrailing, index) => {
        if (stopLossTrailing.config !== null && stopLossTrailing.config !== undefined) {
          lines.push(`# +++++++++++++++++++++++++++++++++++++++++++++`);
          lines.push(`# Input group`);
          lines.push(`# +++++++++++++++++++++++++++++++++++++++++++++`);
          lines.push(`SLT_${index + 1}_nType=${stopLossTrailing.config.nType}`);
          lines.push(`SLT_${index + 1}_nChangePosition=${stopLossTrailing.config.nChangePosition}`);
          lines.push(`SLT_${index + 1}_nBreakevenPosition=${stopLossTrailing.config.nBreakevenPosition}`);
          lines.push(`SLT_${index + 1}_nMarketBufferFix=${stopLossTrailing.config.nMarketBufferFix}`);
          lines.push(`SLT_${index + 1}_dMarketBufferSpread=${formatTo8Digits(stopLossTrailing.config.dMarketBufferSpread)}`);
          lines.push(`SLT_${index + 1}_nStepsSize=${stopLossTrailing.config.nStepsSize}`);
          lines.push(`SLT_${index + 1}_nStepsPosition=${stopLossTrailing.config.nStepsPosition}`);
          lines.push(`SLT_${index + 1}_nTimeCount=${stopLossTrailing.config.nTimeCount}`);
          lines.push(`SLT_${index + 1}_nLinearStep=${stopLossTrailing.config.nLinearStep}`);
          lines.push(`SLT_${index + 1}_nChangingDifference=${stopLossTrailing.config.nChangingDifference}`);
          lines.push(`SLT_${index + 1}_nHiLoPeriod=${stopLossTrailing.config.nHiLoPeriod}`);
          if (professionalMode) { lines.push(`SLT_${index + 1}_nCaSupResFixPipsMin=${stopLossTrailing.config.bCaSupResFixPipsMin ? stopLossTrailing.config.nCaSupResFixPipsMin : "0"}`) };
          if (professionalMode) { lines.push(`SLT_${index + 1}_nCaSupResFixPipsMax=${stopLossTrailing.config.bCaSupResFixPipsMax ? stopLossTrailing.config.nCaSupResFixPipsMax : "0"}`) };
          if (professionalMode) { lines.push(`SLT_${index + 1}_dCaSupResRateOfChangeMin=${stopLossTrailing.config.bCaSupResRateOfChangeMin ? formatTo8Digits(stopLossTrailing.config.dCaSupResRateOfChangeMin) : "0.00000000"}`) };
          if (professionalMode) { lines.push(`SLT_${index + 1}_dCaSupResRateOfChangeMax=${stopLossTrailing.config.bCaSupResRateOfChangeMax ? formatTo8Digits(stopLossTrailing.config.dCaSupResRateOfChangeMax) : "0.00000000"}`) };
          if (professionalMode) { lines.push(`SLT_${index + 1}_nInosUsedForValueInjection=${stopLossTrailing.config.nInosUsedForValueInjection !== "0" ? indicatorIdToNumber[stopLossTrailing.config.nInosUsedForValueInjection] : "0"}`) };
          if (professionalMode) { lines.push(`SLT_${index + 1}_nCaSupResUsedForValueInjection=${stopLossTrailing.config.nCaSupResUsedForValueInjection !== "0" ? chartAnalyzerIdToNumber[stopLossTrailing.config.nCaSupResUsedForValueInjection] : "0"}`) };
        }
      });
    }

    // ----------------------------------------------------------------------
    // ITP_1
    // ----------------------------------------------------------------------
    if (moduleData.initialTakeProfit === undefined) {
      return;
    }
    lines.push(`# +++++++++++++++++++++++++++++++++++++++++++++`);
    lines.push(`# Input group`);
    lines.push(`# +++++++++++++++++++++++++++++++++++++++++++++`);
    lines.push(`ITP_1_nSelection=${moduleData.initialTakeProfit.nSelection}`);
    lines.push(`ITP_1_dRiskRatio=${formatTo8Digits(moduleData.initialTakeProfit.dRiskRatio)}`);
    lines.push(`ITP_1_nFixPipsMin=${moduleData.initialTakeProfit.bFixPipsMin ? moduleData.initialTakeProfit.nFixPipsMin : "0"}`);
    lines.push(`ITP_1_nFixPipsActual=${moduleData.initialTakeProfit.nFixPipsActual}`);
    lines.push(`ITP_1_nFixPipsMax=${moduleData.initialTakeProfit.bFixPipsMax ? moduleData.initialTakeProfit.nFixPipsMax : "0"}`);
    lines.push(`ITP_1_dRateOfChangeMin=${moduleData.initialTakeProfit.bRateOfChangeMin ? formatTo8Digits(moduleData.initialTakeProfit.dRateOfChangeMin) : "0.00000000"}`);
    lines.push(`ITP_1_dRateOfChangeActual=${formatTo8Digits(moduleData.initialTakeProfit.dRateOfChangeActual)}`);
    lines.push(`ITP_1_dRateOfChangeMax=${moduleData.initialTakeProfit.bRateOfChangeMax ? formatTo8Digits(moduleData.initialTakeProfit.dRateOfChangeMax) : "0.00000000"}`);
    if (professionalMode) { lines.push(`ITP_1_nInosUsedForValueInjection=${moduleData.initialTakeProfit.nInosUsedForValueInjection !== "0" ? indicatorIdToNumber[moduleData.initialTakeProfit.nInosUsedForValueInjection] : "0"}`) };
    if (professionalMode) { lines.push(`ITP_1_nCaSupResUsedForValueInjection=${moduleData.initialTakeProfit.nCaSupResUsedForValueInjection !== "0" ? chartAnalyzerIdToNumber[moduleData.initialTakeProfit.nCaSupResUsedForValueInjection] : "0"}`) };

    // ----------------------------------------------------------------------
    // TPD_X
    // ----------------------------------------------------------------------
    if (moduleData.takeProfitDynamics !== undefined && moduleData.initialTakeProfit.nSelection !== "0") {
      // Create temporary sorted array based on nChangePosition (smaller items first)
      const tempSortedData = moduleData.takeProfitDynamics
        .slice()
        .sort((a, b) => {
          const aChangePos = a.config?.nChangePosition || 0;
          const bChangePos = b.config?.nChangePosition || 0;
          return aChangePos - bChangePos;
        });

      tempSortedData.forEach((takeProfitDynamic, index) => {
        if (takeProfitDynamic.config !== null && takeProfitDynamic.config !== undefined) {
          lines.push(`# +++++++++++++++++++++++++++++++++++++++++++++`);
          lines.push(`# Input group`);
          lines.push(`# +++++++++++++++++++++++++++++++++++++++++++++`);
          lines.push(`TPD_${index + 1}_nType=${takeProfitDynamic.config.nType}`);
          lines.push(`TPD_${index + 1}_nChangePosition=${takeProfitDynamic.config.nChangePosition}`);
          lines.push(`TPD_${index + 1}_nLinearStep=${takeProfitDynamic.config.nLinearStep}`);
          if (professionalMode) { lines.push(`TPD_${index + 1}_nMarketBarsMax=${takeProfitDynamic.config.nMarketBarsMax}`) };
          if (professionalMode) { lines.push(`TPD_${index + 1}_nMarketM1=${takeProfitDynamic.config.nMarketM1}`) };
          if (professionalMode) { lines.push(`TPD_${index + 1}_nMarketM2=${takeProfitDynamic.config.nMarketM2}`) };
          if (professionalMode) { lines.push(`TPD_${index + 1}_nMarketEnd=${takeProfitDynamic.config.nMarketEnd}`) };
          lines.push(`TPD_${index + 1}_nChangingDifference=${takeProfitDynamic.config.nChangingDifference}`);
          if (professionalMode) { lines.push(`TPD_${index + 1}_nCaSupResFixPipsMin=${takeProfitDynamic.config.bCaSupResFixPipsMin ? takeProfitDynamic.config.nCaSupResFixPipsMin : "0"}`) };
          if (professionalMode) { lines.push(`TPD_${index + 1}_nCaSupResFixPipsMax=${takeProfitDynamic.config.bCaSupResFixPipsMax ? takeProfitDynamic.config.nCaSupResFixPipsMax : "0"}`) };
          if (professionalMode) { lines.push(`TPD_${index + 1}_dCaSupResRateOfChangeMin=${takeProfitDynamic.config.bCaSupResRateOfChangeMin ? formatTo8Digits(takeProfitDynamic.config.dCaSupResRateOfChangeMin) : "0.00000000"}`) };
          if (professionalMode) { lines.push(`TPD_${index + 1}_dCaSupResRateOfChangeMax=${takeProfitDynamic.config.bCaSupResRateOfChangeMax ? formatTo8Digits(takeProfitDynamic.config.dCaSupResRateOfChangeMax) : "0.00000000"}`) };
          if (professionalMode) { lines.push(`TPD_${index + 1}_nInosUsedForValueInjection=${takeProfitDynamic.config.nInosUsedForValueInjection !== "0" ? indicatorIdToNumber[takeProfitDynamic.config.nInosUsedForValueInjection] : "0"}`) };
          if (professionalMode) { lines.push(`TPD_${index + 1}_nCaSupResUsedForValueInjection=${takeProfitDynamic.config.nCaSupResUsedForValueInjection !== "0" ? chartAnalyzerIdToNumber[takeProfitDynamic.config.nCaSupResUsedForValueInjection] : "0"}`) };
        }
      });
    }

    // ----------------------------------------------------------------------
    // PEO_1
    // ----------------------------------------------------------------------
    if (moduleData.pendingOrderSettings === undefined) {
      return;
    }
    lines.push(`# +++++++++++++++++++++++++++++++++++++++++++++`);
    lines.push(`# Input group`);
    lines.push(`# +++++++++++++++++++++++++++++++++++++++++++++`);
    if(professionalMode === true)
    {
      lines.push(`PEO_1_nMode=${moduleData.pendingOrderSettings.nMode}`);
      lines.push(`PEO_1_nPrice=${moduleData.pendingOrderSettings.nPrice}`);
      lines.push(`PEO_1_nLimits=${moduleData.pendingOrderSettings.nLimits}`);
      lines.push(`PEO_1_nFixPipsActual=${moduleData.pendingOrderSettings.nFixPipsActual}`);
      lines.push(`PEO_1_dRateOfChangeActual=${formatTo8Digits(moduleData.pendingOrderSettings.dRateOfChangeActual)}`);
      lines.push(`PEO_1_nExpiration=${moduleData.pendingOrderSettings.nExpiration}`);
    }
    else
    {
      switch (moduleData.tradeBasics.nOrderType) {
        case "0": // buy
          lines.push(`PEO_1_nMode=0`);
          break;
        case "1": // buy limit
          lines.push(`PEO_1_nMode=2`);
          break;
        case "2": // buy stop
          lines.push(`PEO_1_nMode=1`);
          break;
        case "3": // sell
          lines.push(`PEO_1_nMode=0`);
          break;
        case "4": // sell limit
          lines.push(`PEO_1_nMode=2`);
          break;
        case "5": // sell stop
          lines.push(`PEO_1_nMode=1`);
          break;
        default:
          break;
      }
      lines.push(`PEO_1_nPrice=${moduleData.tradeBasics.nPrice}`);
      lines.push(`PEO_1_nLimits=${moduleData.tradeBasics.nLimits}`);
      lines.push(`PEO_1_nFixPipsActual=${moduleData.tradeBasics.nFixPipsActual}`);
      lines.push(`PEO_1_dRateOfChangeActual=${formatTo8Digits(moduleData.tradeBasics.dRateOfChangeActual)}`);
      lines.push(`PEO_1_nExpiration=${moduleData.tradeBasics.nExpiration}`);
    }
    if (professionalMode) { lines.push(`PEO_1_nReference=${moduleData.pendingOrderSettings.nReference}`) };
    if (professionalMode) { lines.push(`PEO_1_nHysteresisMin=${moduleData.pendingOrderSettings.bHysteresisMin ? moduleData.pendingOrderSettings.nHysteresisMin : "0"}`) };
    if (professionalMode) { lines.push(`PEO_1_nHysteresisMax=${moduleData.pendingOrderSettings.bHysteresisMax ? moduleData.pendingOrderSettings.nHysteresisMax : "0"}`) };
    if (professionalMode) { lines.push(`PEO_1_nFixPipsMin=${moduleData.pendingOrderSettings.bFixPipsMin ? moduleData.pendingOrderSettings.nFixPipsMin : "0"}`) };
    if (professionalMode) { lines.push(`PEO_1_nFixPipsMax=${moduleData.pendingOrderSettings.bFixPipsMax ? moduleData.pendingOrderSettings.nFixPipsMax : "0"}`) };
    if (professionalMode) { lines.push(`PEO_1_dRateOfChangeMin=${moduleData.pendingOrderSettings.bRateOfChangeMin ? formatTo8Digits(moduleData.pendingOrderSettings.dRateOfChangeMin) : "0.0"}`) };
    if (professionalMode) { lines.push(`PEO_1_dRateOfChangeMax=${moduleData.pendingOrderSettings.bRateOfChangeMax ? formatTo8Digits(moduleData.pendingOrderSettings.dRateOfChangeMax) : "0.0"}`) };
    if (professionalMode) { lines.push(`PEO_1_nInosUsedForValueInjection=${moduleData.pendingOrderSettings.nInosUsedForValueInjection !== "0" ? indicatorIdToNumber[moduleData.pendingOrderSettings.nInosUsedForValueInjection] : "0"}`) };
    if (professionalMode) { lines.push(`PEO_1_nCaSupResUsedForValueInjection=${moduleData.pendingOrderSettings.nCaSupResUsedForValueInjection !== "0" ? chartAnalyzerIdToNumber[moduleData.pendingOrderSettings.nCaSupResUsedForValueInjection] : "0"}`) };

    // ----------------------------------------------------------------------
    // ISP_1
    // ----------------------------------------------------------------------
    if (moduleData.monitoring === undefined) {
      return;
    }
    lines.push(`# +++++++++++++++++++++++++++++++++++++++++++++`);
    lines.push(`# Input group`);
    lines.push(`# +++++++++++++++++++++++++++++++++++++++++++++`);
    lines.push(`ISP_1_nDrawInspectorPanel=${moduleData.monitoring.nDrawInspectorPanel === true ? `1` : `0`}`);
    lines.push(`#`);
    if (professionalMode) { lines.push(`ISP_1_dPerformanceDayAbsMin=${moduleData.monitoring.bPerformanceDayAbsMin ? formatTo8Digits(moduleData.monitoring.dPerformanceDayAbsMin) : "0.00"}`) };
    if (professionalMode) { lines.push(`ISP_1_dPerformanceDayAbsMax=${moduleData.monitoring.bPerformanceDayAbsMax ? formatTo8Digits(moduleData.monitoring.dPerformanceDayAbsMax) : "0.00"}`) };
    if (professionalMode) { lines.push(`ISP_1_dPerformanceDayRelMin=${moduleData.monitoring.bPerformanceDayRelMin ? formatTo8Digits(moduleData.monitoring.dPerformanceDayRelMin) : "0.00"}`) };
    if (professionalMode) { lines.push(`ISP_1_dPerformanceDayRelMax=${moduleData.monitoring.bPerformanceDayRelMax ? formatTo8Digits(moduleData.monitoring.dPerformanceDayRelMax) : "0.00"}`) };
    if (professionalMode) { lines.push(`ISP_1_dPerformanceWeekAbsMin=${moduleData.monitoring.bPerformanceWeekAbsMin ? formatTo8Digits(moduleData.monitoring.dPerformanceWeekAbsMin) : "0.00"}`) };
    if (professionalMode) { lines.push(`ISP_1_dPerformanceWeekAbsMax=${moduleData.monitoring.bPerformanceWeekAbsMax ? formatTo8Digits(moduleData.monitoring.dPerformanceWeekAbsMax) : "0.00"}`) };
    if (professionalMode) { lines.push(`ISP_1_dPerformanceWeekRelMin=${moduleData.monitoring.bPerformanceWeekRelMin ? formatTo8Digits(moduleData.monitoring.dPerformanceWeekRelMin) : "0.00"}`) };
    if (professionalMode) { lines.push(`ISP_1_dPerformanceWeekRelMax=${moduleData.monitoring.bPerformanceWeekRelMax ? formatTo8Digits(moduleData.monitoring.dPerformanceWeekRelMax) : "0.00"}`) };
    if (professionalMode) { lines.push(`ISP_1_dPerformanceMonthAbsMin=${moduleData.monitoring.bPerformanceMonthAbsMin ? formatTo8Digits(moduleData.monitoring.dPerformanceMonthAbsMin) : "0.00"}`) };
    if (professionalMode) { lines.push(`ISP_1_dPerformanceMonthAbsMax=${moduleData.monitoring.bPerformanceMonthAbsMax ? formatTo8Digits(moduleData.monitoring.dPerformanceMonthAbsMax) : "0.00"}`) };
    if (professionalMode) { lines.push(`ISP_1_dPerformanceMonthRelMin=${moduleData.monitoring.bPerformanceMonthRelMin ? formatTo8Digits(moduleData.monitoring.dPerformanceMonthRelMin) : "0.00"}`) };
    if (professionalMode) { lines.push(`ISP_1_dPerformanceMonthRelMax=${moduleData.monitoring.bPerformanceMonthRelMax ? formatTo8Digits(moduleData.monitoring.dPerformanceMonthRelMax) : "0.00"}`) };
    if (professionalMode) { lines.push(`ISP_1_dPerformanceYearAbsMin=${moduleData.monitoring.bPerformanceYearAbsMin ? formatTo8Digits(moduleData.monitoring.dPerformanceYearAbsMin) : "0.00"}`) };
    if (professionalMode) { lines.push(`ISP_1_dPerformanceYearAbsMax=${moduleData.monitoring.bPerformanceYearAbsMax ? formatTo8Digits(moduleData.monitoring.dPerformanceYearAbsMax) : "0.00"}`) };
    if (professionalMode) { lines.push(`ISP_1_dPerformanceYearRelMin=${moduleData.monitoring.bPerformanceYearRelMin ? formatTo8Digits(moduleData.monitoring.dPerformanceYearRelMin) : "0.00"}`) };
    if (professionalMode) { lines.push(`ISP_1_dPerformanceYearRelMax=${moduleData.monitoring.bPerformanceYearRelMax ? formatTo8Digits(moduleData.monitoring.dPerformanceYearRelMax) : "0.00"}`) };
    lines.push(`ISP_1_dPerformanceSinceStartAbsMin=${moduleData.monitoring.bPerformanceSinceStartAbsMin ? formatTo8Digits(moduleData.monitoring.dPerformanceSinceStartAbsMin) : "0.00"}`);
    lines.push(`ISP_1_dPerformanceSinceStartAbsMax=${moduleData.monitoring.bPerformanceSinceStartAbsMax ? formatTo8Digits(moduleData.monitoring.dPerformanceSinceStartAbsMax) : "0.00"}`);
    lines.push(`ISP_1_dPerformanceSinceStartRelMin=${moduleData.monitoring.bPerformanceSinceStartRelMin ? formatTo8Digits(moduleData.monitoring.dPerformanceSinceStartRelMin) : "0.00"}`);
    lines.push(`ISP_1_dPerformanceSinceStartRelMax=${moduleData.monitoring.bPerformanceSinceStartRelMax ? formatTo8Digits(moduleData.monitoring.dPerformanceSinceStartRelMax) : "0.00"}`);
    lines.push(`#`);
    if (professionalMode) { lines.push(`ISP_1_dDrawdownDayAbsMax=${moduleData.monitoring.bDrawdownDayAbsMax ? formatTo8Digits(moduleData.monitoring.dDrawdownDayAbsMax) : "0.00"}`) };
    if (professionalMode) { lines.push(`ISP_1_dDrawdownDayRelMax=${moduleData.monitoring.bDrawdownDayRelMax ? formatTo8Digits(moduleData.monitoring.dDrawdownDayRelMax) : "0.00"}`) };
    if (professionalMode) { lines.push(`ISP_1_dDrawdownWeekAbsMax=${moduleData.monitoring.bDrawdownWeekAbsMax ? formatTo8Digits(moduleData.monitoring.dDrawdownWeekAbsMax) : "0.00"}`) };
    if (professionalMode) { lines.push(`ISP_1_dDrawdownWeekRelMax=${moduleData.monitoring.bDrawdownWeekRelMax ? formatTo8Digits(moduleData.monitoring.dDrawdownWeekRelMax) : "0.00"}`) };
    if (professionalMode) { lines.push(`ISP_1_dDrawdownMonthAbsMax=${moduleData.monitoring.bDrawdownMonthAbsMax ? formatTo8Digits(moduleData.monitoring.dDrawdownMonthAbsMax) : "0.00"}`) };
    if (professionalMode) { lines.push(`ISP_1_dDrawdownMonthRelMax=${moduleData.monitoring.bDrawdownMonthRelMax ? formatTo8Digits(moduleData.monitoring.dDrawdownMonthRelMax) : "0.00"}`) };
    if (professionalMode) { lines.push(`ISP_1_dDrawdownYearAbsMax=${moduleData.monitoring.bDrawdownYearAbsMax ? formatTo8Digits(moduleData.monitoring.dDrawdownYearAbsMax) : "0.00"}`) };
    if (professionalMode) { lines.push(`ISP_1_dDrawdownYearRelMax=${moduleData.monitoring.bDrawdownYearRelMax ? formatTo8Digits(moduleData.monitoring.dDrawdownYearRelMax) : "0.00"}`) };
    lines.push(`ISP_1_dDrawdownSinceStartAbsMax=${moduleData.monitoring.bDrawdownSinceStartAbsMax ? formatTo8Digits(moduleData.monitoring.dDrawdownSinceStartAbsMax) : "0.00"}`);
    lines.push(`ISP_1_dDrawdownSinceStartRelMax=${moduleData.monitoring.bDrawdownSinceStartRelMax ? formatTo8Digits(moduleData.monitoring.dDrawdownSinceStartRelMax) : "0.00"}`);

    // ----------------------------------------------------------------------
    // TSP_1_SPLIT_Y
    // ----------------------------------------------------------------------
    if (moduleData.tradeSplittings !== undefined) {
      moduleData.tradeSplittings.forEach((tradeSplitting, index) => {
        if (tradeSplitting.config !== null && tradeSplitting.config !== undefined) {
          lines.push(`# +++++++++++++++++++++++++++++++++++++++++++++`);
          lines.push(`# Input group`);
          lines.push(`# +++++++++++++++++++++++++++++++++++++++++++++`);
          lines.push(`TSP_1_SPLIT_${index + 1}_nOpenVolume=${tradeSplitting.config.nOpenVolume}`);
          lines.push(`TSP_1_SPLIT_${index + 1}_nOpenPosition=${tradeSplitting.config.nOpenPosition}`);
          lines.push(`TSP_1_SPLIT_${index + 1}_nClosePosition=${tradeSplitting.config.nClosePosition}`);
        }
      });
    }

    // ----------------------------------------------------------------------
    // FEB_1
    // ----------------------------------------------------------------------
    if (moduleData.dataFeedback === undefined) {
      return;
    }
    lines.push(`# +++++++++++++++++++++++++++++++++++++++++++++`);
    lines.push(`# Input group`);
    lines.push(`# +++++++++++++++++++++++++++++++++++++++++++++`);
    lines.push(`FEB_1_nInspectorState=${moduleData.dataFeedback.nInspectorState === true ? `1` : `0`}`);
    lines.push(`FEB_1_nInspectorRefreshInterval=${moduleData.dataFeedback.nInspectorRefreshInterval}`);
    lines.push(`#`);
    lines.push(`FEB_1_nPresentTradesState=${moduleData.dataFeedback.nPresentTradesState === true ? `1` : `0`}`);
    lines.push(`FEB_1_nPresentTradesRefreshInterval=${moduleData.dataFeedback.nPresentTradesRefreshInterval}`);
    lines.push(`#`);
    lines.push(`FEB_1_nPastTradesState=${moduleData.dataFeedback.nPastTradesState === true ? `1` : `0`}`);
    if (professionalMode) { lines.push(`#`) };
    if (professionalMode) { lines.push(`FEB_1_nMetaDataState=${moduleData.dataFeedback.nMetaDataState === true ? `1` : `0`}`) };
    if (professionalMode) { lines.push(`#`) };
    if (professionalMode) { lines.push(`FEB_1_nTradeScreenshotsState=${moduleData.dataFeedback.nTradeScreenshotsState === true ? `1` : `0`}`) };
    if (professionalMode) { lines.push(`#`) };
    if (professionalMode) { lines.push(`FEB_1_nCurrentValueState=${moduleData.dataFeedback.nCurrentValueState === true ? `1` : `0`}`) };
    if (professionalMode) { lines.push(`FEB_1_nCurrentValueEvt=${moduleData.dataFeedback.nCurrentValueEvt === true ? `1` : `0`}`) };
    if (professionalMode) { lines.push(`FEB_1_nCurrentValueInos=${moduleData.dataFeedback.nCurrentValueInos === true ? `1` : `0`}`) };
    if (professionalMode) { lines.push(`FEB_1_nCurrentValueCa=${moduleData.dataFeedback.nCurrentValueCa === true ? `1` : `0`}`) };
    if (professionalMode) { lines.push(`FEB_1_nCurrentValueCas=${moduleData.dataFeedback.nCurrentValueCas === true ? `1` : `0`}`) };
    if (professionalMode) { lines.push(`FEB_1_nCurrentValuePas=${moduleData.dataFeedback.nCurrentValuePas === true ? `1` : `0`}`) };
    if (professionalMode) { lines.push(`FEB_1_nCurrentValueFis=${moduleData.dataFeedback.nCurrentValueFis === true ? `1` : `0`}`) };
    if (professionalMode) { lines.push(`FEB_1_nCurrentValueRefreshInterval=${moduleData.dataFeedback.nCurrentValueRefreshInterval}`) };
    if (professionalMode) { lines.push(`#`) };
    if (professionalMode) { lines.push(`FEB_1_nTimeAnalysisState=${moduleData.dataFeedback.nTimeAnalysisState === true ? `1` : `0`}`) };
    if (professionalMode) { lines.push(`FEB_1_nTimeAnalysisMinutePeriod=${moduleData.dataFeedback.nTimeAnalysisMinutePeriod}`) };
    if (professionalMode) { lines.push(`FEB_1_nTimeAnalysisHourPeriod=${moduleData.dataFeedback.nTimeAnalysisHourPeriod}`) };
    if (professionalMode) { lines.push(`FEB_1_nTimeAnalysisDayPeriod=${moduleData.dataFeedback.nTimeAnalysisDayPeriod}`) };
    if (professionalMode) { lines.push(`FEB_1_nTimeAnalysisWeekdayPeriod=${moduleData.dataFeedback.nTimeAnalysisWeekdayPeriod}`) };
    if (professionalMode) { lines.push(`FEB_1_nTimeAnalysisWeekPeriod=${moduleData.dataFeedback.nTimeAnalysisWeekPeriod}`) };
    if (professionalMode) { lines.push(`FEB_1_nTimeAnalysisMonthPeriod=${moduleData.dataFeedback.nTimeAnalysisMonthPeriod}`) };
    if (professionalMode) { lines.push(`FEB_1_nTimeAnalysisRefreshInterval=${moduleData.dataFeedback.nTimeAnalysisRefreshInterval}`) };
    if (professionalMode) { lines.push(`#`) };
    if (professionalMode) { lines.push(`FEB_1_nValueAnalysisState=${moduleData.dataFeedback.nValueAnalysisState === true ? `1` : `0`}`) };
    if (professionalMode) { lines.push(`FEB_1_nValueAnalysisEvtPeriod=${moduleData.dataFeedback.nValueAnalysisEvtPeriod}`) };
    if (professionalMode) { lines.push(`FEB_1_nValueAnalysisInosPeriod=${moduleData.dataFeedback.nValueAnalysisInosPeriod}`) };
    if (professionalMode) { lines.push(`FEB_1_nValueAnalysisCaPeriod=${moduleData.dataFeedback.nValueAnalysisCaPeriod}`) };
    if (professionalMode) { lines.push(`FEB_1_nValueAnalysisCasPeriod=${moduleData.dataFeedback.nValueAnalysisCasPeriod}`) };
    if (professionalMode) { lines.push(`FEB_1_nValueAnalysisPasPeriod=${moduleData.dataFeedback.nValueAnalysisPasPeriod}`) };
    if (professionalMode) { lines.push(`FEB_1_nValueAnalysisFisPeriod=${moduleData.dataFeedback.nValueAnalysisFisPeriod}`) };
    if (professionalMode) { lines.push(`FEB_1_nValueAnalysisHistogramBins=${moduleData.dataFeedback.nValueAnalysisHistogramBins}`) };
    if (professionalMode) { lines.push(`FEB_1_nValueAnalysisRefreshInterval=${moduleData.dataFeedback.nValueAnalysisRefreshInterval}`) };
    if (professionalMode) { lines.push(`#`) };
    if (professionalMode) { lines.push(`FEB_1_nSignalAnalysisState=${moduleData.dataFeedback.nSignalAnalysisState === true ? `1` : `0`}`) };
    if (professionalMode) { lines.push(`FEB_1_nSignalAnalysisActualTradePeriod=${moduleData.dataFeedback.nSignalAnalysisActualTradePeriod}`) };
    if (professionalMode) { lines.push(`FEB_1_nSignalAnalysisGeneralSignalPeriod=${moduleData.dataFeedback.nSignalAnalysisGeneralSignalPeriod}`) };
    if (professionalMode) { lines.push(`FEB_1_nSignalAnalysisEvtPeriod=${moduleData.dataFeedback.nSignalAnalysisEvtPeriod}`) };
    if (professionalMode) { lines.push(`FEB_1_nSignalAnalysisInosPeriod=${moduleData.dataFeedback.nSignalAnalysisInosPeriod}`) };
    if (professionalMode) { lines.push(`FEB_1_nSignalAnalysisRelioPeriod=${moduleData.dataFeedback.nSignalAnalysisRelioPeriod}`) };
    if (professionalMode) { lines.push(`FEB_1_nSignalAnalysisCaPeriod=${moduleData.dataFeedback.nSignalAnalysisCaPeriod}`) };
    if (professionalMode) { lines.push(`FEB_1_nSignalAnalysisCasPeriod=${moduleData.dataFeedback.nSignalAnalysisCasPeriod}`) };
    if (professionalMode) { lines.push(`FEB_1_nSignalAnalysisPasPeriod=${moduleData.dataFeedback.nSignalAnalysisPasPeriod}`) };
    if (professionalMode) { lines.push(`FEB_1_nSignalAnalysisFisPeriod=${moduleData.dataFeedback.nSignalAnalysisFisPeriod}`) };
    if (professionalMode) { lines.push(`FEB_1_nSignalAnalysisBarsBefore=${moduleData.dataFeedback.nSignalAnalysisBarsBefore}`) };
    if (professionalMode) { lines.push(`FEB_1_nSignalAnalysisBarsAfter=${moduleData.dataFeedback.nSignalAnalysisBarsAfter}`) };
    if (professionalMode) { lines.push(`FEB_1_nSignalAnalysisRefreshInterval=${moduleData.dataFeedback.nSignalAnalysisRefreshInterval}`) };
    if (professionalMode) { lines.push(`#`) };
    if (professionalMode) { lines.push(`FEB_1_nSymbolSeriesBarsCompletedState=${moduleData.dataFeedback.nSymbolSeriesBarsCompletedState === true ? `1` : `0`}`) };
    if (professionalMode) { lines.push(`FEB_1_nSymbolSeriesBarsCurrentState=${moduleData.dataFeedback.nSymbolSeriesBarsCurrentState === true ? `1` : `0`}`) };
    if (professionalMode) { lines.push(`FEB_1_nSymbolSeriesM1State=${moduleData.dataFeedback.nSymbolSeriesM1State === true ? `1` : `0`}`) };
    if (professionalMode) { lines.push(`FEB_1_nSymbolSeriesM1Range=${moduleData.dataFeedback.nSymbolSeriesM1Range}`) };
    if (professionalMode) { lines.push(`FEB_1_nSymbolSeriesM5State=${moduleData.dataFeedback.nSymbolSeriesM5State === true ? `1` : `0`}`) };
    if (professionalMode) { lines.push(`FEB_1_nSymbolSeriesM5Range=${moduleData.dataFeedback.nSymbolSeriesM5Range}`) };
    if (professionalMode) { lines.push(`FEB_1_nSymbolSeriesM15State=${moduleData.dataFeedback.nSymbolSeriesM15State === true ? `1` : `0`}`) };
    if (professionalMode) { lines.push(`FEB_1_nSymbolSeriesM15Range=${moduleData.dataFeedback.nSymbolSeriesM15Range}`) };
    if (professionalMode) { lines.push(`FEB_1_nSymbolSeriesM30State=${moduleData.dataFeedback.nSymbolSeriesM30State === true ? `1` : `0`}`) };
    if (professionalMode) { lines.push(`FEB_1_nSymbolSeriesM30Range=${moduleData.dataFeedback.nSymbolSeriesM30Range}`) };
    if (professionalMode) { lines.push(`FEB_1_nSymbolSeriesH1State=${moduleData.dataFeedback.nSymbolSeriesH1State === true ? `1` : `0`}`) };
    if (professionalMode) { lines.push(`FEB_1_nSymbolSeriesH1Range=${moduleData.dataFeedback.nSymbolSeriesH1Range}`) };
    if (professionalMode) { lines.push(`FEB_1_nSymbolSeriesH4State=${moduleData.dataFeedback.nSymbolSeriesH4State === true ? `1` : `0`}`) };
    if (professionalMode) { lines.push(`FEB_1_nSymbolSeriesH4Range=${moduleData.dataFeedback.nSymbolSeriesH4Range}`) };
    if (professionalMode) { lines.push(`FEB_1_nSymbolSeriesD1State=${moduleData.dataFeedback.nSymbolSeriesD1State === true ? `1` : `0`}`) };
    if (professionalMode) { lines.push(`FEB_1_nSymbolSeriesD1Range=${moduleData.dataFeedback.nSymbolSeriesD1Range}`) };
    if (professionalMode) { lines.push(`FEB_1_nSymbolSeriesW1State=${moduleData.dataFeedback.nSymbolSeriesW1State === true ? `1` : `0`}`) };
    if (professionalMode) { lines.push(`FEB_1_nSymbolSeriesW1Range=${moduleData.dataFeedback.nSymbolSeriesW1Range}`) };
    if (professionalMode) { lines.push(`FEB_1_nSymbolSeriesMNState=${moduleData.dataFeedback.nSymbolSeriesMNState === true ? `1` : `0`}`) };
    if (professionalMode) { lines.push(`FEB_1_nSymbolSeriesMNRange=${moduleData.dataFeedback.nSymbolSeriesMNRange}`) };

    // ----------------------------------------------------------------------
    // MIS_1
    // ----------------------------------------------------------------------
    if (moduleData.miscellaneous === undefined) {
      return;
    }
    lines.push(`# +++++++++++++++++++++++++++++++++++++++++++++`);
    lines.push(`# Input group`);
    lines.push(`# +++++++++++++++++++++++++++++++++++++++++++++`);
    if (professionalMode) { lines.push(`MIS_1_nGeneralSignalVisualization=${moduleData.tradeBasics.nGeneralSignalVisualization === true ? `1` : `0`}`) };
    if (professionalMode) { lines.push(`MIS_1_nDrawUnequalSymbols=${moduleData.miscellaneous.nDrawUnequalSymbols === true ? `1` : `0`}`) };
    lines.push(`MIS_1_nDrawSecondTimeframe=${moduleData.miscellaneous.nDrawSecondTimeframe}`);
    if (professionalMode) { lines.push(`MIS_1_nDrawChartAnalyzerPanel=${moduleData.miscellaneous.nDrawChartAnalyzerPanel === true ? `1` : `0`}`) };

    // ----------------------------------------------------------------------
    // TIM_1
    // ----------------------------------------------------------------------
    if (moduleData.timing === undefined) {
      return;
    }
    lines.push(`# +++++++++++++++++++++++++++++++++++++++++++++`);
    lines.push(`# Input group`);
    lines.push(`# +++++++++++++++++++++++++++++++++++++++++++++`);
    lines.push(`TIM_1_nVisualizeTiming=${moduleData.timing.nVisualizeTiming === true ? `1` : `0`}`);
    lines.push(`#`);
    lines.push(`TIM_1_strTradingSeconds=${moduleData.timing.strTradingSeconds}`);
    lines.push(`TIM_1_strTradingMinutes=${moduleData.timing.strTradingMinutes}`);
    lines.push(`TIM_1_strTradingHours=${moduleData.timing.strTradingHours}`);
    lines.push(`TIM_1_strTradingDays=${moduleData.timing.strTradingDays}`);
    lines.push(`TIM_1_strTradingWeeks=${moduleData.timing.strTradingWeeks}`);
    lines.push(`TIM_1_strTradingMonths=${moduleData.timing.strTradingMonths}`);
    lines.push(`TIM_1_strTradingDaysOfWeek=${moduleData.timing.strTradingDaysOfWeek}`);
    if (professionalMode) { lines.push(`#`) };
    if (professionalMode) { lines.push(`TIM_1_nIntradayMode=${moduleData.timing.nIntradayMode === true ? `1` : `0`}`) };
    if (professionalMode) { lines.push(`TIM_1_strStartIntradayTrading=${moduleData.timing.strStartIntradayTrading}`) };
    if (professionalMode) { lines.push(`TIM_1_strStopIntradayTrading=${moduleData.timing.strStopIntradayTrading}`) };
    if (professionalMode) { lines.push(`TIM_1_strDeadlineIntradayTrading=${moduleData.timing.strDeadlineIntradayTrading}`) };
    if (professionalMode) { lines.push(`#`) };
    if (professionalMode) { lines.push(`TIM_1_nDstSummerShiftedMinutes=${moduleData.timing.nDstSummerShiftedMinutes}`) };
    if (professionalMode) { lines.push(`TIM_1_strDstSummerShiftStart=${moduleData.timing.nDstSummerShiftStartNumberOfMonth},${moduleData.timing.nDstSummerShiftStartDayOfWeek},${moduleData.timing.nDstSummerShiftStartCountDayOfWeekInMonth},${moduleData.timing.strDstSummerShiftStartTime}`) };
    if (professionalMode) { lines.push(`TIM_1_strDstSummerShiftEnd=${moduleData.timing.nDstSummerShiftEndNumberOfMonth},${moduleData.timing.nDstSummerShiftEndDayOfWeek},${moduleData.timing.nDstSummerShiftEndCountDayOfWeekInMonth},${moduleData.timing.strDstSummerShiftEndTime}`) };
    if (professionalMode) { lines.push(`#`) };
    if (professionalMode) { lines.push(`TIM_1_nDstWinterShiftedMinutes=${moduleData.timing.nDstWinterShiftedMinutes}`) };
    if (professionalMode) { lines.push(`TIM_1_strDstWinterShiftStart=${moduleData.timing.nDstWinterShiftStartNumberOfMonth},${moduleData.timing.nDstWinterShiftStartDayOfWeek},${moduleData.timing.nDstWinterShiftStartCountDayOfWeekInMonth},${moduleData.timing.strDstWinterShiftStartTime}`) };
    if (professionalMode) { lines.push(`TIM_1_strDstWinterShiftEnd=${moduleData.timing.nDstWinterShiftEndNumberOfMonth},${moduleData.timing.nDstWinterShiftEndDayOfWeek},${moduleData.timing.nDstWinterShiftEndCountDayOfWeekInMonth},${moduleData.timing.strDstWinterShiftEndTime}`) };

    // ----------------------------------------------------------------------
    // EVT_1
    // ----------------------------------------------------------------------
    if (moduleData.news === undefined) {
      return;
    }
    lines.push(`# +++++++++++++++++++++++++++++++++++++++++++++`);
    lines.push(`# Input group`);
    lines.push(`# +++++++++++++++++++++++++++++++++++++++++++++`);
    lines.push(`EVT_1_nSignalInUse=${moduleData.news.nSignalInUse === true ? `1` : `0`}`);
    lines.push(`EVT_1_nSignalUsedFor=${moduleData.news.nSignalUsedFor}`);
    lines.push(`EVT_1_nSignalVisualization=${moduleData.news.nSignalVisualization === true ? `1` : `0`}`);
    lines.push(`#`);
    lines.push(`EVT_1_nDrawTable=${moduleData.news.nDrawTable === true ? `1` : `0`}`);
    lines.push(`EVT_1_nDrawChart=${moduleData.news.nDrawChart === true ? `1` : `0`}`);
    lines.push(`EVT_1_nDrawKeepInCache=${moduleData.news.nDrawKeepInCache}`);
    lines.push(`#`);
    lines.push(`EVT_1_nSignalNegation=${moduleData.news.nSignalNegation === true ? `1` : `0`}`);
    lines.push(`EVT_1_nShiftInSec=${moduleData.news.nShiftInSec}`);
    lines.push(`EVT_1_nPreSignalTime=${moduleData.news.nPreSignalTime}`);
    lines.push(`EVT_1_nPostSignalTime=${moduleData.news.nPostSignalTime}`);
    lines.push(`#`);
    lines.push(`EVT_1_nRegionAll=${moduleData.news.nRegionAll === true ? `1` : `0`}`);
    lines.push(`EVT_1_nRegionAud=${moduleData.news.nRegionAud === true ? `1` : `0`}`);
    lines.push(`EVT_1_nRegionBrl=${moduleData.news.nRegionBrl === true ? `1` : `0`}`);
    lines.push(`EVT_1_nRegionCad=${moduleData.news.nRegionCad === true ? `1` : `0`}`);
    lines.push(`EVT_1_nRegionChf=${moduleData.news.nRegionChf === true ? `1` : `0`}`);
    lines.push(`EVT_1_nRegionCny=${moduleData.news.nRegionCny === true ? `1` : `0`}`);
    lines.push(`EVT_1_nRegionEur=${moduleData.news.nRegionEur === true ? `1` : `0`}`);
    lines.push(`EVT_1_nRegionGbp=${moduleData.news.nRegionGbp === true ? `1` : `0`}`);
    lines.push(`EVT_1_nRegionHkd=${moduleData.news.nRegionHkd === true ? `1` : `0`}`);
    lines.push(`EVT_1_nRegionInr=${moduleData.news.nRegionInr === true ? `1` : `0`}`);
    lines.push(`EVT_1_nRegionJpy=${moduleData.news.nRegionJpy === true ? `1` : `0`}`);
    lines.push(`EVT_1_nRegionKrw=${moduleData.news.nRegionKrw === true ? `1` : `0`}`);
    lines.push(`EVT_1_nRegionMxn=${moduleData.news.nRegionMxn === true ? `1` : `0`}`);
    lines.push(`EVT_1_nRegionNok=${moduleData.news.nRegionNok === true ? `1` : `0`}`);
    lines.push(`EVT_1_nRegionNzd=${moduleData.news.nRegionNzd === true ? `1` : `0`}`);
    lines.push(`EVT_1_nRegionSek=${moduleData.news.nRegionSek === true ? `1` : `0`}`);
    lines.push(`EVT_1_nRegionSgd=${moduleData.news.nRegionSgd === true ? `1` : `0`}`);
    lines.push(`EVT_1_nRegionUsd=${moduleData.news.nRegionUsd === true ? `1` : `0`}`);
    lines.push(`EVT_1_nRegionZar=${moduleData.news.nRegionZar === true ? `1` : `0`}`);
    lines.push(`#`);
    lines.push(`EVT_1_nImportanceUndefined=${moduleData.news.nImportanceUndefined === true ? `1` : `0`}`);
    lines.push(`EVT_1_nImportanceLow=${moduleData.news.nImportanceLow === true ? `1` : `0`}`);
    lines.push(`EVT_1_nImportanceModerate=${moduleData.news.nImportanceModerate === true ? `1` : `0`}`);
    lines.push(`EVT_1_nImportanceHigh=${moduleData.news.nImportanceHigh === true ? `1` : `0`}`);
    lines.push(`#`);
    lines.push(`EVT_1_nImpactUndefined=${moduleData.news.nImpactUndefined === true ? `1` : `0`}`);
    lines.push(`EVT_1_nImpactPositive=${moduleData.news.nImpactPositive === true ? `1` : `0`}`);
    lines.push(`EVT_1_nImpactNegative=${moduleData.news.nImpactNegative === true ? `1` : `0`}`);
    lines.push(`#`);
    lines.push(`EVT_1_lActualMin=${moduleData.news.bActual ? formatTo8Digits(moduleData.news.lActualMin) : "0"}`);
    lines.push(`EVT_1_lActualMax=${moduleData.news.bActual ? formatTo8Digits(moduleData.news.lActualMax) : "0"}`);
    lines.push(`#`);
    lines.push(`EVT_1_lForecastMin=${moduleData.news.bForecast ? formatTo8Digits(moduleData.news.lForecastMin) : "0"}`);
    lines.push(`EVT_1_lForecastMax=${moduleData.news.bForecast ? formatTo8Digits(moduleData.news.lForecastMax) : "0"}`);
    lines.push(`#`);
    lines.push(`EVT_1_lPreviousMin=${moduleData.news.bPrevious ? formatTo8Digits(moduleData.news.lPreviousMin) : "0"}`);
    lines.push(`EVT_1_lPreviousMax=${moduleData.news.bPrevious ? formatTo8Digits(moduleData.news.lPreviousMax) : "0"}`);

    // ----------------------------------------------------------------------
    // EVT_1_FIL_Y
    // ----------------------------------------------------------------------
    if (moduleData.news.titleFilters !== undefined) {
      if(moduleData.news.titleFilters.length !== 0)
      {
        lines.push(`# +++++++++++++++++++++++++++++++++++++++++++++`);
        lines.push(`# Input group`);
        lines.push(`# +++++++++++++++++++++++++++++++++++++++++++++`);
      }
      moduleData.news.titleFilters.forEach((filter, index) => {
        lines.push(`EVT_1_FIL_${index + 1}_nFilterType=${filter.nFilterType}`);
        lines.push(`EVT_1_FIL_${index + 1}_strFilterString=${filter.strFilterString}`);
      });
    }

    // ----------------------------------------------------------------------
    // EVT_1_REL_Y
    // ----------------------------------------------------------------------
    if (moduleData.news.valueRelations !== undefined) {
      if(moduleData.news.valueRelations.length !== 0)
      {
        lines.push(`# +++++++++++++++++++++++++++++++++++++++++++++`);
        lines.push(`# Input group`);
        lines.push(`# +++++++++++++++++++++++++++++++++++++++++++++`);
      }
      moduleData.news.valueRelations.forEach((relation, index) => {
        lines.push(`EVT_1_REL_${index + 1}_nRelationCondition=${relation.nRelationCondition}`);
      });
    }

    // ----------------------------------------------------------------------
    // INOS_X
    // ----------------------------------------------------------------------
    if (moduleData.indicators !== undefined) {
      moduleData.indicators.forEach((indicator, index) => {
        lines.push(`# +++++++++++++++++++++++++++++++++++++++++++++`);
        lines.push(`# Input group`);
        lines.push(`# +++++++++++++++++++++++++++++++++++++++++++++`);
        const {config} = indicator;
        if (config === undefined || config === null) {
          return;
        }
        if (config.nSignalInUse === undefined || config.nSignalInUse === null) {
          return;
        }
        lines.push(`INOS_${index + 1}_nSignalInUse=${config.nSignalInUse === true ? `1` : `0`}`);
        lines.push(`INOS_${index + 1}_nSignalUsedFor=${config.nSignalUsedFor}`);
        lines.push(`INOS_${index + 1}_nSignalVisualization=${config.nSignalVisualization === true ? `1` : `0`}`);
        if (professionalMode) { lines.push(`INOS_${index + 1}_nDrawInChart=${config.nDrawInChart === true ? `1` : `0`}`) } else { lines.push(`INOS_${index + 1}_nDrawInChart=1`) };
        if (professionalMode) { lines.push(`INOS_${index + 1}_nDrawingSlot=${config.nDrawingSlot}`) } else { lines.push(`INOS_${index + 1}_nDrawingSlot=${index + 1}`) };
        if (professionalMode) { lines.push(`INOS_${index + 1}_nLogDrawingSlot=${config.nLogDrawingSlot === true ? `1` : `0`}`) } else { lines.push(`INOS_${index + 1}_nLogDrawingSlot=0`) };
        lines.push(`INOS_${index + 1}_nSelection=${config.nSelection}`);
        lines.push(`INOS_${index + 1}_strSymbol=${config.strSymbol === "Current" ? "CURRENT" : config.strSymbol}`);
        if (professionalMode) { lines.push(`INOS_${index + 1}_strExclusion=${config.strExclusion}`) };
        lines.push(`INOS_${index + 1}_nTimeframe=${config.nTimeframe}`);
        lines.push(`INOS_${index + 1}_nSeries=${config.nSeries}`);
        lines.push(`INOS_${index + 1}_nShift=${config.nShift}`);
        lines.push(`INOS_${index + 1}_nLineIndex=${config.nLineIndex}`);
        lines.push(`#`);
        lines.push(`INOS_${index + 1}_dParameter1=${formatTo8Digits(config.dParameter1)}`);
        lines.push(`INOS_${index + 1}_dParameter2=${formatTo8Digits(config.dParameter2)}`);
        lines.push(`INOS_${index + 1}_dParameter3=${formatTo8Digits(config.dParameter3)}`);
        lines.push(`INOS_${index + 1}_dParameter4=${formatTo8Digits(config.dParameter4)}`);
        lines.push(`INOS_${index + 1}_dParameter5=${formatTo8Digits(config.dParameter5)}`);
        lines.push(`INOS_${index + 1}_dParameter6=${formatTo8Digits(config.dParameter6)}`);
        lines.push(`INOS_${index + 1}_dParameter7=${formatTo8Digits(config.dParameter7)}`);
        lines.push(`INOS_${index + 1}_dParameter8=${formatTo8Digits(config.dParameter8)}`);
        lines.push(`INOS_${index + 1}_dParameter9=${formatTo8Digits(config.dParameter9)}`);
        lines.push(`INOS_${index + 1}_dParameter10=${formatTo8Digits(config.dParameter10)}`);
        lines.push(`INOS_${index + 1}_dParameter11=${formatTo8Digits(config.dParameter11)}`);
        lines.push(`INOS_${index + 1}_dParameter12=${formatTo8Digits(config.dParameter12)}`);
        lines.push(`INOS_${index + 1}_dParameter13=${formatTo8Digits(config.dParameter13)}`);
        lines.push(`INOS_${index + 1}_dParameter14=${formatTo8Digits(config.dParameter14)}`);
        lines.push(`INOS_${index + 1}_dParameter15=${formatTo8Digits(config.dParameter15)}`);
        lines.push(`INOS_${index + 1}_dParameter16=${formatTo8Digits(config.dParameter16)}`);
        lines.push(`INOS_${index + 1}_dParameter17=${formatTo8Digits(config.dParameter17)}`);
        lines.push(`INOS_${index + 1}_dParameter18=${formatTo8Digits(config.dParameter18)}`);
        lines.push(`INOS_${index + 1}_dParameter19=${formatTo8Digits(config.dParameter19)}`);
        lines.push(`INOS_${index + 1}_dParameter20=${formatTo8Digits(config.dParameter20)}`);
        lines.push(`INOS_${index + 1}_dParameter21=${formatTo8Digits(config.dParameter21)}`);
        lines.push(`INOS_${index + 1}_dParameter22=${formatTo8Digits(config.dParameter22)}`);
        lines.push(`INOS_${index + 1}_dParameter23=${formatTo8Digits(config.dParameter23)}`);
        lines.push(`INOS_${index + 1}_dParameter24=${formatTo8Digits(config.dParameter24)}`);
        lines.push(`INOS_${index + 1}_dParameter25=${formatTo8Digits(config.dParameter25)}`);
        lines.push(`INOS_${index + 1}_dParameter26=${formatTo8Digits(config.dParameter26)}`);
        lines.push(`INOS_${index + 1}_dParameter27=${formatTo8Digits(config.dParameter27)}`);
        lines.push(`INOS_${index + 1}_dParameter28=${formatTo8Digits(config.dParameter28)}`);
        lines.push(`INOS_${index + 1}_dParameter29=${formatTo8Digits(config.dParameter29)}`);
        lines.push(`INOS_${index + 1}_dParameter30=${formatTo8Digits(config.dParameter30)}`);
        lines.push(`INOS_${index + 1}_dParameter31=${formatTo8Digits(config.dParameter31)}`);
        lines.push(`INOS_${index + 1}_dParameter32=${formatTo8Digits(config.dParameter32)}`);
        lines.push(`#`);
        lines.push(`INOS_${index + 1}_strParameter1=${config.strParameter1}`);
        lines.push(`INOS_${index + 1}_strParameter2=${config.strParameter2}`);
        lines.push(`INOS_${index + 1}_strParameter3=${config.strParameter3}`);
        lines.push(`INOS_${index + 1}_strParameter4=${config.strParameter4}`);
        lines.push(`#`);
        lines.push(`INOS_${index + 1}_strMt4CustomPath=${config.strMt4CustomPath}`);
        lines.push(`INOS_${index + 1}_strMt5CustomPath=${config.strMt5CustomPath}`);
        lines.push(`#`);
        lines.push(`INOS_${index + 1}_nAngleCondition=${config.nAngleCondition}`);
        lines.push(`INOS_${index + 1}_dAngleLimit1=${formatTo8Digits(config.dAngleLimit1)}`);
        lines.push(`INOS_${index + 1}_dAngleLimit2=${formatTo8Digits(config.dAngleLimit2)}`);
        lines.push(`#`);
        lines.push(`INOS_${index + 1}_nValueCondition=${config.nValueCondition}`);
        lines.push(`INOS_${index + 1}_dValueLimit1=${formatTo8Digits(config.dValueLimit1)}`);
        lines.push(`INOS_${index + 1}_dValueLimit2=${formatTo8Digits(config.dValueLimit2)}`);
        if (professionalMode) { lines.push(`#`) };
        if (professionalMode) { lines.push(`INOS_${index + 1}_dForwardAdjustment=${formatTo8Digits(config.dForwardAdjustment)}`) };
        if (professionalMode) { lines.push(`INOS_${index + 1}_nValueAnalysisFeedbackState=${config.nValueAnalysisFeedbackState === true ? `1` : `0`}`) };
        if (professionalMode) { lines.push(`INOS_${index + 1}_nSignalAnalysisFeedbackState=${config.nSignalAnalysisFeedbackState === true ? `1` : `0`}`) };
      });
    }

    // ----------------------------------------------------------------------
    // RELIO_X
    // ----------------------------------------------------------------------
    if (moduleData.indicatorCombinations !== undefined) {
      moduleData.indicatorCombinations.forEach((relio, index) => {
        lines.push(`# +++++++++++++++++++++++++++++++++++++++++++++`);
        lines.push(`# Input group`);
        lines.push(`# +++++++++++++++++++++++++++++++++++++++++++++`);
        const {config} = relio;
        if (config === undefined || config === null) {
          return;
        }
        if (config.nSignalInUse === undefined || config.nSignalInUse === null) {
          return;
        }
        lines.push(`RELIO_${index + 1}_nSignalInUse=${config.nSignalInUse === true ? `1` : `0`}`);
        lines.push(`RELIO_${index + 1}_nSignalUsedFor=${config.nSignalUsedFor}`);
        lines.push(`RELIO_${index + 1}_nSignalVisualization=${config.nSignalVisualization === true ? `1` : `0`}`);
        lines.push(`RELIO_${index + 1}_nInputInos1=${config.nInputInos1 !== "0" ? indicatorIdToNumber[config.nInputInos1] : "0"}`);
        lines.push(`RELIO_${index + 1}_nInputInos2=${config.nInputInos2 !== "0" ? indicatorIdToNumber[config.nInputInos2] : "0"}`);
        if (professionalMode) { lines.push(`RELIO_${index + 1}_nSignalAnalysisFeedbackState=${config.nSignalAnalysisFeedbackState === true ? `1` : `0`}`) };
      });
    }

    // ----------------------------------------------------------------------
    // RELIO_X_SEL_Y
    // ----------------------------------------------------------------------
    if (moduleData.indicatorCombinations !== undefined) {
      moduleData.indicatorCombinations.forEach((relio, relioIndex) => {
        lines.push(`# +++++++++++++++++++++++++++++++++++++++++++++`);
        lines.push(`# Input group`);
        lines.push(`# +++++++++++++++++++++++++++++++++++++++++++++`);
        const {config} = relio;
        if (config === undefined || config === null) {
          return;
        }
        if (config.nRelation1 === undefined || config.nRelation1 === null) {
          return;
        }

        lines.push(`RELIO_${relioIndex + 1}_SEL_1_nRelation=${config.nRelation1}`);
        lines.push(`RELIO_${relioIndex + 1}_SEL_2_nRelation=${config.nRelation2}`);
      });
    }

    // ----------------------------------------------------------------------
    // CA_X
    // ----------------------------------------------------------------------
    if (moduleData.chartAnalyzers !== undefined) {
      moduleData.chartAnalyzers.forEach((ca, index) => {
        lines.push(`# +++++++++++++++++++++++++++++++++++++++++++++`);
        lines.push(`# Input group`);
        lines.push(`# +++++++++++++++++++++++++++++++++++++++++++++`);
        const {config} = ca;
        if (config === undefined || config === null) {
          return;
        }
        if (config.nSignalInUse === undefined || config.nSignalInUse === null) {
          return;
        }
        lines.push(`CA_${index + 1}_nSignalInUse=${config.nSignalInUse === true ? `1` : `0`}`);
        lines.push(`CA_${index + 1}_nSignalUsedFor=${config.nSignalUsedFor}`);
        lines.push(`CA_${index + 1}_nSignalVisualization=${config.nSignalVisualization === true ? `1` : `0`}`);
        lines.push(`CA_${index + 1}_strSymbol=${config.strSymbol === "Current" ? "CURRENT" : config.strSymbol}`);
        if (professionalMode) { lines.push(`CA_${index + 1}_strExclusion=${config.strExclusion}`) };
        lines.push(`CA_${index + 1}_nTimeframe=${config.nTimeframe}`);
        lines.push(`CA_${index + 1}_nShift=${config.nShift}`);
        lines.push(`#`);
        lines.push(`CA_${index + 1}_nWidth=${config.nWidth}`);
        lines.push(`CA_${index + 1}_dProminence=${formatTo8Digits(config.dProminence)}`);
        lines.push(`CA_${index + 1}_dBreakoutFactor=${formatTo8Digits(config.dBreakoutFactor)}`);
        if (professionalMode) { lines.push(`#`) };
        if (professionalMode) { lines.push(`CA_${index + 1}_nMidVolaMinSwings=${config.nMidVolaMinSwings}`) };
        if (professionalMode) { lines.push(`CA_${index + 1}_dMidVolaMinROC=${formatTo8Digits(config.dMidVolaMinROC)}`) };
        if (professionalMode) { lines.push(`CA_${index + 1}_dMidVolaMinFilled=${formatTo8Digits(config.dMidVolaMinFilled)}`) };
        if (professionalMode) { lines.push(`CA_${index + 1}_nHighVolaMinSwings=${config.nHighVolaMinSwings}`) };
        if (professionalMode) { lines.push(`CA_${index + 1}_dHighVolaMinROC=${formatTo8Digits(config.dHighVolaMinROC)}`) };
        if (professionalMode) { lines.push(`CA_${index + 1}_dHighVolaMinFilled=${formatTo8Digits(config.dHighVolaMinFilled)}`) };
        lines.push(`#`);
        lines.push(`CA_${index + 1}_nDrawBoundaries=${config.nDrawBoundaries === true ? `1` : `0`}`);
        lines.push(`CA_${index + 1}_nDrawExtrema=${config.nDrawExtrema === true ? `1` : `0`}`);
        lines.push(`CA_${index + 1}_nDrawSupRes=${config.nDrawSupRes === true ? `1` : `0`}`);
        lines.push(`CA_${index + 1}_nDrawSwingPhase=${config.nDrawSwingPhase === true ? `1` : `0`}`);
        if (professionalMode) { lines.push(`#`) };
        if (professionalMode) { lines.push(`CA_${index + 1}_strSupResForward=${config.strSupResForward}`) };
        if (professionalMode) { lines.push(`CA_${index + 1}_dSupportMultiplier=${formatTo8Digits(config.dSupportMultiplier)}`) };
        if (professionalMode) { lines.push(`CA_${index + 1}_dResistanceMultiplier=${formatTo8Digits(config.dResistanceMultiplier)}`) };
        if (professionalMode) { lines.push(`#`) };
        if (professionalMode) { lines.push(`CA_${index + 1}_dRegressionAnglesMin=${formatTo8Digits(config.dRegressionAnglesMin)}`) };
        if (professionalMode) { lines.push(`CA_${index + 1}_dRegressionAnglesMax=${formatTo8Digits(config.dRegressionAnglesMax)}`) };
        lines.push(`#`);
        lines.push(`CA_${index + 1}_nTradeVolatilityLow=${config.nTradeVolatilityLow === true ? `1` : `0`}`);
        lines.push(`CA_${index + 1}_nTradeVolatilityMiddle=${config.nTradeVolatilityMiddle === true ? `1` : `0`}`);
        lines.push(`CA_${index + 1}_nTradeVolatilityHigh=${config.nTradeVolatilityHigh === true ? `1` : `0`}`);
        lines.push(`#`);
        lines.push(`CA_${index + 1}_nTradeSwingPhaseOverstatement=${config.nTradeSwingPhaseOverstatement === true ? `1` : `0`}`);
        lines.push(`CA_${index + 1}_nTradeSwingPhaseUnderstatement=${config.nTradeSwingPhaseUnderstatement === true ? `1` : `0`}`);
        lines.push(`CA_${index + 1}_nTradeSwingPhaseOverCorrection=${config.nTradeSwingPhaseOverCorrection === true ? `1` : `0`}`);
        lines.push(`CA_${index + 1}_nTradeSwingPhaseUnderCorrection=${config.nTradeSwingPhaseUnderCorrection === true ? `1` : `0`}`);
        lines.push(`CA_${index + 1}_nTradeSwingPhaseUpswing=${config.nTradeSwingPhaseUpswing === true ? `1` : `0`}`);
        lines.push(`CA_${index + 1}_nTradeSwingPhaseDownswing=${config.nTradeSwingPhaseDownswing === true ? `1` : `0`}`);
        lines.push(`CA_${index + 1}_nTradeSwingPhaseUndefined=${config.nTradeSwingPhaseUndefined === true ? `1` : `0`}`);
        lines.push(`#`);
        lines.push(`CA_${index + 1}_dCurrentSwingAngleMin=${formatTo8Digits(config.dCurrentSwingAngleMin)}`);
        lines.push(`CA_${index + 1}_dCurrentSwingAngleMax=${formatTo8Digits(config.dCurrentSwingAngleMax)}`);
        lines.push(`#`);
        lines.push(`CA_${index + 1}_dCurrentSwingPosMin=${formatTo8Digits(config.dCurrentSwingPosMin)}`);
        lines.push(`CA_${index + 1}_dCurrentSwingPosMax=${formatTo8Digits(config.dCurrentSwingPosMax)}`);
        if (professionalMode) { lines.push(`#`) };
        if (professionalMode) { lines.push(`CA_${index + 1}_nValueAnalysisFeedbackState=${config.nValueAnalysisFeedbackState === true ? `1` : `0`}`) };
        if (professionalMode) { lines.push(`CA_${index + 1}_nSignalAnalysisFeedbackState=${config.nSignalAnalysisFeedbackState === true ? `1` : `0`}`) };
      });
    }

    // ----------------------------------------------------------------------
    // CA_X_SWING_Y
    // ----------------------------------------------------------------------
    if (moduleData.chartAnalyzers !== undefined) {
      moduleData.chartAnalyzers.forEach((chartAnalayzer, caIndex) => {
        if (chartAnalayzer.config === null || chartAnalayzer.config === undefined) {
          return;
        }
        if (chartAnalayzer.config.swingConfigurations !== undefined) {
          chartAnalayzer.config.swingConfigurations.forEach((swing, swingIndex) => {
            lines.push(`# +++++++++++++++++++++++++++++++++++++++++++++`);
            lines.push(`# Input group`);
            lines.push(`# +++++++++++++++++++++++++++++++++++++++++++++`);
            lines.push(`CA_${caIndex + 1}_SWING_${swingIndex + 1}_nNumber=${swing.nNumber}`);
            lines.push(`#`);
            lines.push(`CA_${caIndex + 1}_SWING_${swingIndex + 1}_dHeightMax=${formatTo8Digits(swing.dHeightMax)}`);
            lines.push(`CA_${caIndex + 1}_SWING_${swingIndex + 1}_dHeightMin=${formatTo8Digits(swing.dHeightMin)}`);
            lines.push(`#`);
            lines.push(`CA_${caIndex + 1}_SWING_${swingIndex + 1}_dWidthMax=${formatTo8Digits(swing.dWidthMax)}`);
            lines.push(`CA_${caIndex + 1}_SWING_${swingIndex + 1}_dWidthMin=${formatTo8Digits(swing.dWidthMin)}`);
            lines.push(`#`);
            lines.push(`CA_${caIndex + 1}_SWING_${swingIndex + 1}_dRangeHeightMax=${formatTo8Digits(swing.dRangeHeightMax)}`);
            lines.push(`CA_${caIndex + 1}_SWING_${swingIndex + 1}_dRangeHeightMin=${formatTo8Digits(swing.dRangeHeightMin)}`);
            lines.push(`#`);
            lines.push(`CA_${caIndex + 1}_SWING_${swingIndex + 1}_dRangeWidthMax=${formatTo8Digits(swing.dRangeWidthMax)}`);
            lines.push(`CA_${caIndex + 1}_SWING_${swingIndex + 1}_dRangeWidthMin=${formatTo8Digits(swing.dRangeWidthMin)}`);
            lines.push(`#`);
            lines.push(`CA_${caIndex + 1}_SWING_${swingIndex + 1}_dRangeUpperPointMax=${formatTo8Digits(swing.dRangeUpperPointMax)}`);
            lines.push(`CA_${caIndex + 1}_SWING_${swingIndex + 1}_dRangeUpperPointMin=${formatTo8Digits(swing.dRangeUpperPointMin)}`);
            lines.push(`#`);
            lines.push(`CA_${caIndex + 1}_SWING_${swingIndex + 1}_dRangeLowerPointMax=${formatTo8Digits(swing.dRangeLowerPointMax)}`);
            lines.push(`CA_${caIndex + 1}_SWING_${swingIndex + 1}_dRangeLowerPointMin=${formatTo8Digits(swing.dRangeLowerPointMin)}`);
            lines.push(`#`);
            lines.push(`CA_${caIndex + 1}_SWING_${swingIndex + 1}_dRangeLeftPointMax=${formatTo8Digits(swing.dRangeLeftPointMax)}`);
            lines.push(`CA_${caIndex + 1}_SWING_${swingIndex + 1}_dRangeLeftPointMin=${formatTo8Digits(swing.dRangeLeftPointMin)}`);
            lines.push(`#`);
            lines.push(`CA_${caIndex + 1}_SWING_${swingIndex + 1}_dRangeRightPointMax=${formatTo8Digits(swing.dRangeRightPointMax)}`);
            lines.push(`CA_${caIndex + 1}_SWING_${swingIndex + 1}_dRangeRightPointMin=${formatTo8Digits(swing.dRangeRightPointMin)}`);
          });
        }
      });
    }

    // ----------------------------------------------------------------------
    // CAS_1
    // ----------------------------------------------------------------------
    if (moduleData.candlePatterns !== undefined) {
      lines.push(`# +++++++++++++++++++++++++++++++++++++++++++++`);
      lines.push(`# Input group`);
      lines.push(`# +++++++++++++++++++++++++++++++++++++++++++++`);
      lines.push(`CAS_1_nSignalInUse=${moduleData.candlePatterns.nSignalInUse === true ? `1` : `0`}`);
      lines.push(`CAS_1_nSignalUsedFor=${moduleData.candlePatterns.nSignalUsedFor}`);
      lines.push(`CAS_1_nSignalVisualization=${moduleData.candlePatterns.nSignalVisualization === true ? `1` : `0`}`);
      lines.push(`CAS_1_nLogResults=${moduleData.candlePatterns.nLogResults === true ? `1` : `0`}`);
      lines.push(`CAS_1_nDrawResults=${moduleData.candlePatterns.nDrawResults === true ? `1` : `0`}`);
      lines.push(`CAS_1_strSymbol=${moduleData.candlePatterns.strSymbol === "Current" ? "CURRENT" : moduleData.candlePatterns.strSymbol}`);
      if (professionalMode) { lines.push(`CAS_1_strExclusion=${moduleData.candlePatterns.strExclusion}`) };
      lines.push(`CAS_1_nTimeframe=${moduleData.candlePatterns.nTimeframe}`);
      lines.push(`CAS_1_nShift=${moduleData.candlePatterns.nShift}`);
      if (professionalMode) { lines.push(`CAS_1_dStopLossForwardAdjustment=${formatTo8Digits(moduleData.candlePatterns.dStopLossForwardAdjustment)}`) };
      if (professionalMode) { lines.push(`CAS_1_dTakeProfitForwardAdjustment=${formatTo8Digits(moduleData.candlePatterns.dTakeProfitForwardAdjustment)}`) };
    }

    // ----------------------------------------------------------------------
    // CAS_1_SEL_Y
    // ----------------------------------------------------------------------
    if (moduleData.candlePatterns !== undefined) {
      lines.push(`# +++++++++++++++++++++++++++++++++++++++++++++`);
      lines.push(`# Input group`);
      lines.push(`# +++++++++++++++++++++++++++++++++++++++++++++`);
      for (let i = 0; i <= 23; i += 1) {
        if (moduleData.candlePatterns[`pattern_${i}`] !== undefined && moduleData.candlePatterns[`pattern_${i}`] !== null) {
          lines.push(`CAS_1_SEL_${i + 1}_nPattern=${moduleData.candlePatterns[`pattern_${i}`] === true ? i : `-2`}`);
        }
      }
    }

    // ----------------------------------------------------------------------
    // PAS_1
    // ----------------------------------------------------------------------
    if (moduleData.chartPatterns !== undefined) {
      lines.push(`# +++++++++++++++++++++++++++++++++++++++++++++`);
      lines.push(`# Input group`);
      lines.push(`# +++++++++++++++++++++++++++++++++++++++++++++`);
      lines.push(`PAS_1_nSignalInUse=${moduleData.chartPatterns.nSignalInUse === true ? `1` : `0`}`);
      lines.push(`PAS_1_nSignalUsedFor=${moduleData.chartPatterns.nSignalUsedFor}`);
      lines.push(`PAS_1_nSignalVisualization=${moduleData.chartPatterns.nSignalVisualization === true ? `1` : `0`}`);
      lines.push(`PAS_1_nLogResults=${moduleData.chartPatterns.nLogResults === true ? `1` : `0`}`);
      lines.push(`PAS_1_nDrawResults=${moduleData.chartPatterns.nDrawResults === true ? `1` : `0`}`);
      lines.push(`PAS_1_strSymbol=${moduleData.chartPatterns.strSymbol === "Current" ? "CURRENT" : moduleData.chartPatterns.strSymbol}`);
      if (professionalMode) { lines.push(`PAS_1_strExclusion=${moduleData.chartPatterns.strExclusion}`) };
      lines.push(`PAS_1_nTimeframe=${moduleData.chartPatterns.nTimeframe}`);
      lines.push(`PAS_1_nShift=${moduleData.chartPatterns.nShift}`);
      if (professionalMode) { lines.push(`PAS_1_dStopLossForwardAdjustment=${formatTo8Digits(moduleData.chartPatterns.dStopLossForwardAdjustment)}`) };
      if (professionalMode) { lines.push(`PAS_1_dTakeProfitForwardAdjustment=${formatTo8Digits(moduleData.chartPatterns.dTakeProfitForwardAdjustment)}`) };
    }

    // ----------------------------------------------------------------------
    // PAS_1_SEL_Y
    // ----------------------------------------------------------------------
    if (moduleData.chartPatterns !== undefined) {
      lines.push(`# +++++++++++++++++++++++++++++++++++++++++++++`);
      lines.push(`# Input group`);
      lines.push(`# +++++++++++++++++++++++++++++++++++++++++++++`);
      for (let i = 0; i <= 17; i += 1) {
        if (moduleData.chartPatterns[`pattern_${i}`] !== undefined && moduleData.chartPatterns[`pattern_${i}`] !== null) {
          lines.push(`PAS_1_SEL_${i + 1}_nPattern=${moduleData.chartPatterns[`pattern_${i}`] === true ? i : `-2`}`);
        }
      }
    }

    // ----------------------------------------------------------------------
    // FIS_1
    // ----------------------------------------------------------------------
    if (moduleData.fibonacciPatterns !== undefined) {
      lines.push(`# +++++++++++++++++++++++++++++++++++++++++++++`);
      lines.push(`# Input group`);
      lines.push(`# +++++++++++++++++++++++++++++++++++++++++++++`);
      lines.push(`FIS_1_nSignalInUse=${moduleData.fibonacciPatterns.nSignalInUse === true ? `1` : `0`}`);
      lines.push(`FIS_1_nSignalUsedFor=${moduleData.fibonacciPatterns.nSignalUsedFor}`);
      lines.push(`FIS_1_nSignalVisualization=${moduleData.fibonacciPatterns.nSignalVisualization === true ? `1` : `0`}`);
      lines.push(`FIS_1_nLogResults=${moduleData.fibonacciPatterns.nLogResults === true ? `1` : `0`}`);
      lines.push(`FIS_1_nDrawResults=${moduleData.fibonacciPatterns.nDrawResults === true ? `1` : `0`}`);
      lines.push(`FIS_1_strSymbol=${moduleData.fibonacciPatterns.strSymbol === "Current" ? "CURRENT" : moduleData.fibonacciPatterns.strSymbol}`);
      if (professionalMode) { lines.push(`FIS_1_strExclusion=${moduleData.fibonacciPatterns.strExclusion}`) };
      lines.push(`FIS_1_nTimeframe=${moduleData.fibonacciPatterns.nTimeframe}`);
      lines.push(`FIS_1_nShift=${moduleData.fibonacciPatterns.nShift}`);
      if (professionalMode) { lines.push(`FIS_1_dStopLossForwardAdjustment=${formatTo8Digits(moduleData.fibonacciPatterns.dStopLossForwardAdjustment)}`) };
      if (professionalMode) { lines.push(`FIS_1_dTakeProfitForwardAdjustment=${formatTo8Digits(moduleData.fibonacciPatterns.dTakeProfitForwardAdjustment)}`) };
    }

    // ----------------------------------------------------------------------
    // FIS_1_SEL_Y
    // ----------------------------------------------------------------------
    if (moduleData.fibonacciPatterns !== undefined) {
      lines.push(`# +++++++++++++++++++++++++++++++++++++++++++++`);
      lines.push(`# Input group`);
      lines.push(`# +++++++++++++++++++++++++++++++++++++++++++++`);
      for (let i = 0; i <= 1; i += 1) {
        if (moduleData.fibonacciPatterns[`pattern_${i}`] !== undefined && moduleData.fibonacciPatterns[`pattern_${i}`] !== null) {
          lines.push(`FIS_1_SEL_${i + 1}_nPattern=${moduleData.fibonacciPatterns[`pattern_${i}`] === true ? i : `-2`}`);
        }
      }
    }

    // ----------------------------------------------------------------------
    // AUTOMATICALLY GENERATED DATA FOR EXPERT ADVISOR BUILDER
    // ----------------------------------------------------------------------
    lines.push(`# +++++++++++++++++++++++++++++++++++++++++++++`);
    lines.push(`# START OF AUTOMATICALLY GENERATED DATA FOR EXPERT ADVISOR BUILDER`);
    lines.push(`# DO NOT EDIT THE VALUES IN THIS SECTION`);
    lines.push(`# +++++++++++++++++++++++++++++++++++++++++++++`);

    // ----------------------------------------------------------------------
    // MTA_1
    // ----------------------------------------------------------------------
    lines.push(`# MTA_1_nModuleId=${moduleData.moduleId}`);
    lines.push(`# MTA_1_strModuleName=${moduleData.moduleName}`);
    lines.push(`# MTA_1_nNumber=${moduleData.basics.nNumber}`);
    lines.push(`# MTA_1_nTradingState=${moduleData.basics.nTradingState}`);

    // ----------------------------------------------------------------------
    // RIM_1
    // ----------------------------------------------------------------------
    if (moduleData.volumeCalculation === undefined) {
      return;
    }
    lines.push(`# RIM_1_bMaxSpread=${moduleData.volumeCalculation.bMaxSpread === true ? `1` : `0`}`);
    lines.push(`# RIM_1_nMaxSpread=${moduleData.volumeCalculation.nMaxSpread}`);
    if (!professionalMode) { lines.push(`# RIM_1_nMaxSpread=${moduleData.volumeCalculation.bMaxSpread ? moduleData.volumeCalculation.nMaxSpread : "0"}`) };
    if (!professionalMode) { lines.push(`# RIM_1_nInosUsedForValueInjection=${moduleData.volumeCalculation.nInosUsedForValueInjection !== "0" ? indicatorIdToNumber[moduleData.volumeCalculation.nInosUsedForValueInjection] : "0"}`) };
    if (!professionalMode) { lines.push(`# RIM_1_dCommissionPerLot=${formatTo8Digits(moduleData.volumeCalculation.dCommissionPerLot)}`) };

    // ----------------------------------------------------------------------
    // STF_1
    // ----------------------------------------------------------------------

    // ----------------------------------------------------------------------
    // STF_1_SMP_Y
    // ----------------------------------------------------------------------

    // ----------------------------------------------------------------------
    // ORM_1
    // ----------------------------------------------------------------------
    if (moduleData.tradeBasics === undefined || moduleData.notifications === undefined || moduleData.miscellaneous === undefined) {
      return;
    }
    if (!professionalMode) { lines.push(`# ORM_1_nSignalLogic=${moduleData.tradeBasics.nSignalLogic}`) };
    if (!professionalMode) { lines.push(`# ORM_1_strExclusion=${moduleData.tradeBasics.strExclusion}`) };
    if (!professionalMode) { lines.push(`# ORM_1_nTimeframe=${moduleData.tradeBasics.nTimeframe}`) };
    if (!professionalMode) { lines.push(`# ORM_1_nMaxSlippage=${moduleData.tradeBasics.nMaxSlippage}`) };
    if (!professionalMode) { lines.push(`# ORM_1_nLocalLimits=${moduleData.tradeBasics.nLocalLimits === true ? `1` : `0`}`) };
    if (!professionalMode) { lines.push(`# ORM_1_nLocalPending=${moduleData.pendingOrderSettings.nLocalPending === true ? `1` : `0`}`) };

    // ----------------------------------------------------------------------
    // ISL_1
    // ----------------------------------------------------------------------
    if (moduleData.initialStopLoss === undefined) {
      return;
    }
    lines.push(`# ISL_1_bFixPipsMin=${moduleData.initialStopLoss.bFixPipsMin === true ? `1` : `0`}`);
    lines.push(`# ISL_1_nFixPipsMin=${moduleData.initialStopLoss.nFixPipsMin}`);
    lines.push(`# ISL_1_bFixPipsMax=${moduleData.initialStopLoss.bFixPipsMax === true ? `1` : `0`}`);
    lines.push(`# ISL_1_nFixPipsMax=${moduleData.initialStopLoss.nFixPipsMax}`);
    lines.push(`# ISL_1_bRateOfChangeMin=${moduleData.initialStopLoss.bRateOfChangeMin === true ? `1` : `0`}`);
    lines.push(`# ISL_1_dRateOfChangeMin=${formatTo8Digits(moduleData.initialStopLoss.dRateOfChangeMin)}`);
    lines.push(`# ISL_1_bRateOfChangeMax=${moduleData.initialStopLoss.bRateOfChangeMax === true ? `1` : `0`}`);
    lines.push(`# ISL_1_dRateOfChangeMax=${formatTo8Digits(moduleData.initialStopLoss.dRateOfChangeMax)}`);
    if (!professionalMode) { lines.push(`# ISL_1_nInosUsedForValueInjection=${moduleData.initialStopLoss.nInosUsedForValueInjection !== "0" ? indicatorIdToNumber[moduleData.initialStopLoss.nInosUsedForValueInjection] : "0"}`) };
    if (!professionalMode) { lines.push(`# ISL_1_nCaSupResUsedForValueInjection=${moduleData.initialStopLoss.nCaSupResUsedForValueInjection !== "0" ? chartAnalyzerIdToNumber[moduleData.initialStopLoss.nCaSupResUsedForValueInjection] : "0"}`) };

    // ----------------------------------------------------------------------
    // SLT_X
    // ----------------------------------------------------------------------
    if (moduleData.stopLossTrailings !== undefined) {
      // Create temporary sorted array based on nChangePosition (smaller items first)
      const tempSortedData = moduleData.stopLossTrailings
        .slice()
        .sort((a, b) => {
          const aChangePos = a.config?.nChangePosition || 0;
          const bChangePos = b.config?.nChangePosition || 0;
          return aChangePos - bChangePos;
        });

      tempSortedData.forEach((stopLossTrailing, index) => {
        if (stopLossTrailing.config !== null && stopLossTrailing.config !== undefined) {
          lines.push(`# SLT_${index + 1}_nId=${stopLossTrailing.id}`);
          lines.push(`# SLT_${index + 1}_bCaSupResFixPipsMin=${stopLossTrailing.config.bCaSupResFixPipsMin === true ? `1` : `0`}`);
          lines.push(`# SLT_${index + 1}_nCaSupResFixPipsMin=${stopLossTrailing.config.nCaSupResFixPipsMin}`);
          lines.push(`# SLT_${index + 1}_bCaSupResFixPipsMax=${stopLossTrailing.config.bCaSupResFixPipsMax === true ? `1` : `0`}`);
          lines.push(`# SLT_${index + 1}_nCaSupResFixPipsMax=${stopLossTrailing.config.nCaSupResFixPipsMax}`);
          lines.push(`# SLT_${index + 1}_bCaSupResRateOfChangeMin=${stopLossTrailing.config.bCaSupResRateOfChangeMin === true ? `1` : `0`}`);
          lines.push(`# SLT_${index + 1}_dCaSupResRateOfChangeMin=${formatTo8Digits(stopLossTrailing.config.dCaSupResRateOfChangeMin)}`);
          lines.push(`# SLT_${index + 1}_bCaSupResRateOfChangeMax=${stopLossTrailing.config.bCaSupResRateOfChangeMax === true ? `1` : `0`}`);
          lines.push(`# SLT_${index + 1}_dCaSupResRateOfChangeMax=${formatTo8Digits(stopLossTrailing.config.dCaSupResRateOfChangeMax)}`);
          if (!professionalMode) { lines.push(`# SLT_${index + 1}_nInosUsedForValueInjection=${stopLossTrailing.config.nInosUsedForValueInjection !== "0" ? indicatorIdToNumber[stopLossTrailing.config.nInosUsedForValueInjection] : "0"}`) };
          if (!professionalMode) { lines.push(`# SLT_${index + 1}_nCaSupResUsedForValueInjection=${stopLossTrailing.config.nCaSupResUsedForValueInjection !== "0" ? chartAnalyzerIdToNumber[stopLossTrailing.config.nCaSupResUsedForValueInjection] : "0"}`) };
        }
      });
    }

    // ----------------------------------------------------------------------
    // ITP_1
    // ----------------------------------------------------------------------
    if (moduleData.initialTakeProfit === undefined) {
      return;
    }
    lines.push(`# ITP_1_bFixPipsMin=${moduleData.initialTakeProfit.bFixPipsMin === true ? `1` : `0`}`);
    lines.push(`# ITP_1_nFixPipsMin=${moduleData.initialTakeProfit.nFixPipsMin}`);
    lines.push(`# ITP_1_bFixPipsMax=${moduleData.initialTakeProfit.bFixPipsMax === true ? `1` : `0`}`);
    lines.push(`# ITP_1_nFixPipsMax=${moduleData.initialTakeProfit.nFixPipsMax}`);
    lines.push(`# ITP_1_bRateOfChangeMin=${moduleData.initialTakeProfit.bRateOfChangeMin === true ? `1` : `0`}`);
    lines.push(`# ITP_1_dRateOfChangeMin=${formatTo8Digits(moduleData.initialTakeProfit.dRateOfChangeMin)}`);
    lines.push(`# ITP_1_bRateOfChangeMax=${moduleData.initialTakeProfit.bRateOfChangeMax === true ? `1` : `0`}`);
    lines.push(`# ITP_1_dRateOfChangeMax=${formatTo8Digits(moduleData.initialTakeProfit.dRateOfChangeMax)}`);
    if (!professionalMode) { lines.push(`# ITP_1_nInosUsedForValueInjection=${moduleData.initialTakeProfit.nInosUsedForValueInjection !== "0" ? indicatorIdToNumber[moduleData.initialTakeProfit.nInosUsedForValueInjection] : "0"}`) };
    if (!professionalMode) { lines.push(`# ITP_1_nCaSupResUsedForValueInjection=${moduleData.initialTakeProfit.nCaSupResUsedForValueInjection !== "0" ? chartAnalyzerIdToNumber[moduleData.initialTakeProfit.nCaSupResUsedForValueInjection] : "0"}`) };

    // ----------------------------------------------------------------------
    // TPD_X
    // ----------------------------------------------------------------------
    if (moduleData.takeProfitDynamics !== undefined) {
      // Create temporary sorted array based on nChangePosition (smaller items first)
      const tempSortedData = moduleData.takeProfitDynamics
        .slice()
        .sort((a, b) => {
          const aChangePos = a.config?.nChangePosition || 0;
          const bChangePos = b.config?.nChangePosition || 0;
          return aChangePos - bChangePos;
        });

      tempSortedData.forEach((takeProfitDynamic, index) => {
        if (takeProfitDynamic.config !== null && takeProfitDynamic.config !== undefined) {
          lines.push(`# TPD_${index + 1}_nId=${takeProfitDynamic.id}`);
          if (!professionalMode) { lines.push(`# TPD_${index + 1}_nMarketBarsMax=${takeProfitDynamic.config.nMarketBarsMax}`) };
          if (!professionalMode) { lines.push(`# TPD_${index + 1}_nMarketM1=${takeProfitDynamic.config.nMarketM1}`) };
          if (!professionalMode) { lines.push(`# TPD_${index + 1}_nMarketM2=${takeProfitDynamic.config.nMarketM2}`) };
          if (!professionalMode) { lines.push(`# TPD_${index + 1}_nMarketEnd=${takeProfitDynamic.config.nMarketEnd}`) };
          lines.push(`# TPD_${index + 1}_bCaSupResFixPipsMin=${takeProfitDynamic.config.bCaSupResFixPipsMin === true ? `1` : `0`}`);
          lines.push(`# TPD_${index + 1}_nCaSupResFixPipsMin=${takeProfitDynamic.config.nCaSupResFixPipsMin}`);
          lines.push(`# TPD_${index + 1}_bCaSupResFixPipsMax=${takeProfitDynamic.config.bCaSupResFixPipsMax === true ? `1` : `0`}`);
          lines.push(`# TPD_${index + 1}_nCaSupResFixPipsMax=${takeProfitDynamic.config.nCaSupResFixPipsMax}`);
          lines.push(`# TPD_${index + 1}_bCaSupResRateOfChangeMin=${takeProfitDynamic.config.bCaSupResRateOfChangeMin === true ? `1` : `0`}`);
          lines.push(`# TPD_${index + 1}_dCaSupResRateOfChangeMin=${formatTo8Digits(takeProfitDynamic.config.dCaSupResRateOfChangeMin)}`);
          lines.push(`# TPD_${index + 1}_bCaSupResRateOfChangeMax=${takeProfitDynamic.config.bCaSupResRateOfChangeMax === true ? `1` : `0`}`);
          lines.push(`# TPD_${index + 1}_dCaSupResRateOfChangeMax=${formatTo8Digits(takeProfitDynamic.config.dCaSupResRateOfChangeMax)}`);
          if (!professionalMode) { lines.push(`# TPD_${index + 1}_nInosUsedForValueInjection=${takeProfitDynamic.config.nInosUsedForValueInjection !== "0" ? indicatorIdToNumber[takeProfitDynamic.config.nInosUsedForValueInjection] : "0"}`) };
          if (!professionalMode) { lines.push(`# TPD_${index + 1}_nCaSupResUsedForValueInjection=${takeProfitDynamic.config.nCaSupResUsedForValueInjection !== "0" ? chartAnalyzerIdToNumber[takeProfitDynamic.config.nCaSupResUsedForValueInjection] : "0"}`) };
        }
      });
    }

    // ----------------------------------------------------------------------
    // PEO_1
    // ----------------------------------------------------------------------
    if (moduleData.pendingOrderSettings === undefined) {
      return;
    }
    lines.push(`# PEO_1_bHysteresisMin=${moduleData.pendingOrderSettings.bHysteresisMin === true ? `1` : `0`}`);
    lines.push(`# PEO_1_nHysteresisMin=${moduleData.pendingOrderSettings.nHysteresisMin}`);
    lines.push(`# PEO_1_bHysteresisMax=${moduleData.pendingOrderSettings.bHysteresisMax === true ? `1` : `0`}`);
    lines.push(`# PEO_1_nHysteresisMax=${moduleData.pendingOrderSettings.nHysteresisMax}`);
    lines.push(`# PEO_1_bFixPipsMin=${moduleData.pendingOrderSettings.bFixPipsMin === true ? `1` : `0`}`);
    lines.push(`# PEO_1_nFixPipsMin=${moduleData.pendingOrderSettings.nFixPipsMin}`);
    lines.push(`# PEO_1_bFixPipsMax=${moduleData.pendingOrderSettings.bFixPipsMax === true ? `1` : `0`}`);
    lines.push(`# PEO_1_nFixPipsMax=${moduleData.pendingOrderSettings.nFixPipsMax}`);
    lines.push(`# PEO_1_bRateOfChangeMin=${moduleData.pendingOrderSettings.bRateOfChangeMin === true ? `1` : `0`}`);
    lines.push(`# PEO_1_dRateOfChangeMin=${formatTo8Digits(moduleData.pendingOrderSettings.dRateOfChangeMin)}`);
    lines.push(`# PEO_1_bRateOfChangeMax=${moduleData.pendingOrderSettings.bRateOfChangeMax === true ? `1` : `0`}`);
    lines.push(`# PEO_1_dRateOfChangeMax=${formatTo8Digits(moduleData.pendingOrderSettings.dRateOfChangeMax)}`);
    if (!professionalMode) { lines.push(`# PEO_1_nReference=${moduleData.pendingOrderSettings.nReference}`) };
    if (!professionalMode) { lines.push(`# PEO_1_nHysteresisMin=${moduleData.pendingOrderSettings.bHysteresisMin ? moduleData.pendingOrderSettings.nHysteresisMin : "0"}`) };
    if (!professionalMode) { lines.push(`# PEO_1_nHysteresisMax=${moduleData.pendingOrderSettings.bHysteresisMax ? moduleData.pendingOrderSettings.nHysteresisMax : "0"}`) };
    if (!professionalMode) { lines.push(`# PEO_1_nFixPipsMin=${moduleData.pendingOrderSettings.bFixPipsMin ? moduleData.pendingOrderSettings.nFixPipsMin : "0"}`) };
    if (!professionalMode) { lines.push(`# PEO_1_nFixPipsMax=${moduleData.pendingOrderSettings.bFixPipsMax ? moduleData.pendingOrderSettings.nFixPipsMax : "0"}`) };
    if (!professionalMode) { lines.push(`# PEO_1_dRateOfChangeMin=${moduleData.pendingOrderSettings.bRateOfChangeMin ? formatTo8Digits(moduleData.pendingOrderSettings.dRateOfChangeMin) : "0.0"}`) };
    if (!professionalMode) { lines.push(`# PEO_1_dRateOfChangeMax=${moduleData.pendingOrderSettings.bRateOfChangeMax ? formatTo8Digits(moduleData.pendingOrderSettings.dRateOfChangeMax) : "0.0"}`) };
    if (!professionalMode) { lines.push(`# PEO_1_nInosUsedForValueInjection=${moduleData.pendingOrderSettings.nInosUsedForValueInjection !== "0" ? indicatorIdToNumber[moduleData.pendingOrderSettings.nInosUsedForValueInjection] : "0"}`) };
    if (!professionalMode) { lines.push(`# PEO_1_nCaSupResUsedForValueInjection=${moduleData.pendingOrderSettings.nCaSupResUsedForValueInjection !== "0" ? chartAnalyzerIdToNumber[moduleData.pendingOrderSettings.nCaSupResUsedForValueInjection] : "0"}`) };

    // ----------------------------------------------------------------------
    // ISP_1
    // ----------------------------------------------------------------------
    if (moduleData.monitoring === undefined) {
      return;
    }
    lines.push(`# ISP_1_bPerformanceDayAbsMin=${moduleData.monitoring.bPerformanceDayAbsMin === true ? `1` : `0`}`);
    lines.push(`# ISP_1_dPerformanceDayAbsMin=${formatTo8Digits(moduleData.monitoring.dPerformanceDayAbsMin)}`);
    lines.push(`# ISP_1_bPerformanceDayAbsMax=${moduleData.monitoring.bPerformanceDayAbsMax === true ? `1` : `0`}`);
    lines.push(`# ISP_1_dPerformanceDayAbsMax=${formatTo8Digits(moduleData.monitoring.dPerformanceDayAbsMax)}`);
    lines.push(`# ISP_1_bPerformanceDayRelMin=${moduleData.monitoring.bPerformanceDayRelMin === true ? `1` : `0`}`);
    lines.push(`# ISP_1_dPerformanceDayRelMin=${formatTo8Digits(moduleData.monitoring.dPerformanceDayRelMin)}`);
    lines.push(`# ISP_1_bPerformanceDayRelMax=${moduleData.monitoring.bPerformanceDayRelMax === true ? `1` : `0`}`);
    lines.push(`# ISP_1_dPerformanceDayRelMax=${formatTo8Digits(moduleData.monitoring.dPerformanceDayRelMax)}`);
    lines.push(`# ISP_1_bPerformanceWeekAbsMin=${moduleData.monitoring.bPerformanceWeekAbsMin === true ? `1` : `0`}`);
    lines.push(`# ISP_1_dPerformanceWeekAbsMin=${formatTo8Digits(moduleData.monitoring.dPerformanceWeekAbsMin)}`);
    lines.push(`# ISP_1_bPerformanceWeekAbsMax=${moduleData.monitoring.bPerformanceWeekAbsMax === true ? `1` : `0`}`);
    lines.push(`# ISP_1_dPerformanceWeekAbsMax=${formatTo8Digits(moduleData.monitoring.dPerformanceWeekAbsMax)}`);
    lines.push(`# ISP_1_bPerformanceWeekRelMin=${moduleData.monitoring.bPerformanceWeekRelMin === true ? `1` : `0`}`);
    lines.push(`# ISP_1_dPerformanceWeekRelMin=${formatTo8Digits(moduleData.monitoring.dPerformanceWeekRelMin)}`);
    lines.push(`# ISP_1_bPerformanceWeekRelMax=${moduleData.monitoring.bPerformanceWeekRelMax === true ? `1` : `0`}`);
    lines.push(`# ISP_1_dPerformanceWeekRelMax=${formatTo8Digits(moduleData.monitoring.dPerformanceWeekRelMax)}`);
    lines.push(`# ISP_1_bPerformanceMonthAbsMin=${moduleData.monitoring.bPerformanceMonthAbsMin === true ? `1` : `0`}`);
    lines.push(`# ISP_1_dPerformanceMonthAbsMin=${formatTo8Digits(moduleData.monitoring.dPerformanceMonthAbsMin)}`);
    lines.push(`# ISP_1_bPerformanceMonthAbsMax=${moduleData.monitoring.bPerformanceMonthAbsMax === true ? `1` : `0`}`);
    lines.push(`# ISP_1_dPerformanceMonthAbsMax=${formatTo8Digits(moduleData.monitoring.dPerformanceMonthAbsMax)}`);
    lines.push(`# ISP_1_bPerformanceMonthRelMin=${moduleData.monitoring.bPerformanceMonthRelMin === true ? `1` : `0`}`);
    lines.push(`# ISP_1_dPerformanceMonthRelMin=${formatTo8Digits(moduleData.monitoring.dPerformanceMonthRelMin)}`);
    lines.push(`# ISP_1_bPerformanceMonthRelMax=${moduleData.monitoring.bPerformanceMonthRelMax === true ? `1` : `0`}`);
    lines.push(`# ISP_1_dPerformanceMonthRelMax=${formatTo8Digits(moduleData.monitoring.dPerformanceMonthRelMax)}`);
    lines.push(`# ISP_1_bPerformanceYearAbsMin=${moduleData.monitoring.bPerformanceYearAbsMin === true ? `1` : `0`}`);
    lines.push(`# ISP_1_dPerformanceYearAbsMin=${formatTo8Digits(moduleData.monitoring.dPerformanceYearAbsMin)}`);
    lines.push(`# ISP_1_bPerformanceYearAbsMax=${moduleData.monitoring.bPerformanceYearAbsMax === true ? `1` : `0`}`);
    lines.push(`# ISP_1_dPerformanceYearAbsMax=${formatTo8Digits(moduleData.monitoring.dPerformanceYearAbsMax)}`);
    lines.push(`# ISP_1_bPerformanceYearRelMin=${moduleData.monitoring.bPerformanceYearRelMin === true ? `1` : `0`}`);
    lines.push(`# ISP_1_dPerformanceYearRelMin=${formatTo8Digits(moduleData.monitoring.dPerformanceYearRelMin)}`);
    lines.push(`# ISP_1_bPerformanceYearRelMax=${moduleData.monitoring.bPerformanceYearRelMax === true ? `1` : `0`}`);
    lines.push(`# ISP_1_dPerformanceYearRelMax=${formatTo8Digits(moduleData.monitoring.dPerformanceYearRelMax)}`);
    lines.push(`# ISP_1_bPerformanceSinceStartAbsMin=${moduleData.monitoring.bPerformanceSinceStartAbsMin === true ? `1` : `0`}`);
    lines.push(`# ISP_1_dPerformanceSinceStartAbsMin=${formatTo8Digits(moduleData.monitoring.dPerformanceSinceStartAbsMin)}`);
    lines.push(`# ISP_1_bPerformanceSinceStartAbsMax=${moduleData.monitoring.bPerformanceSinceStartAbsMax === true ? `1` : `0`}`);
    lines.push(`# ISP_1_dPerformanceSinceStartAbsMax=${formatTo8Digits(moduleData.monitoring.dPerformanceSinceStartAbsMax)}`);
    lines.push(`# ISP_1_bPerformanceSinceStartRelMin=${moduleData.monitoring.bPerformanceSinceStartRelMin === true ? `1` : `0`}`);
    lines.push(`# ISP_1_dPerformanceSinceStartRelMin=${formatTo8Digits(moduleData.monitoring.dPerformanceSinceStartRelMin)}`);
    lines.push(`# ISP_1_bPerformanceSinceStartRelMax=${moduleData.monitoring.bPerformanceSinceStartRelMax === true ? `1` : `0`}`);
    lines.push(`# ISP_1_dPerformanceSinceStartRelMax=${formatTo8Digits(moduleData.monitoring.dPerformanceSinceStartRelMax)}`);
    lines.push(`# ISP_1_bDrawdownDayAbsMax=${moduleData.monitoring.bDrawdownDayAbsMax === true ? `1` : `0`}`);
    lines.push(`# ISP_1_dDrawdownDayAbsMax=${formatTo8Digits(moduleData.monitoring.dDrawdownDayAbsMax)}`);
    lines.push(`# ISP_1_bDrawdownDayRelMax=${moduleData.monitoring.bDrawdownDayRelMax === true ? `1` : `0`}`);
    lines.push(`# ISP_1_dDrawdownDayRelMax=${formatTo8Digits(moduleData.monitoring.dDrawdownDayRelMax)}`);
    lines.push(`# ISP_1_bDrawdownWeekAbsMax=${moduleData.monitoring.bDrawdownWeekAbsMax === true ? `1` : `0`}`);
    lines.push(`# ISP_1_dDrawdownWeekAbsMax=${formatTo8Digits(moduleData.monitoring.dDrawdownWeekAbsMax)}`);
    lines.push(`# ISP_1_bDrawdownWeekRelMax=${moduleData.monitoring.bDrawdownWeekRelMax === true ? `1` : `0`}`);
    lines.push(`# ISP_1_dDrawdownWeekRelMax=${formatTo8Digits(moduleData.monitoring.dDrawdownWeekRelMax)}`);
    lines.push(`# ISP_1_bDrawdownMonthAbsMax=${moduleData.monitoring.bDrawdownMonthAbsMax === true ? `1` : `0`}`);
    lines.push(`# ISP_1_dDrawdownMonthAbsMax=${formatTo8Digits(moduleData.monitoring.dDrawdownMonthAbsMax)}`);
    lines.push(`# ISP_1_bDrawdownMonthRelMax=${moduleData.monitoring.bDrawdownMonthRelMax === true ? `1` : `0`}`);
    lines.push(`# ISP_1_dDrawdownMonthRelMax=${formatTo8Digits(moduleData.monitoring.dDrawdownMonthRelMax)}`);
    lines.push(`# ISP_1_bDrawdownYearAbsMax=${moduleData.monitoring.bDrawdownYearAbsMax === true ? `1` : `0`}`);
    lines.push(`# ISP_1_dDrawdownYearAbsMax=${formatTo8Digits(moduleData.monitoring.dDrawdownYearAbsMax)}`);
    lines.push(`# ISP_1_bDrawdownYearRelMax=${moduleData.monitoring.bDrawdownYearRelMax === true ? `1` : `0`}`);
    lines.push(`# ISP_1_dDrawdownYearRelMax=${formatTo8Digits(moduleData.monitoring.dDrawdownYearRelMax)}`);
    lines.push(`# ISP_1_bDrawdownSinceStartAbsMax=${moduleData.monitoring.bDrawdownSinceStartAbsMax === true ? `1` : `0`}`);
    lines.push(`# ISP_1_dDrawdownSinceStartAbsMax=${formatTo8Digits(moduleData.monitoring.dDrawdownSinceStartAbsMax)}`);
    lines.push(`# ISP_1_bDrawdownSinceStartRelMax=${moduleData.monitoring.bDrawdownSinceStartRelMax === true ? `1` : `0`}`);
    lines.push(`# ISP_1_dDrawdownSinceStartRelMax=${formatTo8Digits(moduleData.monitoring.dDrawdownSinceStartRelMax)}`);
    if (!professionalMode) { lines.push(`# ISP_1_dPerformanceDayAbsMin=${moduleData.monitoring.bPerformanceDayAbsMin ? formatTo8Digits(moduleData.monitoring.dPerformanceDayAbsMin) : "0.0"}`) };
    if (!professionalMode) { lines.push(`# ISP_1_dPerformanceDayAbsMax=${moduleData.monitoring.bPerformanceDayAbsMax ? formatTo8Digits(moduleData.monitoring.dPerformanceDayAbsMax) : "0.0"}`) };
    if (!professionalMode) { lines.push(`# ISP_1_dPerformanceDayRelMin=${moduleData.monitoring.bPerformanceDayRelMin ? formatTo8Digits(moduleData.monitoring.dPerformanceDayRelMin) : "0.0"}`) };
    if (!professionalMode) { lines.push(`# ISP_1_dPerformanceDayRelMax=${moduleData.monitoring.bPerformanceDayRelMax ? formatTo8Digits(moduleData.monitoring.dPerformanceDayRelMax) : "0.0"}`) };
    if (!professionalMode) { lines.push(`# ISP_1_dPerformanceWeekAbsMin=${moduleData.monitoring.bPerformanceWeekAbsMin ? formatTo8Digits(moduleData.monitoring.dPerformanceWeekAbsMin) : "0.0"}`) };
    if (!professionalMode) { lines.push(`# ISP_1_dPerformanceWeekAbsMax=${moduleData.monitoring.bPerformanceWeekAbsMax ? formatTo8Digits(moduleData.monitoring.dPerformanceWeekAbsMax) : "0.0"}`) };
    if (!professionalMode) { lines.push(`# ISP_1_dPerformanceWeekRelMin=${moduleData.monitoring.bPerformanceWeekRelMin ? formatTo8Digits(moduleData.monitoring.dPerformanceWeekRelMin) : "0.0"}`) };
    if (!professionalMode) { lines.push(`# ISP_1_dPerformanceWeekRelMax=${moduleData.monitoring.bPerformanceWeekRelMax ? formatTo8Digits(moduleData.monitoring.dPerformanceWeekRelMax) : "0.0"}`) };
    if (!professionalMode) { lines.push(`# ISP_1_dPerformanceMonthAbsMin=${moduleData.monitoring.bPerformanceMonthAbsMin ? formatTo8Digits(moduleData.monitoring.dPerformanceMonthAbsMin) : "0.0"}`) };
    if (!professionalMode) { lines.push(`# ISP_1_dPerformanceMonthAbsMax=${moduleData.monitoring.bPerformanceMonthAbsMax ? formatTo8Digits(moduleData.monitoring.dPerformanceMonthAbsMax) : "0.0"}`) };
    if (!professionalMode) { lines.push(`# ISP_1_dPerformanceMonthRelMin=${moduleData.monitoring.bPerformanceMonthRelMin ? formatTo8Digits(moduleData.monitoring.dPerformanceMonthRelMin) : "0.0"}`) };
    if (!professionalMode) { lines.push(`# ISP_1_dPerformanceMonthRelMax=${moduleData.monitoring.bPerformanceMonthRelMax ? formatTo8Digits(moduleData.monitoring.dPerformanceMonthRelMax) : "0.0"}`) };
    if (!professionalMode) { lines.push(`# ISP_1_dPerformanceYearAbsMin=${moduleData.monitoring.bPerformanceYearAbsMin ? formatTo8Digits(moduleData.monitoring.dPerformanceYearAbsMin) : "0.0"}`) };
    if (!professionalMode) { lines.push(`# ISP_1_dPerformanceYearAbsMax=${moduleData.monitoring.bPerformanceYearAbsMax ? formatTo8Digits(moduleData.monitoring.dPerformanceYearAbsMax) : "0.0"}`) };
    if (!professionalMode) { lines.push(`# ISP_1_dPerformanceYearRelMin=${moduleData.monitoring.bPerformanceYearRelMin ? formatTo8Digits(moduleData.monitoring.dPerformanceYearRelMin) : "0.0"}`) };
    if (!professionalMode) { lines.push(`# ISP_1_dPerformanceYearRelMax=${moduleData.monitoring.bPerformanceYearRelMax ? formatTo8Digits(moduleData.monitoring.dPerformanceYearRelMax) : "0.0"}`) };
    if (!professionalMode) { lines.push(`# ISP_1_dDrawdownDayAbsMax=${moduleData.monitoring.bDrawdownDayAbsMax ? formatTo8Digits(moduleData.monitoring.dDrawdownDayAbsMax) : "0.0"}`) };
    if (!professionalMode) { lines.push(`# ISP_1_dDrawdownDayRelMax=${moduleData.monitoring.bDrawdownDayRelMax ? formatTo8Digits(moduleData.monitoring.dDrawdownDayRelMax) : "0.0"}`) };
    if (!professionalMode) { lines.push(`# ISP_1_dDrawdownWeekAbsMax=${moduleData.monitoring.bDrawdownWeekAbsMax ? formatTo8Digits(moduleData.monitoring.dDrawdownWeekAbsMax) : "0.0"}`) };
    if (!professionalMode) { lines.push(`# ISP_1_dDrawdownWeekRelMax=${moduleData.monitoring.bDrawdownWeekRelMax ? formatTo8Digits(moduleData.monitoring.dDrawdownWeekRelMax) : "0.0"}`) };
    if (!professionalMode) { lines.push(`# ISP_1_dDrawdownMonthAbsMax=${moduleData.monitoring.bDrawdownMonthAbsMax ? formatTo8Digits(moduleData.monitoring.dDrawdownMonthAbsMax) : "0.0"}`) };
    if (!professionalMode) { lines.push(`# ISP_1_dDrawdownMonthRelMax=${moduleData.monitoring.bDrawdownMonthRelMax ? formatTo8Digits(moduleData.monitoring.dDrawdownMonthRelMax) : "0.0"}`) };
    if (!professionalMode) { lines.push(`# ISP_1_dDrawdownYearAbsMax=${moduleData.monitoring.bDrawdownYearAbsMax ? formatTo8Digits(moduleData.monitoring.dDrawdownYearAbsMax) : "0.0"}`) };
    if (!professionalMode) { lines.push(`# ISP_1_dDrawdownYearRelMax=${moduleData.monitoring.bDrawdownYearRelMax ? formatTo8Digits(moduleData.monitoring.dDrawdownYearRelMax) : "0.0"}`) };

    // ----------------------------------------------------------------------
    // TSP_1_SPLIT_Y
    // ----------------------------------------------------------------------
    if (moduleData.tradeSplittings !== undefined) {
      moduleData.tradeSplittings.forEach((tradeSplitting, index) => {
        if (tradeSplitting.config !== null && tradeSplitting.config !== undefined) {
          lines.push(`# TSP_1_SPLIT_${index + 1}_nId=${tradeSplitting.id}`);
        }
      });
    }

    // ----------------------------------------------------------------------
    // FEB_1
    // ----------------------------------------------------------------------
    if (moduleData.dataFeedback === undefined) {
      return;
    }
    if (!professionalMode) { lines.push(`# FEB_1_nMetaDataState=${moduleData.dataFeedback.nMetaDataState === true ? `1` : `0`}`) };
    if (!professionalMode) { lines.push(`# FEB_1_nTradeScreenshotsState=${moduleData.dataFeedback.nTradeScreenshotsState === true ? `1` : `0`}`) };
    if (!professionalMode) { lines.push(`# FEB_1_nCurrentValueState=${moduleData.dataFeedback.nCurrentValueState === true ? `1` : `0`}`) };
    if (!professionalMode) { lines.push(`# FEB_1_nCurrentValueEvt=${moduleData.dataFeedback.nCurrentValueEvt === true ? `1` : `0`}`) };
    if (!professionalMode) { lines.push(`# FEB_1_nCurrentValueInos=${moduleData.dataFeedback.nCurrentValueInos === true ? `1` : `0`}`) };
    if (!professionalMode) { lines.push(`# FEB_1_nCurrentValueCa=${moduleData.dataFeedback.nCurrentValueCa === true ? `1` : `0`}`) };
    if (!professionalMode) { lines.push(`# FEB_1_nCurrentValueCas=${moduleData.dataFeedback.nCurrentValueCas === true ? `1` : `0`}`) };
    if (!professionalMode) { lines.push(`# FEB_1_nCurrentValuePas=${moduleData.dataFeedback.nCurrentValuePas === true ? `1` : `0`}`) };
    if (!professionalMode) { lines.push(`# FEB_1_nCurrentValueFis=${moduleData.dataFeedback.nCurrentValueFis === true ? `1` : `0`}`) };
    if (!professionalMode) { lines.push(`# FEB_1_nCurrentValueRefreshInterval=${moduleData.dataFeedback.nCurrentValueRefreshInterval}`) };
    if (!professionalMode) { lines.push(`# FEB_1_nTimeAnalysisState=${moduleData.dataFeedback.nTimeAnalysisState === true ? `1` : `0`}`) };
    if (!professionalMode) { lines.push(`# FEB_1_nTimeAnalysisMinutePeriod=${moduleData.dataFeedback.nTimeAnalysisMinutePeriod}`) };
    if (!professionalMode) { lines.push(`# FEB_1_nTimeAnalysisHourPeriod=${moduleData.dataFeedback.nTimeAnalysisHourPeriod}`) };
    if (!professionalMode) { lines.push(`# FEB_1_nTimeAnalysisDayPeriod=${moduleData.dataFeedback.nTimeAnalysisDayPeriod}`) };
    if (!professionalMode) { lines.push(`# FEB_1_nTimeAnalysisWeekdayPeriod=${moduleData.dataFeedback.nTimeAnalysisWeekdayPeriod}`) };
    if (!professionalMode) { lines.push(`# FEB_1_nTimeAnalysisWeekPeriod=${moduleData.dataFeedback.nTimeAnalysisWeekPeriod}`) };
    if (!professionalMode) { lines.push(`# FEB_1_nTimeAnalysisMonthPeriod=${moduleData.dataFeedback.nTimeAnalysisMonthPeriod}`) };
    if (!professionalMode) { lines.push(`# FEB_1_nTimeAnalysisRefreshInterval=${moduleData.dataFeedback.nTimeAnalysisRefreshInterval}`) };
    if (!professionalMode) { lines.push(`# FEB_1_nValueAnalysisState=${moduleData.dataFeedback.nValueAnalysisState === true ? `1` : `0`}`) };
    if (!professionalMode) { lines.push(`# FEB_1_nValueAnalysisEvtPeriod=${moduleData.dataFeedback.nValueAnalysisEvtPeriod}`) };
    if (!professionalMode) { lines.push(`# FEB_1_nValueAnalysisInosPeriod=${moduleData.dataFeedback.nValueAnalysisInosPeriod}`) };
    if (!professionalMode) { lines.push(`# FEB_1_nValueAnalysisCaPeriod=${moduleData.dataFeedback.nValueAnalysisCaPeriod}`) };
    if (!professionalMode) { lines.push(`# FEB_1_nValueAnalysisCasPeriod=${moduleData.dataFeedback.nValueAnalysisCasPeriod}`) };
    if (!professionalMode) { lines.push(`# FEB_1_nValueAnalysisPasPeriod=${moduleData.dataFeedback.nValueAnalysisPasPeriod}`) };
    if (!professionalMode) { lines.push(`# FEB_1_nValueAnalysisFisPeriod=${moduleData.dataFeedback.nValueAnalysisFisPeriod}`) };
    if (!professionalMode) { lines.push(`# FEB_1_nValueAnalysisHistogramBins=${moduleData.dataFeedback.nValueAnalysisHistogramBins}`) };
    if (!professionalMode) { lines.push(`# FEB_1_nValueAnalysisRefreshInterval=${moduleData.dataFeedback.nValueAnalysisRefreshInterval}`) };
    if (!professionalMode) { lines.push(`# FEB_1_nSignalAnalysisState=${moduleData.dataFeedback.nSignalAnalysisState === true ? `1` : `0`}`) };
    if (!professionalMode) { lines.push(`# FEB_1_nSignalAnalysisActualTradePeriod=${moduleData.dataFeedback.nSignalAnalysisActualTradePeriod}`) };
    if (!professionalMode) { lines.push(`# FEB_1_nSignalAnalysisGeneralSignalPeriod=${moduleData.dataFeedback.nSignalAnalysisGeneralSignalPeriod}`) };
    if (!professionalMode) { lines.push(`# FEB_1_nSignalAnalysisEvtPeriod=${moduleData.dataFeedback.nSignalAnalysisEvtPeriod}`) };
    if (!professionalMode) { lines.push(`# FEB_1_nSignalAnalysisInosPeriod=${moduleData.dataFeedback.nSignalAnalysisInosPeriod}`) };
    if (!professionalMode) { lines.push(`# FEB_1_nSignalAnalysisRelioPeriod=${moduleData.dataFeedback.nSignalAnalysisRelioPeriod}`) };
    if (!professionalMode) { lines.push(`# FEB_1_nSignalAnalysisCaPeriod=${moduleData.dataFeedback.nSignalAnalysisCaPeriod}`) };
    if (!professionalMode) { lines.push(`# FEB_1_nSignalAnalysisCasPeriod=${moduleData.dataFeedback.nSignalAnalysisCasPeriod}`) };
    if (!professionalMode) { lines.push(`# FEB_1_nSignalAnalysisPasPeriod=${moduleData.dataFeedback.nSignalAnalysisPasPeriod}`) };
    if (!professionalMode) { lines.push(`# FEB_1_nSignalAnalysisFisPeriod=${moduleData.dataFeedback.nSignalAnalysisFisPeriod}`) };
    if (!professionalMode) { lines.push(`# FEB_1_nSignalAnalysisBarsBefore=${moduleData.dataFeedback.nSignalAnalysisBarsBefore}`) };
    if (!professionalMode) { lines.push(`# FEB_1_nSignalAnalysisBarsAfter=${moduleData.dataFeedback.nSignalAnalysisBarsAfter}`) };
    if (!professionalMode) { lines.push(`# FEB_1_nSignalAnalysisRefreshInterval=${moduleData.dataFeedback.nSignalAnalysisRefreshInterval}`) };
    if (!professionalMode) { lines.push(`# FEB_1_nSymbolSeriesBarsCompletedState=${moduleData.dataFeedback.nSymbolSeriesBarsCompletedState === true ? `1` : `0`}`) };
    if (!professionalMode) { lines.push(`# FEB_1_nSymbolSeriesBarsCurrentState=${moduleData.dataFeedback.nSymbolSeriesBarsCurrentState === true ? `1` : `0`}`) };
    if (!professionalMode) { lines.push(`# FEB_1_nSymbolSeriesM1State=${moduleData.dataFeedback.nSymbolSeriesM1State === true ? `1` : `0`}`) };
    if (!professionalMode) { lines.push(`# FEB_1_nSymbolSeriesM1Range=${moduleData.dataFeedback.nSymbolSeriesM1Range}`) };
    if (!professionalMode) { lines.push(`# FEB_1_nSymbolSeriesM5State=${moduleData.dataFeedback.nSymbolSeriesM5State === true ? `1` : `0`}`) };
    if (!professionalMode) { lines.push(`# FEB_1_nSymbolSeriesM5Range=${moduleData.dataFeedback.nSymbolSeriesM5Range}`) };
    if (!professionalMode) { lines.push(`# FEB_1_nSymbolSeriesM15State=${moduleData.dataFeedback.nSymbolSeriesM15State === true ? `1` : `0`}`) };
    if (!professionalMode) { lines.push(`# FEB_1_nSymbolSeriesM15Range=${moduleData.dataFeedback.nSymbolSeriesM15Range}`) };
    if (!professionalMode) { lines.push(`# FEB_1_nSymbolSeriesM30State=${moduleData.dataFeedback.nSymbolSeriesM30State === true ? `1` : `0`}`) };
    if (!professionalMode) { lines.push(`# FEB_1_nSymbolSeriesM30Range=${moduleData.dataFeedback.nSymbolSeriesM30Range}`) };
    if (!professionalMode) { lines.push(`# FEB_1_nSymbolSeriesH1State=${moduleData.dataFeedback.nSymbolSeriesH1State === true ? `1` : `0`}`) };
    if (!professionalMode) { lines.push(`# FEB_1_nSymbolSeriesH1Range=${moduleData.dataFeedback.nSymbolSeriesH1Range}`) };
    if (!professionalMode) { lines.push(`# FEB_1_nSymbolSeriesH4State=${moduleData.dataFeedback.nSymbolSeriesH4State === true ? `1` : `0`}`) };
    if (!professionalMode) { lines.push(`# FEB_1_nSymbolSeriesH4Range=${moduleData.dataFeedback.nSymbolSeriesH4Range}`) };
    if (!professionalMode) { lines.push(`# FEB_1_nSymbolSeriesD1State=${moduleData.dataFeedback.nSymbolSeriesD1State === true ? `1` : `0`}`) };
    if (!professionalMode) { lines.push(`# FEB_1_nSymbolSeriesD1Range=${moduleData.dataFeedback.nSymbolSeriesD1Range}`) };
    if (!professionalMode) { lines.push(`# FEB_1_nSymbolSeriesW1State=${moduleData.dataFeedback.nSymbolSeriesW1State === true ? `1` : `0`}`) };
    if (!professionalMode) { lines.push(`# FEB_1_nSymbolSeriesW1Range=${moduleData.dataFeedback.nSymbolSeriesW1Range}`) };
    if (!professionalMode) { lines.push(`# FEB_1_nSymbolSeriesMNState=${moduleData.dataFeedback.nSymbolSeriesMNState === true ? `1` : `0`}`) };
    if (!professionalMode) { lines.push(`# FEB_1_nSymbolSeriesMNRange=${moduleData.dataFeedback.nSymbolSeriesMNRange}`) };

    // ----------------------------------------------------------------------
    // MIS_1
    // ----------------------------------------------------------------------
    if (moduleData.miscellaneous === undefined) {
      return;
    }
    if (!professionalMode) { lines.push(`# MIS_1_nGeneralSignalVisualization=${moduleData.tradeBasics.nGeneralSignalVisualization === true ? `1` : `0`}`) };
    if (!professionalMode) { lines.push(`# MIS_1_nDrawUnequalSymbols=${moduleData.miscellaneous.nDrawUnequalSymbols === true ? `1` : `0`}`) };
    if (!professionalMode) { lines.push(`# MIS_1_nDrawChartAnalyzerPanel=${moduleData.miscellaneous.nDrawChartAnalyzerPanel === true ? `1` : `0`}`) };

    // ----------------------------------------------------------------------
    // TIM_1
    // ----------------------------------------------------------------------
    if (moduleData.timing === undefined) {
      return;
    }
    if (!professionalMode) { lines.push(`# TIM_1_nIntradayMode=${moduleData.timing.nIntradayMode === true ? `1` : `0`}`) };
    if (!professionalMode) { lines.push(`# TIM_1_strStartIntradayTrading=${moduleData.timing.strStartIntradayTrading}`) };
    if (!professionalMode) { lines.push(`# TIM_1_strStopIntradayTrading=${moduleData.timing.strStopIntradayTrading}`) };
    if (!professionalMode) { lines.push(`# TIM_1_strDeadlineIntradayTrading=${moduleData.timing.strDeadlineIntradayTrading}`) };
    if (!professionalMode) { lines.push(`# TIM_1_nDstSummerShiftedMinutes=${moduleData.timing.nDstSummerShiftedMinutes}`) };
    if (!professionalMode) { lines.push(`# TIM_1_strDstSummerShiftStart=${moduleData.timing.nDstSummerShiftStartNumberOfMonth},${moduleData.timing.nDstSummerShiftStartDayOfWeek},${moduleData.timing.nDstSummerShiftStartCountDayOfWeekInMonth},${moduleData.timing.strDstSummerShiftStartTime}`) };
    if (!professionalMode) { lines.push(`# TIM_1_strDstSummerShiftEnd=${moduleData.timing.nDstSummerShiftEndNumberOfMonth},${moduleData.timing.nDstSummerShiftEndDayOfWeek},${moduleData.timing.nDstSummerShiftEndCountDayOfWeekInMonth},${moduleData.timing.strDstSummerShiftEndTime}`) };
    if (!professionalMode) { lines.push(`# TIM_1_nDstWinterShiftedMinutes=${moduleData.timing.nDstWinterShiftedMinutes}`) };
    if (!professionalMode) { lines.push(`# TIM_1_strDstWinterShiftStart=${moduleData.timing.nDstWinterShiftStartNumberOfMonth},${moduleData.timing.nDstWinterShiftStartDayOfWeek},${moduleData.timing.nDstWinterShiftStartCountDayOfWeekInMonth},${moduleData.timing.strDstWinterShiftStartTime}`) };
    if (!professionalMode) { lines.push(`# TIM_1_strDstWinterShiftEnd=${moduleData.timing.nDstWinterShiftEndNumberOfMonth},${moduleData.timing.nDstWinterShiftEndDayOfWeek},${moduleData.timing.nDstWinterShiftEndCountDayOfWeekInMonth},${moduleData.timing.strDstWinterShiftEndTime}`) };

    // ----------------------------------------------------------------------
    // EVT_1
    // ----------------------------------------------------------------------
    lines.push(`# EVT_1_bActual=${moduleData.news.bActual === true ? `1` : `0`}`);
    lines.push(`# EVT_1_lActualMin=${formatTo8Digits(moduleData.news.lActualMin)}`);
    lines.push(`# EVT_1_lActualMax=${formatTo8Digits(moduleData.news.lActualMax)}`);
    lines.push(`# EVT_1_bForecast=${moduleData.news.bForecast === true ? `1` : `0`}`);
    lines.push(`# EVT_1_lForecastMin=${formatTo8Digits(moduleData.news.lForecastMin)}`);
    lines.push(`# EVT_1_lForecastMax=${formatTo8Digits(moduleData.news.lForecastMax)}`);
    lines.push(`# EVT_1_bPrevious=${moduleData.news.bPrevious === true ? `1` : `0`}`);
    lines.push(`# EVT_1_lPreviousMin=${formatTo8Digits(moduleData.news.lPreviousMin)}`);
    lines.push(`# EVT_1_lPreviousMax=${formatTo8Digits(moduleData.news.lPreviousMax)}`);

    // ----------------------------------------------------------------------
    // EVT_1_FIL_Y
    // ----------------------------------------------------------------------

    // ----------------------------------------------------------------------
    // EVT_1_REL_Y
    // ----------------------------------------------------------------------

    // ----------------------------------------------------------------------
    // INOS_X
    // ----------------------------------------------------------------------
    if (moduleData.indicators !== undefined) {
      moduleData.indicators.forEach((indicator, index) => {
        const {config} = indicator;
        if (config === undefined || config === null) {
          return;
        }
        if (config.nSignalInUse === undefined || config.nSignalInUse === null) {
          return;
        }
        lines.push(`# INOS_${index + 1}_nId=${indicator.id}`);
        if (!professionalMode) { lines.push(`# INOS_${index + 1}_strExclusion=${config.strExclusion}`) };
        if (!professionalMode) { lines.push(`# INOS_${index + 1}_dForwardAdjustment=${formatTo8Digits(config.dForwardAdjustment)}`) };
        if (!professionalMode) { lines.push(`# INOS_${index + 1}_nValueAnalysisFeedbackState=${config.nValueAnalysisFeedbackState === true ? `1` : `0`}`) };
        if (!professionalMode) { lines.push(`# INOS_${index + 1}_nSignalAnalysisFeedbackState=${config.nSignalAnalysisFeedbackState === true ? `1` : `0`}`) };
      });
    }

    // ----------------------------------------------------------------------
    // RELIO_X
    // ----------------------------------------------------------------------
    if (moduleData.indicatorCombinations !== undefined) {
      moduleData.indicatorCombinations.forEach((relio, index) => {
        const {config} = relio;
        if (config === undefined || config === null) {
          return;
        }
        if (config.nSignalInUse === undefined || config.nSignalInUse === null) {
          return;
        }
        lines.push(`# RELIO_${index + 1}_nId=${relio.id}`);	
        if (!professionalMode) { lines.push(`# RELIO_${index + 1}_nSignalAnalysisFeedbackState=${config.nSignalAnalysisFeedbackState === true ? `1` : `0`}`) };
      });
    }

    // ----------------------------------------------------------------------
    // RELIO_X_SEL_Y
    // ----------------------------------------------------------------------

    // ----------------------------------------------------------------------
    // CA_X
    // ----------------------------------------------------------------------
    if (moduleData.chartAnalyzers !== undefined) {
      moduleData.chartAnalyzers.forEach((ca, index) => {
        const {config} = ca;
        if (config === undefined || config === null) {
          return;
        }
        if (config.nSignalInUse === undefined || config.nSignalInUse === null) {
          return;
        }
        lines.push(`# CA_${index + 1}_nId=${ca.id}`);
        if (!professionalMode) { lines.push(`# CA_${index + 1}_strExclusion=${config.strExclusion}`) };
        if (!professionalMode) { lines.push(`# CA_${index + 1}_nMidVolaMinSwings=${config.nMidVolaMinSwings}`) };
        if (!professionalMode) { lines.push(`# CA_${index + 1}_dMidVolaMinROC=${formatTo8Digits(config.dMidVolaMinROC)}`) };
        if (!professionalMode) { lines.push(`# CA_${index + 1}_dMidVolaMinFilled=${formatTo8Digits(config.dMidVolaMinFilled)}`) };
        if (!professionalMode) { lines.push(`# CA_${index + 1}_nHighVolaMinSwings=${config.nHighVolaMinSwings}`) };
        if (!professionalMode) { lines.push(`# CA_${index + 1}_dHighVolaMinROC=${formatTo8Digits(config.dHighVolaMinROC)}`) };
        if (!professionalMode) { lines.push(`# CA_${index + 1}_dHighVolaMinFilled=${formatTo8Digits(config.dHighVolaMinFilled)}`) };
        if (!professionalMode) { lines.push(`# CA_${index + 1}_strSupResForward=${config.strSupResForward}`) };
        if (!professionalMode) { lines.push(`# CA_${index + 1}_dSupportMultiplier=${formatTo8Digits(config.dSupportMultiplier)}`) };
        if (!professionalMode) { lines.push(`# CA_${index + 1}_dResistanceMultiplier=${formatTo8Digits(config.dResistanceMultiplier)}`) };
        if (!professionalMode) { lines.push(`# CA_${index + 1}_dRegressionAnglesMin=${formatTo8Digits(config.dRegressionAnglesMin)}`) };
        if (!professionalMode) { lines.push(`# CA_${index + 1}_dRegressionAnglesMax=${formatTo8Digits(config.dRegressionAnglesMax)}`) };
        if (!professionalMode) { lines.push(`# CA_${index + 1}_nValueAnalysisFeedbackState=${config.nValueAnalysisFeedbackState === true ? `1` : `0`}`) };
        if (!professionalMode) { lines.push(`# CA_${index + 1}_nSignalAnalysisFeedbackState=${config.nSignalAnalysisFeedbackState === true ? `1` : `0`}`) };
      });
    }

    // ----------------------------------------------------------------------
    // CA_X_SWING_Y
    // ----------------------------------------------------------------------
    if (moduleData.chartAnalyzers !== undefined) {
      moduleData.chartAnalyzers.forEach((chartAnalayzer, caIndex) => {
        if (chartAnalayzer.config === null || chartAnalayzer.config === undefined) {
          return;
        }
        if (chartAnalayzer.config.swingConfigurations !== undefined) {
          chartAnalayzer.config.swingConfigurations.forEach((swing, swingIndex) => {
            lines.push(`# CA_${caIndex + 1}_SWING_${swingIndex + 1}_bState=${swing.bState === true ? 1 : 0}`);
          });
        }
      });
    }

    // ----------------------------------------------------------------------
    // CAS_1
    // ----------------------------------------------------------------------
    if (moduleData.candlePatterns !== undefined) {
      if (!professionalMode) { lines.push(`# CAS_1_strExclusion=${moduleData.candlePatterns.strExclusion}`) };
      if (!professionalMode) { lines.push(`# CAS_1_dStopLossForwardAdjustment=${formatTo8Digits(moduleData.candlePatterns.dStopLossForwardAdjustment)}`) };
      if (!professionalMode) { lines.push(`# CAS_1_dTakeProfitForwardAdjustment=${formatTo8Digits(moduleData.candlePatterns.dTakeProfitForwardAdjustment)}`) };
    }

    // ----------------------------------------------------------------------
    // CAS_1_SEL_Y
    // ----------------------------------------------------------------------

    // ----------------------------------------------------------------------
    // PAS_1
    // ----------------------------------------------------------------------
    if (moduleData.chartPatterns !== undefined) {
      if (!professionalMode) { lines.push(`# PAS_1_strExclusion=${moduleData.chartPatterns.strExclusion}`) };
      if (!professionalMode) { lines.push(`# PAS_1_dStopLossForwardAdjustment=${formatTo8Digits(moduleData.chartPatterns.dStopLossForwardAdjustment)}`) };
      if (!professionalMode) { lines.push(`# PAS_1_dTakeProfitForwardAdjustment=${formatTo8Digits(moduleData.chartPatterns.dTakeProfitForwardAdjustment)}`) };
    }

    // ----------------------------------------------------------------------
    // PAS_1_SEL_Y
    // ----------------------------------------------------------------------

    // ----------------------------------------------------------------------
    // FIS_1
    // ----------------------------------------------------------------------
    if (moduleData.fibonacciPatterns !== undefined) {
      if (!professionalMode) { lines.push(`# FIS_1_strExclusion=${moduleData.fibonacciPatterns.strExclusion}`) };
      if (!professionalMode) { lines.push(`# FIS_1_dStopLossForwardAdjustment=${formatTo8Digits(moduleData.fibonacciPatterns.dStopLossForwardAdjustment)}`) };
      if (!professionalMode) { lines.push(`# FIS_1_dTakeProfitForwardAdjustment=${formatTo8Digits(moduleData.fibonacciPatterns.dTakeProfitForwardAdjustment)}`) };
    }

    lines.push(`# +++++++++++++++++++++++++++++++++++++++++++++`);
    lines.push(`# DO NOT EDIT THE VALUES IN THIS SECTION`);
    lines.push(`# END OF AUTOMATICALLY GENERATED DATA FOR EXPERT ADVISOR BUILDER`);
    lines.push(`# +++++++++++++++++++++++++++++++++++++++++++++`);
    
    txtData = lines.join(`\n`);
  }

  if(DEBUG_LEVEL >= 1)
  {
    console.log(`----- WRITE -----`);
    console.log(deepSortKeys(moduleData));
    console.log(`----- WRITE -----`);
  }

  return txtData;
};

// ----------------------------------------------------------------------
// Section
// ----------------------------------------------------------------------
export const TxtDataToModuleData = (txtData, batchIndex, providedModuleNumber = null) => {
  const useJson = false;
  let moduleData = {};
  const now = Date.now();

   if (useJson) {
    moduleData = JSON.parse(txtData);
  } else {
    const lines = txtData.split(`\n`).map((line) => line.trim());

    // Find the start and end of the hidden data section
    const startMarker = "# START OF AUTOMATICALLY GENERATED DATA FOR EXPERT ADVISOR BUILDER";
    const endMarker = "# END OF AUTOMATICALLY GENERATED DATA FOR EXPERT ADVISOR BUILDER";

    const startIndex = lines.findIndex(line => line.includes(startMarker));
    const endIndex = lines.findIndex(line => line.includes(endMarker));

    const keyValuePairs = {};

    lines.forEach((line, index) => {
      if (!line) return; // Skip empty lines
      
      let shouldParse = false;
      let cleanedLine = line;
      
      // Regular data lines (not starting with #)
      if (!line.startsWith(`#`)) {
        shouldParse = true;
        cleanedLine = line;
      }
      // Hidden data section (between start and end markers)
      else if (startIndex !== -1 && endIndex !== -1 && 
              index > startIndex && index < endIndex && 
              line.startsWith(`# `) && 
              !line.includes("++++++++++++++++++") &&
              !line.includes("DO NOT EDIT")) {
        shouldParse = true;
        cleanedLine = line.substring(2); // Remove "# " prefix
      }
      
      if (shouldParse) {
        const match = cleanedLine.match(/^([^=]+)=(.*)$/);
        if (match) {
          keyValuePairs[match[1]] = match[2];
        }
      }
    });

    // Initialize moduleData structure
    let moduleNumber = providedModuleNumber;
    
    // Only generate if not provided
    if (moduleNumber === null) {
      const savedData = localStorage.getItem("expertAdvisorBuilderData");
      let modules = [];
      if (savedData) {
        modules = JSON.parse(savedData);
      }

      while (moduleNumber === null) {
        let isUnique = true;
        const moduleNumberTest = Math.floor(Math.random() * (9999 - 1000 + 1) + 1000);
        modules.forEach((module) => {
          
          // Updated to extract number from new format
          const match = module.moduleName.match(/Module (\d+)/);
          const existingNumber = match ? parseInt(match[1], 10) : null;
          if (moduleNumberTest === existingNumber) {
            isUnique = false;
          }

        });
        if (isUnique) {
          moduleNumber = moduleNumberTest;
        }
      }
    }
    moduleData = {
      moduleId: Number(String(now) + String(batchIndex)),
      moduleName: `Module ${moduleNumber}`,
      basics: {        
        dVersion: "3.1",
        nNumber: moduleNumber,
        nTradingState: "1",
        strIdeaOutputDescription: ""
      },
      //
      tradeBasics: { ...TradeBasicsDefaults },
      pendingOrderSettings: { ...PendingOrderSettingsDefaults },
      initialStopLoss: { ...InitialStopLossDefaults },
      stopLossTrailings: [],
      initialTakeProfit: { ...InitialTakeProfitDefaults },
      takeProfitDynamics: [],
      symbolAndTimeframe: { ...SymbolAndTimeframeDefaults },
      volumeCalculation: { ...VolumeCalculationDefaults },
      tradeSplittings: [],
      timing: { ...TimingDefaults },
      monitoring: { ...MonitoringDefaults },
      dataFeedback: { ...DataFeedbackDefaults },
      notifications: { ...NotificationsDefaults },
      miscellaneous: { ...MiscellaneousDefaults },
      //
      indicators: [],
      indicatorCombinations: [],
      chartAnalyzers: [],
      news: { ...NewsDefaults },
      candlePatterns: { ...CandlePatternsDefaults },
      chartPatterns: { ...ChartPatternsDefaults },
      fibonacciPatterns: { ...FibonacciPatternsDefaults },
    };

    // ----------------------------------------------------------------------
    // INOS_X
    // ----------------------------------------------------------------------
    const indicatorNumberToId = {};
    let inosIndex = 1;
    while (keyValuePairs[`INOS_${inosIndex}_nSignalInUse`]) {
      // Generate unique ID
      let id = now + inosIndex;
      if(keyValuePairs[`INOS_${inosIndex}_nId`])
      {
        id = parseInt(keyValuePairs[`INOS_${inosIndex}_nId`], 10);
      }
      
      // Create mapping from number to ID
      indicatorNumberToId[inosIndex] = id;

      inosIndex += 1;
    }

    if(DEBUG_LEVEL >= 2) { console.log("INOS_X"); }

    // ----------------------------------------------------------------------
    // CA_X
    // ----------------------------------------------------------------------
    const chartAnalyzerNumberToId = {};
    let caIndex = 1;
    while (keyValuePairs[`CA_${caIndex}_nSignalInUse`]) {
      // Generate unique ID
      let id = now + caIndex;
      if(keyValuePairs[`CA_${caIndex}_nId`])
      {
        id = parseInt(keyValuePairs[`CA_${caIndex}_nId`], 10);
      }
      
      // Create mapping from number to ID
      chartAnalyzerNumberToId[caIndex] = id;

      caIndex += 1;
    }

    if(DEBUG_LEVEL >= 2) { console.log("CA_X"); }

    // ----------------------------------------------------------------------
    // Meta
    // ----------------------------------------------------------------------
    const firstLine = txtData.split(`\n`)[0].trim();
    if (firstLine !== `[module_file]`) {
      return "error";
    } 

    const secondLine = txtData.split(`\n`)[1].trim();

    if (keyValuePairs.MTA_1_nModuleId) {
      moduleData.moduleId = parseInt(keyValuePairs.MTA_1_nModuleId, 10);
    }
    if (keyValuePairs.MTA_1_strModuleName) {
      moduleData.moduleName = keyValuePairs.MTA_1_strModuleName;
    }

    if(DEBUG_LEVEL >= 2) { console.log("Meta"); }

    // ----------------------------------------------------------------------
    // MTA_1
    // ----------------------------------------------------------------------
    if (keyValuePairs.MTA_1_dVersion) {
      moduleData.basics.dVersion = keyValuePairs.MTA_1_dVersion;
    }
    if (keyValuePairs.MTA_1_nNumber) {
      moduleData.basics.nNumber = parseFloat(keyValuePairs.MTA_1_nNumber).toString();
    }
    if (secondLine === `[EXCLUDED]`) {
      moduleData.basics.nTradingState = `0`;
    } else if (secondLine === `[ENABLED]`) {
      moduleData.basics.nTradingState = `1`;
    } else if (secondLine === `[DISABLED_WITHOUT_CLOSING]`) {
      moduleData.basics.nTradingState = `2`;
    } else if (secondLine === `[DISABLED_WITH_CLOSING]`) {
      moduleData.basics.nTradingState = `3`;
    } else {
      moduleData.basics.nTradingState = `0`;
    }

    if(keyValuePairs.MTA_1_strIdeaOutputDescription)
    {
      if(keyValuePairs.MTA_1_strIdeaOutputDescription !== "Description not set!")
      {
        moduleData.basics.strIdeaOutputDescription = keyValuePairs.MTA_1_strIdeaOutputDescription;

        if (!keyValuePairs.MTA_1_strModuleName && keyValuePairs.MTA_1_strIdeaOutputDescription !== "") {
          moduleData.moduleName = `${moduleData.moduleName }: ${keyValuePairs.MTA_1_strIdeaOutputDescription}`;
        }
      }
    }

    if(DEBUG_LEVEL >= 2) { console.log("MTA_1"); }
    
    // ----------------------------------------------------------------------
    // RIM_1
    // ----------------------------------------------------------------------
    if (keyValuePairs.RIM_1_nRiskProfile) {
      moduleData.volumeCalculation.nRiskProfile = keyValuePairs.RIM_1_nRiskProfile;
    }
    if (keyValuePairs.RIM_1_nVolumeCalculation) {
      moduleData.volumeCalculation.nVolumeCalculation = keyValuePairs.RIM_1_nVolumeCalculation;
    }
    if (keyValuePairs.RIM_1_dFixLots) {
      moduleData.volumeCalculation.dFixLots = parseFromFormattedDigits(keyValuePairs.RIM_1_dFixLots);
    }
    if (keyValuePairs.RIM_1_dFixRelRisk) {
      moduleData.volumeCalculation.dFixRelRisk = parseFromFormattedDigits(keyValuePairs.RIM_1_dFixRelRisk);
    }
    if (keyValuePairs.RIM_1_dFixAbsRisk) {
      moduleData.volumeCalculation.dFixAbsRisk = parseFromFormattedDigits(keyValuePairs.RIM_1_dFixAbsRisk);
    }
    if (keyValuePairs.RIM_1_bMaxSpread) {
      moduleData.volumeCalculation.bMaxSpread = keyValuePairs.RIM_1_bMaxSpread === `1`;
    }
    else if(keyValuePairs.RIM_1_nMaxSpread && parseFloat(keyValuePairs.RIM_1_nMaxSpread) !== 0)
    {
      moduleData.volumeCalculation.bMaxSpread = true;
    }
    if (keyValuePairs.RIM_1_nMaxSpread) {
      moduleData.volumeCalculation.nMaxSpread = keyValuePairs.RIM_1_nMaxSpread;
    }
    if (keyValuePairs.RIM_1_nInosUsedForValueInjection) {
      moduleData.volumeCalculation.nInosUsedForValueInjection = keyValuePairs.RIM_1_nInosUsedForValueInjection !== "0" ? indicatorNumberToId[keyValuePairs.RIM_1_nInosUsedForValueInjection].toString() : "0";
    }
    if (keyValuePairs.RIM_1_dCommissionPerLot) {
      moduleData.volumeCalculation.dCommissionPerLot = parseFromFormattedDigits(keyValuePairs.RIM_1_dCommissionPerLot);
    }

    if(DEBUG_LEVEL >= 2) { console.log("RIM_1"); }
    
    // ----------------------------------------------------------------------
    // STF_1
    // ----------------------------------------------------------------------
    if (keyValuePairs.STF_1_strSymbol) {
      moduleData.symbolAndTimeframe.strSymbol = keyValuePairs.STF_1_strSymbol === "CURRENT" ? "Current" : keyValuePairs.STF_1_strSymbol;
    }
    if (keyValuePairs.STF_1_nTimeframe) {
      moduleData.symbolAndTimeframe.nTimeframe = keyValuePairs.STF_1_nTimeframe;
    }

    if(DEBUG_LEVEL >= 2) { console.log("STF_1"); }

    // ----------------------------------------------------------------------
    // STF_1_SMP_Y
    // ----------------------------------------------------------------------
    let smpIndex = 1;
    if (keyValuePairs[`STF_1_SMP_${smpIndex}_strMapping`]) {
      moduleData.symbolAndTimeframe.symbolMappings = [];
    }
    while (keyValuePairs[`STF_1_SMP_${smpIndex}_strMapping`]) {
      const mappingValue = keyValuePairs[`STF_1_SMP_${smpIndex}_strMapping`];
      const parts = mappingValue.split(`;`);
      if (parts.length >= 3) {
        const usageFlags = parts[0];

        const symbolMapping = { ...SymbolAndTimeframeSymbolMappingsDefaults };

        symbolMapping.useLive = usageFlags.includes(`L`);
        symbolMapping.useStrategy = usageFlags.includes(`T`);
        symbolMapping.stringToReplace = parts[1];
        symbolMapping.replacementString = parts[2];

        moduleData.symbolAndTimeframe.symbolMappings.push(symbolMapping);
      }
      smpIndex += 1;
    }

    if(DEBUG_LEVEL >= 2) { console.log("STF_1_SMP_Y"); }

    // ----------------------------------------------------------------------
    // ORM_1
    // ----------------------------------------------------------------------
    if (keyValuePairs.ORM_1_nOperation) {
      moduleData.tradeBasics.nOperation = keyValuePairs.ORM_1_nOperation;
    }
    if (keyValuePairs.ORM_1_nSignalLogic) {
      moduleData.tradeBasics.nSignalLogic = keyValuePairs.ORM_1_nSignalLogic;
    }
    if (keyValuePairs.ORM_1_strSymbol) {
      moduleData.tradeBasics.strSymbol = keyValuePairs.ORM_1_strSymbol === "CURRENT" ? "Current" : keyValuePairs.ORM_1_strSymbol;
    }
    if (keyValuePairs.ORM_1_strExclusion) {
      moduleData.tradeBasics.strExclusion = keyValuePairs.ORM_1_strExclusion;
    }
    if (keyValuePairs.ORM_1_nTimeframe) {
      moduleData.tradeBasics.nTimeframe = keyValuePairs.ORM_1_nTimeframe;
    }
    if (keyValuePairs.ORM_1_nComfortVisualization) {
      moduleData.tradeBasics.nComfortVisualization = keyValuePairs.ORM_1_nComfortVisualization === `1`;
    }
    if (keyValuePairs.ORM_1_nOneTrade) {
      moduleData.tradeBasics.nOneTrade = keyValuePairs.ORM_1_nOneTrade;
    }
    if (keyValuePairs.ORM_1_nNotificationLogs) {
      moduleData.notifications.nNotificationLogs = keyValuePairs.ORM_1_nNotificationLogs === `1`;
    }
    if (keyValuePairs.ORM_1_nNotificationMails) {
      moduleData.notifications.nNotificationMails = keyValuePairs.ORM_1_nNotificationMails === `1`;
    }
    if (keyValuePairs.ORM_1_nNotificationProtection) {
      moduleData.notifications.nNotificationProtection = keyValuePairs.ORM_1_nNotificationProtection === `1`;
    }
    if (keyValuePairs.ORM_1_nNotificationOpen) {
      moduleData.notifications.nNotificationOpen = keyValuePairs.ORM_1_nNotificationOpen === `1`;
    }
    if (keyValuePairs.ORM_1_nNotificationClose) {
      moduleData.notifications.nNotificationClose = keyValuePairs.ORM_1_nNotificationClose === `1`;
    }
    if (keyValuePairs.ORM_1_nNotificationReportDaily) {
      moduleData.notifications.nNotificationReportDaily = keyValuePairs.ORM_1_nNotificationReportDaily === `1`;
    }
    if (keyValuePairs.ORM_1_nNotificationReportWeekly) {
      moduleData.notifications.nNotificationReportWeekly = keyValuePairs.ORM_1_nNotificationReportWeekly === `1`;
    }
    if (keyValuePairs.ORM_1_nNotificationReportMonthly) {
      moduleData.notifications.nNotificationReportMonthly = keyValuePairs.ORM_1_nNotificationReportMonthly === `1`;
    }
    if (keyValuePairs.ORM_1_nNotificationReportEnd) {
      moduleData.notifications.nNotificationReportEnd = keyValuePairs.ORM_1_nNotificationReportEnd === `1`;
    }
    if (keyValuePairs.ORM_1_nMaxSlippage) {
      moduleData.tradeBasics.nMaxSlippage = keyValuePairs.ORM_1_nMaxSlippage;
    }
    if (keyValuePairs.ORM_1_nWaitingBetweenTrades) {
      moduleData.tradeBasics.nWaitingBetweenTrades = keyValuePairs.ORM_1_nWaitingBetweenTrades;
    }
    if (keyValuePairs.ORM_1_nLocalLimits) {
      moduleData.tradeBasics.nLocalLimits = keyValuePairs.ORM_1_nLocalLimits === `1`;
    }
    if (keyValuePairs.ORM_1_nLocalPending) {
      moduleData.pendingOrderSettings.nLocalPending = keyValuePairs.ORM_1_nLocalPending === `1`;
    }

    if(DEBUG_LEVEL >= 2) { console.log("ORM_1"); }

    // ----------------------------------------------------------------------
    // ISL_1
    // ----------------------------------------------------------------------
    if (keyValuePairs.ISL_1_nSelection) {
      moduleData.initialStopLoss.nSelection = keyValuePairs.ISL_1_nSelection;
    }
    if (keyValuePairs.ISL_1_nFixPipsMin) {
      moduleData.initialStopLoss.nFixPipsMin = keyValuePairs.ISL_1_nFixPipsMin;
    }
    if (keyValuePairs.ISL_1_nFixPipsActual) {
      moduleData.initialStopLoss.nFixPipsActual = keyValuePairs.ISL_1_nFixPipsActual;
    }
    if (keyValuePairs.ISL_1_nFixPipsMax) {
      moduleData.initialStopLoss.nFixPipsMax = keyValuePairs.ISL_1_nFixPipsMax;
    }
    if (keyValuePairs.ISL_1_dRateOfChangeMin) {
      moduleData.initialStopLoss.dRateOfChangeMin = parseFromFormattedDigits(keyValuePairs.ISL_1_dRateOfChangeMin);
    }
    if (keyValuePairs.ISL_1_dRateOfChangeActual) {
      moduleData.initialStopLoss.dRateOfChangeActual = parseFromFormattedDigits(keyValuePairs.ISL_1_dRateOfChangeActual);
    }
    if (keyValuePairs.ISL_1_dRateOfChangeMax) {
      moduleData.initialStopLoss.dRateOfChangeMax = parseFromFormattedDigits(keyValuePairs.ISL_1_dRateOfChangeMax);
    }
    if (keyValuePairs.ISL_1_nInosUsedForValueInjection) {
      moduleData.initialStopLoss.nInosUsedForValueInjection = keyValuePairs.ISL_1_nInosUsedForValueInjection !== "0" ? indicatorNumberToId[keyValuePairs.ISL_1_nInosUsedForValueInjection].toString() : "0";
    }
    if (keyValuePairs.ISL_1_nCaSupResUsedForValueInjection) {
      moduleData.initialStopLoss.nCaSupResUsedForValueInjection = keyValuePairs.ISL_1_nCaSupResUsedForValueInjection !== "0" ? chartAnalyzerNumberToId[keyValuePairs.ISL_1_nCaSupResUsedForValueInjection].toString() : "0";
    }

    if (keyValuePairs.ISL_1_bFixPipsMax) {
      moduleData.initialStopLoss.bFixPipsMax = keyValuePairs.ISL_1_bFixPipsMax === `1`;
    }
    else if(keyValuePairs.ISL_1_nFixPipsMax && parseFloat(keyValuePairs.ISL_1_nFixPipsMax) !== 0)
    {
      moduleData.initialStopLoss.bFixPipsMax = true;
    }

    if (keyValuePairs.ISL_1_bFixPipsMin) {
      moduleData.initialStopLoss.bFixPipsMin = keyValuePairs.ISL_1_bFixPipsMin === `1`;
    }
    else if(keyValuePairs.ISL_1_nFixPipsMin && parseFloat(keyValuePairs.ISL_1_nFixPipsMin) !== 0)
    {
      moduleData.initialStopLoss.bFixPipsMin = true;
    }

    if (keyValuePairs.ISL_1_bRateOfChangeMax) {
      moduleData.initialStopLoss.bRateOfChangeMax = keyValuePairs.ISL_1_bRateOfChangeMax === `1`;
    }
    else if(keyValuePairs.ISL_1_dRateOfChangeMax && parseFloat(keyValuePairs.ISL_1_dRateOfChangeMax) !== 0)
    {
      moduleData.initialStopLoss.bRateOfChangeMax = true;
    }

    if (keyValuePairs.ISL_1_bRateOfChangeMin) {
      moduleData.initialStopLoss.bRateOfChangeMin = keyValuePairs.ISL_1_bRateOfChangeMin === `1`;
    }
    else if(keyValuePairs.ISL_1_dRateOfChangeMin && parseFloat(keyValuePairs.ISL_1_dRateOfChangeMin) !== 0)
    {
      moduleData.initialStopLoss.bRateOfChangeMin = true;
    }

    if(DEBUG_LEVEL >= 2) { console.log("ISL_1"); }

    // ----------------------------------------------------------------------
    // SLT_X
    // ----------------------------------------------------------------------
    let sltIndex = 1;
    while (keyValuePairs[`SLT_${sltIndex}_nType`]) {

      const config = { ...StopLossTrailingsDefaults };

      if (keyValuePairs[`SLT_${sltIndex}_nType`]) {
        config.nType = keyValuePairs[`SLT_${sltIndex}_nType`];
      }
      if (keyValuePairs[`SLT_${sltIndex}_nChangePosition`]) {
        config.nChangePosition = keyValuePairs[`SLT_${sltIndex}_nChangePosition`];
      }
      if (keyValuePairs[`SLT_${sltIndex}_nBreakevenPosition`]) {
        config.nBreakevenPosition = keyValuePairs[`SLT_${sltIndex}_nBreakevenPosition`];
      }
      if (keyValuePairs[`SLT_${sltIndex}_nMarketBufferFix`]) {
        config.nMarketBufferFix = keyValuePairs[`SLT_${sltIndex}_nMarketBufferFix`];
      }
      if (keyValuePairs[`SLT_${sltIndex}_dMarketBufferSpread`]) {
        config.dMarketBufferSpread = parseFromFormattedDigits(keyValuePairs[`SLT_${sltIndex}_dMarketBufferSpread`]);
      }
      if (keyValuePairs[`SLT_${sltIndex}_nStepsSize`]) {
        config.nStepsSize = keyValuePairs[`SLT_${sltIndex}_nStepsSize`];
      }
      if (keyValuePairs[`SLT_${sltIndex}_nStepsPosition`]) {
        config.nStepsPosition = keyValuePairs[`SLT_${sltIndex}_nStepsPosition`];
      }
      if (keyValuePairs[`SLT_${sltIndex}_nTimeCount`]) {
        config.nTimeCount = keyValuePairs[`SLT_${sltIndex}_nTimeCount`];
      }
      if (keyValuePairs[`SLT_${sltIndex}_nLinearStep`]) {
        config.nLinearStep = keyValuePairs[`SLT_${sltIndex}_nLinearStep`];
      }
      if (keyValuePairs[`SLT_${sltIndex}_nChangingDifference`]) {
        config.nChangingDifference = keyValuePairs[`SLT_${sltIndex}_nChangingDifference`];
      }
      if (keyValuePairs[`SLT_${sltIndex}_nHiLoPeriod`]) {
        config.nHiLoPeriod = keyValuePairs[`SLT_${sltIndex}_nHiLoPeriod`];
      }
      if (keyValuePairs[`SLT_${sltIndex}_nCaSupResFixPipsMin`]) {
        config.nCaSupResFixPipsMin = keyValuePairs[`SLT_${sltIndex}_nCaSupResFixPipsMin`];
      }
      if (keyValuePairs[`SLT_${sltIndex}_nCaSupResFixPipsMax`]) {
        config.nCaSupResFixPipsMax = keyValuePairs[`SLT_${sltIndex}_nCaSupResFixPipsMax`];
      }
      if (keyValuePairs[`SLT_${sltIndex}_dCaSupResRateOfChangeMin`]) {
        config.dCaSupResRateOfChangeMin = parseFromFormattedDigits(keyValuePairs[`SLT_${sltIndex}_dCaSupResRateOfChangeMin`]);
      }
      if (keyValuePairs[`SLT_${sltIndex}_dCaSupResRateOfChangeMax`]) {
        config.dCaSupResRateOfChangeMax = parseFromFormattedDigits(keyValuePairs[`SLT_${sltIndex}_dCaSupResRateOfChangeMax`]);
      }
      if (keyValuePairs[`SLT_${sltIndex}_nInosUsedForValueInjection`]) {
        config.nInosUsedForValueInjection = keyValuePairs[`SLT_${sltIndex}_nInosUsedForValueInjection`] !== "0" ? indicatorNumberToId[keyValuePairs[`SLT_${sltIndex}_nInosUsedForValueInjection`]].toString() : "0";
      }
      if (keyValuePairs[`SLT_${sltIndex}_nCaSupResUsedForValueInjection`]) {
        config.nCaSupResUsedForValueInjection = keyValuePairs[`SLT_${sltIndex}_nCaSupResUsedForValueInjection`] !== "0" ? chartAnalyzerNumberToId[keyValuePairs[`SLT_${sltIndex}_nCaSupResUsedForValueInjection`]].toString() : "0";
      }

      if (keyValuePairs[`SLT_${sltIndex}_bCaSupResFixPipsMin`]) {
        config.bCaSupResFixPipsMin = keyValuePairs[`SLT_${sltIndex}_bCaSupResFixPipsMin`] === `1`;
      }
      else if(keyValuePairs[`SLT_${sltIndex}_nCaSupResFixPipsMin`] && parseFloat(keyValuePairs[`SLT_${sltIndex}_nCaSupResFixPipsMin`]) !== 0)
      {
        config.bCaSupResFixPipsMin = true;
      }
      if (keyValuePairs[`SLT_${sltIndex}_bCaSupResFixPipsMax`]) {
        config.bCaSupResFixPipsMax = keyValuePairs[`SLT_${sltIndex}_bCaSupResFixPipsMax`] === `1`;
      }
      else if(keyValuePairs[`SLT_${sltIndex}_nCaSupResFixPipsMax`] && parseFloat(keyValuePairs[`SLT_${sltIndex}_nCaSupResFixPipsMax`]) !== 0)
      {
        config.bCaSupResFixPipsMax = true;
      }
      if (keyValuePairs[`SLT_${sltIndex}_bCaSupResRateOfChangeMin`]) {
        config.bCaSupResRateOfChangeMin = keyValuePairs[`SLT_${sltIndex}_bCaSupResRateOfChangeMin`] === `1`;
      }
      else if(keyValuePairs[`SLT_${sltIndex}_nCaSupResRateOfChangeMin`] && parseFloat(keyValuePairs[`SLT_${sltIndex}_nCaSupResRateOfChangeMin`]) !== 0)
      {
        config.bCaSupResRateOfChangeMin = true;
      }
      if (keyValuePairs[`SLT_${sltIndex}_bCaSupResRateOfChangeMax`]) {
        config.bCaSupResRateOfChangeMax = keyValuePairs[`SLT_${sltIndex}_bCaSupResRateOfChangeMax`] === `1`;
      }
      else if(keyValuePairs[`SLT_${sltIndex}_nCaSupResRateOfChangeMax`] && parseFloat(keyValuePairs[`SLT_${sltIndex}_nCaSupResRateOfChangeMax`]) !== 0)
      {
        config.bCaSupResRateOfChangeMax = true;
      }

      const name = stlGetTypeDisplay(config.nType);
      const subtitle = `Activation position: ${config.nChangePosition}`;

      // Generate unique ID
      let id = now + sltIndex;
      if(keyValuePairs[`SLT_${sltIndex}_nId`])
      {
        id = keyValuePairs[`SLT_${sltIndex}_nId`];
      }
      const stopLossTrailing = {
        id: parseInt(id, 10),
        name,
        subtitle,
        isNewlyCreated: false,
        config,
      };
      moduleData.stopLossTrailings.push(stopLossTrailing);
      sltIndex += 1;

      if(DEBUG_LEVEL >= 2) { console.log("SLT_X"); }
    }

    // ----------------------------------------------------------------------
    // ITP_1
    // ----------------------------------------------------------------------
    if (keyValuePairs.ITP_1_nSelection) {
      moduleData.initialTakeProfit.nSelection = keyValuePairs.ITP_1_nSelection;
    }
    if (keyValuePairs.ITP_1_dRiskRatio) {
      moduleData.initialTakeProfit.dRiskRatio = parseFromFormattedDigits(keyValuePairs.ITP_1_dRiskRatio);
    }
    if (keyValuePairs.ITP_1_nFixPipsMin) {
      moduleData.initialTakeProfit.nFixPipsMin = keyValuePairs.ITP_1_nFixPipsMin;
    }
    if (keyValuePairs.ITP_1_nFixPipsActual) {
      moduleData.initialTakeProfit.nFixPipsActual = keyValuePairs.ITP_1_nFixPipsActual;
    }
    if (keyValuePairs.ITP_1_nFixPipsMax) {
      moduleData.initialTakeProfit.nFixPipsMax = keyValuePairs.ITP_1_nFixPipsMax;
    }
    if (keyValuePairs.ITP_1_dRateOfChangeMin) {
      moduleData.initialTakeProfit.dRateOfChangeMin = parseFromFormattedDigits(keyValuePairs.ITP_1_dRateOfChangeMin);
    }
    if (keyValuePairs.ITP_1_dRateOfChangeActual) {
      moduleData.initialTakeProfit.dRateOfChangeActual = parseFromFormattedDigits(keyValuePairs.ITP_1_dRateOfChangeActual);
    }
    if (keyValuePairs.ITP_1_dRateOfChangeMax) {
      moduleData.initialTakeProfit.dRateOfChangeMax = parseFromFormattedDigits(keyValuePairs.ITP_1_dRateOfChangeMax);
    }
    if (keyValuePairs.ITP_1_nInosUsedForValueInjection) {
      moduleData.initialTakeProfit.nInosUsedForValueInjection = keyValuePairs.ITP_1_nInosUsedForValueInjection !== "0" ? indicatorNumberToId[keyValuePairs.ITP_1_nInosUsedForValueInjection].toString() : "0";
    }
    if (keyValuePairs.ITP_1_nCaSupResUsedForValueInjection) {
      moduleData.initialTakeProfit.nCaSupResUsedForValueInjection = keyValuePairs.ITP_1_nCaSupResUsedForValueInjection !== "0" ? chartAnalyzerNumberToId[keyValuePairs.ITP_1_nCaSupResUsedForValueInjection].toString() : "0";
    }
    if (keyValuePairs.ITP_1_bFixPipsMax) {
      moduleData.initialTakeProfit.bFixPipsMax = keyValuePairs.ITP_1_bFixPipsMax === `1`;
    }
    else if(keyValuePairs.ITP_1_nFixPipsMax && parseFloat(keyValuePairs.ITP_1_nFixPipsMax) !== 0)
    {
      moduleData.initialTakeProfit.bFixPipsMax = true;
    }

    if (keyValuePairs.ITP_1_bFixPipsMin) {
      moduleData.initialTakeProfit.bFixPipsMin = keyValuePairs.ITP_1_bFixPipsMin === `1`;
    }
    else if(keyValuePairs.ITP_1_nFixPipsMin && parseFloat(keyValuePairs.ITP_1_nFixPipsMin) !== 0)
    {
      moduleData.initialTakeProfit.bFixPipsMin = true;
    }

    if (keyValuePairs.ITP_1_bRateOfChangeMax) {
      moduleData.initialTakeProfit.bRateOfChangeMax = keyValuePairs.ITP_1_bRateOfChangeMax === `1`;
    }
    else if(keyValuePairs.ITP_1_dRateOfChangeMax && parseFloat(keyValuePairs.ITP_1_dRateOfChangeMax) !== 0)
    {
      moduleData.initialTakeProfit.bRateOfChangeMax = true;
    }

    if (keyValuePairs.ITP_1_bRateOfChangeMin) {
      moduleData.initialTakeProfit.bRateOfChangeMin = keyValuePairs.ITP_1_bRateOfChangeMin === `1`;
    }
    else if(keyValuePairs.ITP_1_dRateOfChangeMin && parseFloat(keyValuePairs.ITP_1_dRateOfChangeMin) !== 0)
    {
      moduleData.initialTakeProfit.bRateOfChangeMin = true;
    }

    if(DEBUG_LEVEL >= 2) { console.log("ITP_1"); }

    // ----------------------------------------------------------------------
    // TPD_X
    // ----------------------------------------------------------------------
    let tpdIndex = 1;
    while (keyValuePairs[`TPD_${tpdIndex}_nType`]) {

      const config = { ...TakeProfitDynamicsDefaults };

      if (keyValuePairs[`TPD_${tpdIndex}_nType`]) {
        config.nType = keyValuePairs[`TPD_${tpdIndex}_nType`];
      }
      if (keyValuePairs[`TPD_${tpdIndex}_nChangePosition`]) {
        config.nChangePosition = keyValuePairs[`TPD_${tpdIndex}_nChangePosition`];
      }
      if (keyValuePairs[`TPD_${tpdIndex}_nLinearStep`]) {
        config.nLinearStep = keyValuePairs[`TPD_${tpdIndex}_nLinearStep`];
      }
      if (keyValuePairs[`TPD_${tpdIndex}_nMarketBarsMax`]) {
        config.nMarketBarsMax = keyValuePairs[`TPD_${tpdIndex}_nMarketBarsMax`];
      }
      if (keyValuePairs[`TPD_${tpdIndex}_nMarketM1`]) {
        config.nMarketM1 = keyValuePairs[`TPD_${tpdIndex}_nMarketM1`];
      }
      if (keyValuePairs[`TPD_${tpdIndex}_nMarketM2`]) {
        config.nMarketM2 = keyValuePairs[`TPD_${tpdIndex}_nMarketM2`];
      }
      if (keyValuePairs[`TPD_${tpdIndex}_nMarketEnd`]) {
        config.nMarketEnd = keyValuePairs[`TPD_${tpdIndex}_nMarketEnd`];
      }
      if (keyValuePairs[`TPD_${tpdIndex}_nChangingDifference`]) {
        config.nChangingDifference = keyValuePairs[`TPD_${tpdIndex}_nChangingDifference`];
      }

      if (keyValuePairs[`TPD_${tpdIndex}_nCaSupResFixPipsMin`]) {
        config.nCaSupResFixPipsMin = keyValuePairs[`TPD_${tpdIndex}_nCaSupResFixPipsMin`];
      }
      if (keyValuePairs[`TPD_${tpdIndex}_nCaSupResFixPipsMax`]) {
        config.nCaSupResFixPipsMax = keyValuePairs[`TPD_${tpdIndex}_nCaSupResFixPipsMax`];
      }
      if (keyValuePairs[`TPD_${tpdIndex}_dCaSupResRateOfChangeMin`]) {
        config.dCaSupResRateOfChangeMin = parseFromFormattedDigits(keyValuePairs[`TPD_${tpdIndex}_dCaSupResRateOfChangeMin`]);
      }
      if (keyValuePairs[`TPD_${tpdIndex}_dCaSupResRateOfChangeMax`]) {
        config.dCaSupResRateOfChangeMax = parseFromFormattedDigits(keyValuePairs[`TPD_${tpdIndex}_dCaSupResRateOfChangeMax`]);
      }
      
      if (keyValuePairs[`TPD_${tpdIndex}_bCaSupResFixPipsMin`]) {
        config.bCaSupResFixPipsMin = keyValuePairs[`TPD_${tpdIndex}_bCaSupResFixPipsMin`] === `1`;
      }
      else if(keyValuePairs[`TPD_${tpdIndex}_nCaSupResFixPipsMin`] && parseFloat(keyValuePairs[`TPD_${tpdIndex}_nCaSupResFixPipsMin`]) !== 0)
      {
        config.bCaSupResFixPipsMin = true;
      }
      if (keyValuePairs[`TPD_${tpdIndex}_bCaSupResFixPipsMax`]) {
        config.bCaSupResFixPipsMax = keyValuePairs[`TPD_${tpdIndex}_bCaSupResFixPipsMax`] === `1`;
      }
      else if(keyValuePairs[`TPD_${tpdIndex}_nCaSupResFixPipsMax`] && parseFloat(keyValuePairs[`TPD_${tpdIndex}_nCaSupResFixPipsMax`]) !== 0)
      {
        config.bCaSupResFixPipsMax = true;
      }
      if (keyValuePairs[`TPD_${tpdIndex}_bCaSupResRateOfChangeMin`]) {
        config.bCaSupResRateOfChangeMin = keyValuePairs[`TPD_${tpdIndex}_bCaSupResRateOfChangeMin`] === `1`;
      }
      else if(keyValuePairs[`TPD_${tpdIndex}_nCaSupResRateOfChangeMin`] && parseFloat(keyValuePairs[`TPD_${tpdIndex}_nCaSupResRateOfChangeMin`]) !== 0)
      {
        config.bCaSupResRateOfChangeMin = true;
      }
      if (keyValuePairs[`TPD_${tpdIndex}_bCaSupResRateOfChangeMax`]) {
        config.bCaSupResRateOfChangeMax = keyValuePairs[`TPD_${tpdIndex}_bCaSupResRateOfChangeMax`] === `1`;
      }
      else if(keyValuePairs[`TPD_${tpdIndex}_nCaSupResRateOfChangeMax`] && parseFloat(keyValuePairs[`TPD_${tpdIndex}_nCaSupResRateOfChangeMax`]) !== 0)
      {
        config.bCaSupResRateOfChangeMax = true;
      }

      if (keyValuePairs[`TPD_${tpdIndex}_nInosUsedForValueInjection`]) {
        config.nInosUsedForValueInjection = keyValuePairs[`TPD_${tpdIndex}_nInosUsedForValueInjection`] !== "0" ? indicatorNumberToId[keyValuePairs[`TPD_${tpdIndex}_nInosUsedForValueInjection`]].toString() : "0";
      }
      if (keyValuePairs[`TPD_${tpdIndex}_nCaSupResUsedForValueInjection`]) {
        config.nCaSupResUsedForValueInjection = keyValuePairs[`TPD_${tpdIndex}_nCaSupResUsedForValueInjection`] !== "0" ? chartAnalyzerNumberToId[keyValuePairs[`TPD_${tpdIndex}_nCaSupResUsedForValueInjection`]].toString() : "0";
      }
      
      const name = tpdGetTypeDisplay(config.nType);
      const subtitle = `Activation position: ${config.nChangePosition}`;

      // Generate unique ID
      let id = now + tpdIndex;
      if(keyValuePairs[`TPD_${tpdIndex}_nId`])
      {
        id = keyValuePairs[`TPD_${tpdIndex}_nId`];
      }
      const takeProfitDynamic = {
        id: parseInt(id, 10),
        name,
        subtitle,
        isNewlyCreated: false,
        config,
      };
      moduleData.takeProfitDynamics.push(takeProfitDynamic);
      tpdIndex += 1;

      if(DEBUG_LEVEL >= 2) { console.log("TPD_X"); }
    }

    // ----------------------------------------------------------------------
    // PEO_1
    // ----------------------------------------------------------------------
    if (keyValuePairs.PEO_1_nMode) {
      moduleData.pendingOrderSettings.nMode = keyValuePairs.PEO_1_nMode;
    }
    if (keyValuePairs.PEO_1_nPrice) {
      moduleData.pendingOrderSettings.nPrice = keyValuePairs.PEO_1_nPrice;
      moduleData.tradeBasics.nPrice = keyValuePairs.PEO_1_nPrice;
    }
    if (keyValuePairs.PEO_1_nLimits) {
      moduleData.pendingOrderSettings.nLimits = keyValuePairs.PEO_1_nLimits;
      moduleData.tradeBasics.nLimits = keyValuePairs.PEO_1_nLimits;
    }
    if (keyValuePairs.PEO_1_nReference) {
      moduleData.pendingOrderSettings.nReference = keyValuePairs.PEO_1_nReference;
    }
    if (keyValuePairs.PEO_1_nExpiration) {
      moduleData.pendingOrderSettings.nExpiration = keyValuePairs.PEO_1_nExpiration;
      moduleData.tradeBasics.nExpiration = keyValuePairs.PEO_1_nExpiration;
    }
    if (keyValuePairs.PEO_1_bHysteresisMin) {
      moduleData.pendingOrderSettings.bHysteresisMin = keyValuePairs.PEO_1_bHysteresisMin === `1`;
    }
    else if(keyValuePairs.PEO_1_nHysteresisMin && parseFloat(keyValuePairs.PEO_1_nHysteresisMin) !== 0)
    {
      moduleData.pendingOrderSettings.bHysteresisMin = true;
    }
    if (keyValuePairs.PEO_1_nHysteresisMin) {
      moduleData.pendingOrderSettings.nHysteresisMin = keyValuePairs.PEO_1_nHysteresisMin;
    }
    if (keyValuePairs.PEO_1_bHysteresisMax) {
      moduleData.pendingOrderSettings.bHysteresisMax = keyValuePairs.PEO_1_bHysteresisMax === `1`;
    }
    else if(keyValuePairs.PEO_1_nHysteresisMax && parseFloat(keyValuePairs.PEO_1_nHysteresisMax) !== 0)
    {
      moduleData.pendingOrderSettings.bHysteresisMax = true;
    }
    if (keyValuePairs.PEO_1_nHysteresisMax) {
      moduleData.pendingOrderSettings.nHysteresisMax = keyValuePairs.PEO_1_nHysteresisMax;
    }
    if (keyValuePairs.PEO_1_bFixPipsMin) {
      moduleData.pendingOrderSettings.bFixPipsMin = keyValuePairs.PEO_1_bFixPipsMin === `1`;
    }
    else if(keyValuePairs.PEO_1_nFixPipsMin && parseFloat(keyValuePairs.PEO_1_nFixPipsMin) !== 0)
    {
      moduleData.pendingOrderSettings.bFixPipsMin = true;
    }
    if (keyValuePairs.PEO_1_nFixPipsMin) {
      moduleData.pendingOrderSettings.nFixPipsMin = keyValuePairs.PEO_1_nFixPipsMin;
    }
    if (keyValuePairs.PEO_1_nFixPipsActual) {
      moduleData.pendingOrderSettings.nFixPipsActual = keyValuePairs.PEO_1_nFixPipsActual;
      moduleData.tradeBasics.nFixPipsActual = keyValuePairs.PEO_1_nFixPipsActual;
    }
    if (keyValuePairs.PEO_1_bFixPipsMax) {
      moduleData.pendingOrderSettings.bFixPipsMax = keyValuePairs.PEO_1_bFixPipsMax === `1`;
    }
    else if(keyValuePairs.PEO_1_nFixPipsMax && parseFloat(keyValuePairs.PEO_1_nFixPipsMax) !== 0)
    {
      moduleData.pendingOrderSettings.bFixPipsMax = true;
    }
    if (keyValuePairs.PEO_1_nFixPipsMax) {
      moduleData.pendingOrderSettings.nFixPipsMax = keyValuePairs.PEO_1_nFixPipsMax;
    }
    if (keyValuePairs.PEO_1_bRateOfChangeMin) {
      moduleData.pendingOrderSettings.bRateOfChangeMin = keyValuePairs.PEO_1_bRateOfChangeMin === `1`;
    }
    else if(keyValuePairs.PEO_1_dRateOfChangeMin && parseFloat(keyValuePairs.PEO_1_dRateOfChangeMin) !== 0)
    {
      moduleData.pendingOrderSettings.bRateOfChangeMin = true;
    }
    if (keyValuePairs.PEO_1_dRateOfChangeMin) {
      moduleData.pendingOrderSettings.dRateOfChangeMin = parseFromFormattedDigits(keyValuePairs.PEO_1_dRateOfChangeMin);
    }
    if (keyValuePairs.PEO_1_dRateOfChangeActual) {
      moduleData.pendingOrderSettings.dRateOfChangeActual = parseFromFormattedDigits(keyValuePairs.PEO_1_dRateOfChangeActual);
      moduleData.tradeBasics.dRateOfChangeActual = parseFromFormattedDigits(keyValuePairs.PEO_1_dRateOfChangeActual);
    }
    if (keyValuePairs.PEO_1_bRateOfChangeMax) {
      moduleData.pendingOrderSettings.bRateOfChangeMax = keyValuePairs.PEO_1_bRateOfChangeMax === `1`;
    }
    else if(keyValuePairs.PEO_1_dRateOfChangeMax && parseFloat(keyValuePairs.PEO_1_dRateOfChangeMax) !== 0)
    {
      moduleData.pendingOrderSettings.bRateOfChangeMax = true;
    }
    if (keyValuePairs.PEO_1_dRateOfChangeMax) {
      moduleData.pendingOrderSettings.dRateOfChangeMax = parseFromFormattedDigits(keyValuePairs.PEO_1_dRateOfChangeMax);
    }
    if (keyValuePairs.PEO_1_nInosUsedForValueInjection) {
      moduleData.pendingOrderSettings.nInosUsedForValueInjection = keyValuePairs.PEO_1_nInosUsedForValueInjection !== "0" ? indicatorNumberToId[keyValuePairs.PEO_1_nInosUsedForValueInjection].toString() : "0";
    }
    if (keyValuePairs.PEO_1_nCaSupResUsedForValueInjection) {
      moduleData.pendingOrderSettings.nCaSupResUsedForValueInjection = keyValuePairs.PEO_1_nCaSupResUsedForValueInjection !== "0" ? chartAnalyzerNumberToId[keyValuePairs.PEO_1_nCaSupResUsedForValueInjection].toString() : "0";
    }

    if (keyValuePairs.ORM_1_nOperation === "0" || keyValuePairs.ORM_1_nOperation === "2") {
      // buy operations
      switch (keyValuePairs.PEO_1_nMode) {
        case "0":
          moduleData.tradeBasics.nOrderType = "0"; // buy
          break;
        case "1":
          moduleData.tradeBasics.nOrderType = "2"; // buy stop
          break;
        case "2":
          moduleData.tradeBasics.nOrderType = "1"; // buy limit
          break;
        default:
          break;
      }
    } else if (keyValuePairs.ORM_1_nOperation === "1" || keyValuePairs.ORM_1_nOperation === "3") {
      // sell operations
      switch (keyValuePairs.PEO_1_nMode) {
        case "0":
          moduleData.tradeBasics.nOrderType = "3"; // sell
          break;
        case "1":
          moduleData.tradeBasics.nOrderType = "5"; // sell stop
          break;
        case "2":
          moduleData.tradeBasics.nOrderType = "4"; // sell limit
          break;
        default:
          break;
      }
    }

    if(DEBUG_LEVEL >= 2) { console.log("PEO_1"); }

    // ----------------------------------------------------------------------
    // ISP_1
    // ----------------------------------------------------------------------
    if (keyValuePairs.ISP_1_nDrawInspectorPanel) {
      moduleData.monitoring.nDrawInspectorPanel = keyValuePairs.ISP_1_nDrawInspectorPanel === `1`;
    }
    if (keyValuePairs.ISP_1_bPerformanceDayAbsMin) {
      moduleData.monitoring.bPerformanceDayAbsMin = keyValuePairs.ISP_1_bPerformanceDayAbsMin === `1`;
    }
    else if(keyValuePairs.ISP_1_dPerformanceDayAbsMin && parseFloat(keyValuePairs.ISP_1_dPerformanceDayAbsMin) !== 0)
    {
      moduleData.monitoring.bPerformanceDayAbsMin = true;
    }
    if (keyValuePairs.ISP_1_dPerformanceDayAbsMin) {
      moduleData.monitoring.dPerformanceDayAbsMin = parseFromFormattedDigits(keyValuePairs.ISP_1_dPerformanceDayAbsMin);
    }
    if (keyValuePairs.ISP_1_bPerformanceDayAbsMax) {
      moduleData.monitoring.bPerformanceDayAbsMax = keyValuePairs.ISP_1_bPerformanceDayAbsMax === `1`;
    }
    else if(keyValuePairs.ISP_1_dPerformanceDayAbsMax && parseFloat(keyValuePairs.ISP_1_dPerformanceDayAbsMax) !== 0)
    {
      moduleData.monitoring.bPerformanceDayAbsMax = true;
    }
    if (keyValuePairs.ISP_1_dPerformanceDayAbsMax) {
      moduleData.monitoring.dPerformanceDayAbsMax = parseFromFormattedDigits(keyValuePairs.ISP_1_dPerformanceDayAbsMax);
    }
    if (keyValuePairs.ISP_1_bPerformanceDayRelMin) {
      moduleData.monitoring.bPerformanceDayRelMin = keyValuePairs.ISP_1_bPerformanceDayRelMin === `1`;
    }
    else if(keyValuePairs.ISP_1_dPerformanceDayRelMin && parseFloat(keyValuePairs.ISP_1_dPerformanceDayRelMin) !== 0)
    {
      moduleData.monitoring.bPerformanceDayRelMin = true;
    }
    if (keyValuePairs.ISP_1_dPerformanceDayRelMin) {
      moduleData.monitoring.dPerformanceDayRelMin = parseFromFormattedDigits(keyValuePairs.ISP_1_dPerformanceDayRelMin);
    }
    if (keyValuePairs.ISP_1_bPerformanceDayRelMax) {
      moduleData.monitoring.bPerformanceDayRelMax = keyValuePairs.ISP_1_bPerformanceDayRelMax === `1`;
    }
    else if(keyValuePairs.ISP_1_dPerformanceDayRelMax && parseFloat(keyValuePairs.ISP_1_dPerformanceDayRelMax) !== 0)
    {
      moduleData.monitoring.bPerformanceDayRelMax = true;
    }
    if (keyValuePairs.ISP_1_dPerformanceDayRelMax) {
      moduleData.monitoring.dPerformanceDayRelMax = parseFromFormattedDigits(keyValuePairs.ISP_1_dPerformanceDayRelMax);
    }
    if (keyValuePairs.ISP_1_bPerformanceWeekAbsMin) {
      moduleData.monitoring.bPerformanceWeekAbsMin = keyValuePairs.ISP_1_bPerformanceWeekAbsMin === `1`;
    }
    else if(keyValuePairs.ISP_1_dPerformanceWeekAbsMin && parseFloat(keyValuePairs.ISP_1_dPerformanceWeekAbsMin) !== 0)
    {
      moduleData.monitoring.bPerformanceWeekAbsMin = true;
    }
    if (keyValuePairs.ISP_1_dPerformanceWeekAbsMin) {
      moduleData.monitoring.dPerformanceWeekAbsMin = parseFromFormattedDigits(keyValuePairs.ISP_1_dPerformanceWeekAbsMin);
    }
    if (keyValuePairs.ISP_1_bPerformanceWeekAbsMax) {
      moduleData.monitoring.bPerformanceWeekAbsMax = keyValuePairs.ISP_1_bPerformanceWeekAbsMax === `1`;
    }
    else if(keyValuePairs.ISP_1_dPerformanceWeekAbsMax && parseFloat(keyValuePairs.ISP_1_dPerformanceWeekAbsMax) !== 0)
    {
      moduleData.monitoring.bPerformanceWeekAbsMax = true;
    }
    if (keyValuePairs.ISP_1_dPerformanceWeekAbsMax) {
      moduleData.monitoring.dPerformanceWeekAbsMax = parseFromFormattedDigits(keyValuePairs.ISP_1_dPerformanceWeekAbsMax);
    }
    if (keyValuePairs.ISP_1_bPerformanceWeekRelMin) {
      moduleData.monitoring.bPerformanceWeekRelMin = keyValuePairs.ISP_1_bPerformanceWeekRelMin === `1`;
    }
    else if(keyValuePairs.ISP_1_dPerformanceWeekRelMin && parseFloat(keyValuePairs.ISP_1_dPerformanceWeekRelMin) !== 0)
    {
      moduleData.monitoring.bPerformanceWeekRelMin = true;
    }
    if (keyValuePairs.ISP_1_dPerformanceWeekRelMin) {
      moduleData.monitoring.dPerformanceWeekRelMin = parseFromFormattedDigits(keyValuePairs.ISP_1_dPerformanceWeekRelMin);
    }
    if (keyValuePairs.ISP_1_bPerformanceWeekRelMax) {
      moduleData.monitoring.bPerformanceWeekRelMax = keyValuePairs.ISP_1_bPerformanceWeekRelMax === `1`;
    }
    else if(keyValuePairs.ISP_1_dPerformanceWeekRelMax && parseFloat(keyValuePairs.ISP_1_dPerformanceWeekRelMax) !== 0)
    {
      moduleData.monitoring.bPerformanceWeekRelMax = true;
    }
    if (keyValuePairs.ISP_1_dPerformanceWeekRelMax) {
      moduleData.monitoring.dPerformanceWeekRelMax = parseFromFormattedDigits(keyValuePairs.ISP_1_dPerformanceWeekRelMax);
    }
    if (keyValuePairs.ISP_1_bPerformanceMonthAbsMin) {
      moduleData.monitoring.bPerformanceMonthAbsMin = keyValuePairs.ISP_1_bPerformanceMonthAbsMin === `1`;
    }
    else if(keyValuePairs.ISP_1_dPerformanceMonthAbsMin && parseFloat(keyValuePairs.ISP_1_dPerformanceMonthAbsMin) !== 0)
    {
      moduleData.monitoring.bPerformanceMonthAbsMin = true;
    }
    if (keyValuePairs.ISP_1_dPerformanceMonthAbsMin) {
      moduleData.monitoring.dPerformanceMonthAbsMin = parseFromFormattedDigits(keyValuePairs.ISP_1_dPerformanceMonthAbsMin);
    }
    if (keyValuePairs.ISP_1_bPerformanceMonthAbsMax) {
      moduleData.monitoring.bPerformanceMonthAbsMax = keyValuePairs.ISP_1_bPerformanceMonthAbsMax === `1`;
    }
    else if(keyValuePairs.ISP_1_dPerformanceMonthAbsMax && parseFloat(keyValuePairs.ISP_1_dPerformanceMonthAbsMax) !== 0)
    {
      moduleData.monitoring.bPerformanceMonthAbsMax = true;
    }
    if (keyValuePairs.ISP_1_dPerformanceMonthAbsMax) {
      moduleData.monitoring.dPerformanceMonthAbsMax = parseFromFormattedDigits(keyValuePairs.ISP_1_dPerformanceMonthAbsMax);
    }
    if (keyValuePairs.ISP_1_bPerformanceMonthRelMin) {
      moduleData.monitoring.bPerformanceMonthRelMin = keyValuePairs.ISP_1_bPerformanceMonthRelMin === `1`;
    }
    else if(keyValuePairs.ISP_1_dPerformanceMonthRelMin && parseFloat(keyValuePairs.ISP_1_dPerformanceMonthRelMin) !== 0)
    {
      moduleData.monitoring.bPerformanceMonthRelMin = true;
    }
    if (keyValuePairs.ISP_1_dPerformanceMonthRelMin) {
      moduleData.monitoring.dPerformanceMonthRelMin = parseFromFormattedDigits(keyValuePairs.ISP_1_dPerformanceMonthRelMin);
    }
    if (keyValuePairs.ISP_1_bPerformanceMonthRelMax) {
      moduleData.monitoring.bPerformanceMonthRelMax = keyValuePairs.ISP_1_bPerformanceMonthRelMax === `1`;
    }
    else if(keyValuePairs.ISP_1_dPerformanceMonthRelMax && parseFloat(keyValuePairs.ISP_1_dPerformanceMonthRelMax) !== 0)
    {
      moduleData.monitoring.bPerformanceMonthRelMax = true;
    }
    if (keyValuePairs.ISP_1_dPerformanceMonthRelMax) {
      moduleData.monitoring.dPerformanceMonthRelMax = parseFromFormattedDigits(keyValuePairs.ISP_1_dPerformanceMonthRelMax);
    }
    if (keyValuePairs.ISP_1_bPerformanceYearAbsMin) {
      moduleData.monitoring.bPerformanceYearAbsMin = keyValuePairs.ISP_1_bPerformanceYearAbsMin === `1`;
    }
    else if(keyValuePairs.ISP_1_dPerformanceYearAbsMin && parseFloat(keyValuePairs.ISP_1_dPerformanceYearAbsMin) !== 0)
    {
      moduleData.monitoring.bPerformanceYearAbsMin = true;
    }
    if (keyValuePairs.ISP_1_dPerformanceYearAbsMin) {
      moduleData.monitoring.dPerformanceYearAbsMin = parseFromFormattedDigits(keyValuePairs.ISP_1_dPerformanceYearAbsMin);
    }
    if (keyValuePairs.ISP_1_bPerformanceYearAbsMax) {
      moduleData.monitoring.bPerformanceYearAbsMax = keyValuePairs.ISP_1_bPerformanceYearAbsMax === `1`;
    }
    else if(keyValuePairs.ISP_1_dPerformanceYearAbsMax && parseFloat(keyValuePairs.ISP_1_dPerformanceYearAbsMax) !== 0)
    {
      moduleData.monitoring.bPerformanceYearAbsMax = true;
    }
    if (keyValuePairs.ISP_1_dPerformanceYearAbsMax) {
      moduleData.monitoring.dPerformanceYearAbsMax = parseFromFormattedDigits(keyValuePairs.ISP_1_dPerformanceYearAbsMax);
    }
    if (keyValuePairs.ISP_1_bPerformanceYearRelMin) {
      moduleData.monitoring.bPerformanceYearRelMin = keyValuePairs.ISP_1_bPerformanceYearRelMin === `1`;
    }
    else if(keyValuePairs.ISP_1_dPerformanceYearRelMin && parseFloat(keyValuePairs.ISP_1_dPerformanceYearRelMin) !== 0)
    {
      moduleData.monitoring.bPerformanceYearRelMin = true;
    }
    if (keyValuePairs.ISP_1_dPerformanceYearRelMin) {
      moduleData.monitoring.dPerformanceYearRelMin = parseFromFormattedDigits(keyValuePairs.ISP_1_dPerformanceYearRelMin);
    }
    if (keyValuePairs.ISP_1_bPerformanceYearRelMax) {
      moduleData.monitoring.bPerformanceYearRelMax = keyValuePairs.ISP_1_bPerformanceYearRelMax === `1`;
    }
    else if(keyValuePairs.ISP_1_dPerformanceYearRelMax && parseFloat(keyValuePairs.ISP_1_dPerformanceYearRelMax) !== 0)
    {
      moduleData.monitoring.bPerformanceYearRelMax = true;
    }
    if (keyValuePairs.ISP_1_dPerformanceYearRelMax) {
      moduleData.monitoring.dPerformanceYearRelMax = parseFromFormattedDigits(keyValuePairs.ISP_1_dPerformanceYearRelMax);
    }
    if (keyValuePairs.ISP_1_bPerformanceSinceStartAbsMin) {
      moduleData.monitoring.bPerformanceSinceStartAbsMin = keyValuePairs.ISP_1_bPerformanceSinceStartAbsMin === `1`;
    }
    else if(keyValuePairs.ISP_1_dPerformanceSinceStartAbsMin && parseFloat(keyValuePairs.ISP_1_dPerformanceSinceStartAbsMin) !== 0)
    {
      moduleData.monitoring.bPerformanceSinceStartAbsMin = true;
    }
    if (keyValuePairs.ISP_1_dPerformanceSinceStartAbsMin) {
      moduleData.monitoring.dPerformanceSinceStartAbsMin = parseFromFormattedDigits(keyValuePairs.ISP_1_dPerformanceSinceStartAbsMin);
    }
    if (keyValuePairs.ISP_1_bPerformanceSinceStartAbsMax) {
      moduleData.monitoring.bPerformanceSinceStartAbsMax = keyValuePairs.ISP_1_bPerformanceSinceStartAbsMax === `1`;
    }
    else if(keyValuePairs.ISP_1_dPerformanceSinceStartAbsMax && parseFloat(keyValuePairs.ISP_1_dPerformanceSinceStartAbsMax) !== 0)
    {
      moduleData.monitoring.bPerformanceSinceStartAbsMax = true;
    }
    if (keyValuePairs.ISP_1_dPerformanceSinceStartAbsMax) {
      moduleData.monitoring.dPerformanceSinceStartAbsMax = parseFromFormattedDigits(keyValuePairs.ISP_1_dPerformanceSinceStartAbsMax);
    }
    if (keyValuePairs.ISP_1_bPerformanceSinceStartRelMin) {
      moduleData.monitoring.bPerformanceSinceStartRelMin = keyValuePairs.ISP_1_bPerformanceSinceStartRelMin === `1`;
    }
    else if(keyValuePairs.ISP_1_dPerformanceSinceStartRelMin && parseFloat(keyValuePairs.ISP_1_dPerformanceSinceStartRelMin) !== 0)
    {
      moduleData.monitoring.bPerformanceSinceStartRelMin = true;
    }
    if (keyValuePairs.ISP_1_dPerformanceSinceStartRelMin) {
      moduleData.monitoring.dPerformanceSinceStartRelMin = parseFromFormattedDigits(keyValuePairs.ISP_1_dPerformanceSinceStartRelMin);
    }
    if (keyValuePairs.ISP_1_bPerformanceSinceStartRelMax) {
      moduleData.monitoring.bPerformanceSinceStartRelMax = keyValuePairs.ISP_1_bPerformanceSinceStartRelMax === `1`;
    }
    else if(keyValuePairs.ISP_1_dPerformanceSinceStartRelMax && parseFloat(keyValuePairs.ISP_1_dPerformanceSinceStartRelMax) !== 0)
    {
      moduleData.monitoring.bPerformanceSinceStartRelMax = true;
    }
    if (keyValuePairs.ISP_1_dPerformanceSinceStartRelMax) {
      moduleData.monitoring.dPerformanceSinceStartRelMax = parseFromFormattedDigits(keyValuePairs.ISP_1_dPerformanceSinceStartRelMax);
    }
    if (keyValuePairs.ISP_1_bDrawdownDayAbsMax) {
      moduleData.monitoring.bDrawdownDayAbsMax = keyValuePairs.ISP_1_bDrawdownDayAbsMax === `1`;
    }
    else if(keyValuePairs.ISP_1_dDrawdownDayAbsMax && parseFloat(keyValuePairs.ISP_1_dDrawdownDayAbsMax) !== 0)
    {
      moduleData.monitoring.bDrawdownDayAbsMax = true;
    }
    if (keyValuePairs.ISP_1_dDrawdownDayAbsMax) {
      moduleData.monitoring.dDrawdownDayAbsMax = parseFromFormattedDigits(keyValuePairs.ISP_1_dDrawdownDayAbsMax);
    }
    if (keyValuePairs.ISP_1_bDrawdownDayRelMax) {
      moduleData.monitoring.bDrawdownDayRelMax = keyValuePairs.ISP_1_bDrawdownDayRelMax === `1`;
    }
    else if(keyValuePairs.ISP_1_dDrawdownDayRelMax && parseFloat(keyValuePairs.ISP_1_dDrawdownDayRelMax) !== 0)
    {
      moduleData.monitoring.bDrawdownDayRelMax = true;
    }
    if (keyValuePairs.ISP_1_dDrawdownDayRelMax) {
      moduleData.monitoring.dDrawdownDayRelMax = parseFromFormattedDigits(keyValuePairs.ISP_1_dDrawdownDayRelMax);
    }
    if (keyValuePairs.ISP_1_bDrawdownWeekAbsMax) {
      moduleData.monitoring.bDrawdownWeekAbsMax = keyValuePairs.ISP_1_bDrawdownWeekAbsMax === `1`;
    }
    else if(keyValuePairs.ISP_1_dDrawdownWeekAbsMax && parseFloat(keyValuePairs.ISP_1_dDrawdownWeekAbsMax) !== 0)
    {
      moduleData.monitoring.bDrawdownWeekAbsMax = true;
    }
    if (keyValuePairs.ISP_1_dDrawdownWeekAbsMax) {
      moduleData.monitoring.dDrawdownWeekAbsMax = parseFromFormattedDigits(keyValuePairs.ISP_1_dDrawdownWeekAbsMax);
    }
    if (keyValuePairs.ISP_1_bDrawdownWeekRelMax) {
      moduleData.monitoring.bDrawdownWeekRelMax = keyValuePairs.ISP_1_bDrawdownWeekRelMax === `1`;
    }
    else if(keyValuePairs.ISP_1_dDrawdownWeekRelMax && parseFloat(keyValuePairs.ISP_1_dDrawdownWeekRelMax) !== 0)
    {
      moduleData.monitoring.bDrawdownWeekRelMax = true;
    }
    if (keyValuePairs.ISP_1_dDrawdownWeekRelMax) {
      moduleData.monitoring.dDrawdownWeekRelMax = parseFromFormattedDigits(keyValuePairs.ISP_1_dDrawdownWeekRelMax);
    }
    if (keyValuePairs.ISP_1_bDrawdownMonthAbsMax) {
      moduleData.monitoring.bDrawdownMonthAbsMax = keyValuePairs.ISP_1_bDrawdownMonthAbsMax === `1`;
    }
    else if(keyValuePairs.ISP_1_dDrawdownMonthAbsMax && parseFloat(keyValuePairs.ISP_1_dDrawdownMonthAbsMax) !== 0)
    {
      moduleData.monitoring.bDrawdownMonthAbsMax = true;
    }
    if (keyValuePairs.ISP_1_dDrawdownMonthAbsMax) {
      moduleData.monitoring.dDrawdownMonthAbsMax = parseFromFormattedDigits(keyValuePairs.ISP_1_dDrawdownMonthAbsMax);
    }
    if (keyValuePairs.ISP_1_bDrawdownMonthRelMax) {
      moduleData.monitoring.bDrawdownMonthRelMax = keyValuePairs.ISP_1_bDrawdownMonthRelMax === `1`;
    }
    else if(keyValuePairs.ISP_1_dDrawdownMonthRelMax && parseFloat(keyValuePairs.ISP_1_dDrawdownMonthRelMax) !== 0)
    {
      moduleData.monitoring.bDrawdownMonthRelMax = true;
    }
    if (keyValuePairs.ISP_1_dDrawdownMonthRelMax) {
      moduleData.monitoring.dDrawdownMonthRelMax = parseFromFormattedDigits(keyValuePairs.ISP_1_dDrawdownMonthRelMax);
    }
    if (keyValuePairs.ISP_1_bDrawdownYearAbsMax) {
      moduleData.monitoring.bDrawdownYearAbsMax = keyValuePairs.ISP_1_bDrawdownYearAbsMax === `1`;
    }
    else if(keyValuePairs.ISP_1_dDrawdownYearAbsMax && parseFloat(keyValuePairs.ISP_1_dDrawdownYearAbsMax) !== 0)
    {
      moduleData.monitoring.bDrawdownYearAbsMax = true;
    }
    if (keyValuePairs.ISP_1_dDrawdownYearAbsMax) {
      moduleData.monitoring.dDrawdownYearAbsMax = parseFromFormattedDigits(keyValuePairs.ISP_1_dDrawdownYearAbsMax);
    }
    if (keyValuePairs.ISP_1_bDrawdownYearRelMax) {
      moduleData.monitoring.bDrawdownYearRelMax = keyValuePairs.ISP_1_bDrawdownYearRelMax === `1`;
    }
    else if(keyValuePairs.ISP_1_dDrawdownYearRelMax && parseFloat(keyValuePairs.ISP_1_dDrawdownYearRelMax) !== 0)
    {
      moduleData.monitoring.bDrawdownYearRelMax = true;
    }
    if (keyValuePairs.ISP_1_dDrawdownYearRelMax) {
      moduleData.monitoring.dDrawdownYearRelMax = parseFromFormattedDigits(keyValuePairs.ISP_1_dDrawdownYearRelMax);
    }
    if (keyValuePairs.ISP_1_bDrawdownSinceStartAbsMax) {
      moduleData.monitoring.bDrawdownSinceStartAbsMax = keyValuePairs.ISP_1_bDrawdownSinceStartAbsMax === `1`;
    }
    else if(keyValuePairs.ISP_1_dDrawdownSinceStartAbsMax && parseFloat(keyValuePairs.ISP_1_dDrawdownSinceStartAbsMax) !== 0)
    {
      moduleData.monitoring.bDrawdownSinceStartAbsMax = true;
    }
    if (keyValuePairs.ISP_1_dDrawdownSinceStartAbsMax) {
      moduleData.monitoring.dDrawdownSinceStartAbsMax = parseFromFormattedDigits(keyValuePairs.ISP_1_dDrawdownSinceStartAbsMax);
    }
    if (keyValuePairs.ISP_1_bDrawdownSinceStartRelMax) {
      moduleData.monitoring.bDrawdownSinceStartRelMax = keyValuePairs.ISP_1_bDrawdownSinceStartRelMax === `1`;
    }
    else if(keyValuePairs.ISP_1_dDrawdownSinceStartRelMax && parseFloat(keyValuePairs.ISP_1_dDrawdownSinceStartRelMax) !== 0)
    {
      moduleData.monitoring.bDrawdownSinceStartRelMax = true;
    }
    if (keyValuePairs.ISP_1_dDrawdownSinceStartRelMax) {
      moduleData.monitoring.dDrawdownSinceStartRelMax = parseFromFormattedDigits(keyValuePairs.ISP_1_dDrawdownSinceStartRelMax);
    }

    if(DEBUG_LEVEL >= 2) { console.log("ISP_1"); }

    // ----------------------------------------------------------------------
    // TSP_1_SPLIT_Y
    // ----------------------------------------------------------------------
    let tspIndex = 1;
    while (keyValuePairs[`TSP_1_SPLIT_${tspIndex}_nOpenVolume`]) {

      const config = { ...TradeSplittingDefaults };
      
      if (keyValuePairs[`TSP_1_SPLIT_${tspIndex}_nOpenVolume`]) {
        config.nOpenVolume = keyValuePairs[`TSP_1_SPLIT_${tspIndex}_nOpenVolume`];
      }
      if (keyValuePairs[`TSP_1_SPLIT_${tspIndex}_nOpenPosition`]) {
      config.nOpenPosition = keyValuePairs[`TSP_1_SPLIT_${tspIndex}_nOpenPosition`];
      }
      if (keyValuePairs[`TSP_1_SPLIT_${tspIndex}_nClosePosition`]) {
        config.nClosePosition = keyValuePairs[`TSP_1_SPLIT_${tspIndex}_nClosePosition`];
      }

      const name = `OV: ${config.nOpenVolume} | OP: ${config.nOpenPosition} | CP: ${config.nClosePosition}`;
      const subtitle = name;

      // Generate unique ID
      let id = now + tspIndex;
      if(keyValuePairs[`TSP_1_SPLIT_${tspIndex}_nId`])
      {
        id = keyValuePairs[`TSP_1_SPLIT_${tspIndex}_nId`];
      }
      const tradeSplitting = {
        id: parseInt(id, 10),
        name,
        subtitle,
        isNewlyCreated: false,
        config,
      };
      moduleData.tradeSplittings.push(tradeSplitting);
      tspIndex += 1;

      if(DEBUG_LEVEL >= 2) { console.log("TSP_1_SPLIT_Y"); }
    }

    // ----------------------------------------------------------------------
    // FEB_1
    // ----------------------------------------------------------------------
    if (keyValuePairs.FEB_1_nInspectorState) {
      moduleData.dataFeedback.nInspectorState = keyValuePairs.FEB_1_nInspectorState === `1`;
    }
    if (keyValuePairs.FEB_1_nInspectorRefreshInterval) {
      moduleData.dataFeedback.nInspectorRefreshInterval = keyValuePairs.FEB_1_nInspectorRefreshInterval;
    }
    if (keyValuePairs.FEB_1_nPresentTradesState) {
      moduleData.dataFeedback.nPresentTradesState = keyValuePairs.FEB_1_nPresentTradesState === `1`;
    }
    if (keyValuePairs.FEB_1_nPresentTradesRefreshInterval) {
      moduleData.dataFeedback.nPresentTradesRefreshInterval = keyValuePairs.FEB_1_nPresentTradesRefreshInterval;
    }
    if (keyValuePairs.FEB_1_nPastTradesState) {
      moduleData.dataFeedback.nPastTradesState = keyValuePairs.FEB_1_nPastTradesState === `1`;
    }
    if (keyValuePairs.FEB_1_nMetaDataState) {
      moduleData.dataFeedback.nMetaDataState = keyValuePairs.FEB_1_nMetaDataState === `1`;
    }
    if (keyValuePairs.FEB_1_nTradeScreenshotsState) {
      moduleData.dataFeedback.nTradeScreenshotsState = keyValuePairs.FEB_1_nTradeScreenshotsState === `1`;
    }
    if (keyValuePairs.FEB_1_nCurrentValueState) {
      moduleData.dataFeedback.nCurrentValueState = keyValuePairs.FEB_1_nCurrentValueState === `1`;
    }
    if (keyValuePairs.FEB_1_nCurrentValueEvt) {
      moduleData.dataFeedback.nCurrentValueEvt = keyValuePairs.FEB_1_nCurrentValueEvt === `1`;
    }
    if (keyValuePairs.FEB_1_nCurrentValueInos) {
      moduleData.dataFeedback.nCurrentValueInos = keyValuePairs.FEB_1_nCurrentValueInos === `1`;
    }
    if (keyValuePairs.FEB_1_nCurrentValueCa) {
      moduleData.dataFeedback.nCurrentValueCa = keyValuePairs.FEB_1_nCurrentValueCa === `1`;
    }
    if (keyValuePairs.FEB_1_nCurrentValueCas) {
      moduleData.dataFeedback.nCurrentValueCas = keyValuePairs.FEB_1_nCurrentValueCas === `1`;
    }
    if (keyValuePairs.FEB_1_nCurrentValuePas) {
      moduleData.dataFeedback.nCurrentValuePas = keyValuePairs.FEB_1_nCurrentValuePas === `1`;
    }
    if (keyValuePairs.FEB_1_nCurrentValueFis) {
      moduleData.dataFeedback.nCurrentValueFis = keyValuePairs.FEB_1_nCurrentValueFis === `1`;
    }
    if (keyValuePairs.FEB_1_nCurrentValueRefreshInterval) {
      moduleData.dataFeedback.nCurrentValueRefreshInterval = keyValuePairs.FEB_1_nCurrentValueRefreshInterval;
    }

    if (keyValuePairs.FEB_1_nTimeAnalysisState) {
      moduleData.dataFeedback.nTimeAnalysisState = keyValuePairs.FEB_1_nTimeAnalysisState === `1`;
    }
    if (keyValuePairs.FEB_1_nTimeAnalysisMinutePeriod) {
      moduleData.dataFeedback.nTimeAnalysisMinutePeriod = keyValuePairs.FEB_1_nTimeAnalysisMinutePeriod;
    }
    if (keyValuePairs.FEB_1_nTimeAnalysisHourPeriod) {
      moduleData.dataFeedback.nTimeAnalysisHourPeriod = keyValuePairs.FEB_1_nTimeAnalysisHourPeriod;
    }
    if (keyValuePairs.FEB_1_nTimeAnalysisDayPeriod) {
      moduleData.dataFeedback.nTimeAnalysisDayPeriod = keyValuePairs.FEB_1_nTimeAnalysisDayPeriod;
    }
    if (keyValuePairs.FEB_1_nTimeAnalysisWeekdayPeriod) {
      moduleData.dataFeedback.nTimeAnalysisWeekdayPeriod = keyValuePairs.FEB_1_nTimeAnalysisWeekdayPeriod;
    }
    if (keyValuePairs.FEB_1_nTimeAnalysisWeekPeriod) {
      moduleData.dataFeedback.nTimeAnalysisWeekPeriod = keyValuePairs.FEB_1_nTimeAnalysisWeekPeriod;
    }
    if (keyValuePairs.FEB_1_nTimeAnalysisMonthPeriod) {
      moduleData.dataFeedback.nTimeAnalysisMonthPeriod = keyValuePairs.FEB_1_nTimeAnalysisMonthPeriod;
    }
    if (keyValuePairs.FEB_1_nTimeAnalysisRefreshInterval) {
      moduleData.dataFeedback.nTimeAnalysisRefreshInterval = keyValuePairs.FEB_1_nTimeAnalysisRefreshInterval;
    }
    if (keyValuePairs.FEB_1_nValueAnalysisState) {
      moduleData.dataFeedback.nValueAnalysisState = keyValuePairs.FEB_1_nValueAnalysisState === `1`;
    }
    if (keyValuePairs.FEB_1_nValueAnalysisEvtPeriod) {
      moduleData.dataFeedback.nValueAnalysisEvtPeriod = keyValuePairs.FEB_1_nValueAnalysisEvtPeriod;
    }
    if (keyValuePairs.FEB_1_nValueAnalysisInosPeriod) {
      moduleData.dataFeedback.nValueAnalysisInosPeriod = keyValuePairs.FEB_1_nValueAnalysisInosPeriod;
    }
    if (keyValuePairs.FEB_1_nValueAnalysisCaPeriod) {
      moduleData.dataFeedback.nValueAnalysisCaPeriod = keyValuePairs.FEB_1_nValueAnalysisCaPeriod;
    }
    if (keyValuePairs.FEB_1_nValueAnalysisCasPeriod) {
      moduleData.dataFeedback.nValueAnalysisCasPeriod = keyValuePairs.FEB_1_nValueAnalysisCasPeriod;
    }
    if (keyValuePairs.FEB_1_nValueAnalysisPasPeriod) {
      moduleData.dataFeedback.nValueAnalysisPasPeriod = keyValuePairs.FEB_1_nValueAnalysisPasPeriod;
    }
    if (keyValuePairs.FEB_1_nValueAnalysisFisPeriod) {
      moduleData.dataFeedback.nValueAnalysisFisPeriod = keyValuePairs.FEB_1_nValueAnalysisFisPeriod;
    }
    if (keyValuePairs.FEB_1_nValueAnalysisHistogramBins) {
      moduleData.dataFeedback.nValueAnalysisHistogramBins = keyValuePairs.FEB_1_nValueAnalysisHistogramBins;
    }
    if (keyValuePairs.FEB_1_nValueAnalysisRefreshInterval) {
      moduleData.dataFeedback.nValueAnalysisRefreshInterval = keyValuePairs.FEB_1_nValueAnalysisRefreshInterval;
    }
    if (keyValuePairs.FEB_1_nSignalAnalysisState) {
      moduleData.dataFeedback.nSignalAnalysisState = keyValuePairs.FEB_1_nSignalAnalysisState === `1`;
    }
    if (keyValuePairs.FEB_1_nSignalAnalysisActualTradePeriod) {
      moduleData.dataFeedback.nSignalAnalysisActualTradePeriod = keyValuePairs.FEB_1_nSignalAnalysisActualTradePeriod;
    }
    if (keyValuePairs.FEB_1_nSignalAnalysisGeneralSignalPeriod) {
      moduleData.dataFeedback.nSignalAnalysisGeneralSignalPeriod = keyValuePairs.FEB_1_nSignalAnalysisGeneralSignalPeriod;
    }
    if (keyValuePairs.FEB_1_nSignalAnalysisEvtPeriod) {
      moduleData.dataFeedback.nSignalAnalysisEvtPeriod = keyValuePairs.FEB_1_nSignalAnalysisEvtPeriod;
    }
    if (keyValuePairs.FEB_1_nSignalAnalysisInosPeriod) {
      moduleData.dataFeedback.nSignalAnalysisInosPeriod = keyValuePairs.FEB_1_nSignalAnalysisInosPeriod;
    }
    if (keyValuePairs.FEB_1_nSignalAnalysisRelioPeriod) {
      moduleData.dataFeedback.nSignalAnalysisRelioPeriod = keyValuePairs.FEB_1_nSignalAnalysisRelioPeriod;
    }
    if (keyValuePairs.FEB_1_nSignalAnalysisCaPeriod) {
      moduleData.dataFeedback.nSignalAnalysisCaPeriod = keyValuePairs.FEB_1_nSignalAnalysisCaPeriod;
    }
    if (keyValuePairs.FEB_1_nSignalAnalysisCasPeriod) {
      moduleData.dataFeedback.nSignalAnalysisCasPeriod = keyValuePairs.FEB_1_nSignalAnalysisCasPeriod;
    }
    if (keyValuePairs.FEB_1_nSignalAnalysisPasPeriod) {
      moduleData.dataFeedback.nSignalAnalysisPasPeriod = keyValuePairs.FEB_1_nSignalAnalysisPasPeriod;
    }
    if (keyValuePairs.FEB_1_nSignalAnalysisFisPeriod) {
      moduleData.dataFeedback.nSignalAnalysisFisPeriod = keyValuePairs.FEB_1_nSignalAnalysisFisPeriod;
    }
    if (keyValuePairs.FEB_1_nSignalAnalysisBarsBefore) {
      moduleData.dataFeedback.nSignalAnalysisBarsBefore = keyValuePairs.FEB_1_nSignalAnalysisBarsBefore;
    }
    if (keyValuePairs.FEB_1_nSignalAnalysisBarsAfter) {
      moduleData.dataFeedback.nSignalAnalysisBarsAfter = keyValuePairs.FEB_1_nSignalAnalysisBarsAfter;
    }
    if (keyValuePairs.FEB_1_nSignalAnalysisRefreshInterval) {
      moduleData.dataFeedback.nSignalAnalysisRefreshInterval = keyValuePairs.FEB_1_nSignalAnalysisRefreshInterval;
    }
    if (keyValuePairs.FEB_1_nSymbolSeriesBarsCompletedState) {
      moduleData.dataFeedback.nSymbolSeriesBarsCompletedState = keyValuePairs.FEB_1_nSymbolSeriesBarsCompletedState === `1`;
    }
    if (keyValuePairs.FEB_1_nSymbolSeriesBarsCurrentState) {
      moduleData.dataFeedback.nSymbolSeriesBarsCurrentState = keyValuePairs.FEB_1_nSymbolSeriesBarsCurrentState === `1`;
    }
    if (keyValuePairs.FEB_1_nSymbolSeriesM1State) {
      moduleData.dataFeedback.nSymbolSeriesM1State = keyValuePairs.FEB_1_nSymbolSeriesM1State === `1`;
    }
    if (keyValuePairs.FEB_1_nSymbolSeriesM1Range) {
      moduleData.dataFeedback.nSymbolSeriesM1Range = keyValuePairs.FEB_1_nSymbolSeriesM1Range;
    }
    if (keyValuePairs.FEB_1_nSymbolSeriesM5State) {
      moduleData.dataFeedback.nSymbolSeriesM5State = keyValuePairs.FEB_1_nSymbolSeriesM5State === `1`;
    }
    if (keyValuePairs.FEB_1_nSymbolSeriesM5Range) {
      moduleData.dataFeedback.nSymbolSeriesM5Range = keyValuePairs.FEB_1_nSymbolSeriesM5Range;
    }
    if (keyValuePairs.FEB_1_nSymbolSeriesM15State) {
      moduleData.dataFeedback.nSymbolSeriesM15State = keyValuePairs.FEB_1_nSymbolSeriesM15State === `1`;
    }
    if (keyValuePairs.FEB_1_nSymbolSeriesM15Range) {
      moduleData.dataFeedback.nSymbolSeriesM15Range = keyValuePairs.FEB_1_nSymbolSeriesM15Range;
    }
    if (keyValuePairs.FEB_1_nSymbolSeriesM30State) {
      moduleData.dataFeedback.nSymbolSeriesM30State = keyValuePairs.FEB_1_nSymbolSeriesM30State === `1`;
    }
    if (keyValuePairs.FEB_1_nSymbolSeriesM30Range) {
      moduleData.dataFeedback.nSymbolSeriesM30Range = keyValuePairs.FEB_1_nSymbolSeriesM30Range;
    }
    if (keyValuePairs.FEB_1_nSymbolSeriesH1State) {
      moduleData.dataFeedback.nSymbolSeriesH1State = keyValuePairs.FEB_1_nSymbolSeriesH1State === `1`;
    }
    if (keyValuePairs.FEB_1_nSymbolSeriesH1Range) {
      moduleData.dataFeedback.nSymbolSeriesH1Range = keyValuePairs.FEB_1_nSymbolSeriesH1Range;
    }
    if (keyValuePairs.FEB_1_nSymbolSeriesH4State) {
      moduleData.dataFeedback.nSymbolSeriesH4State = keyValuePairs.FEB_1_nSymbolSeriesH4State === `1`;
    }
    if (keyValuePairs.FEB_1_nSymbolSeriesH4Range) {
      moduleData.dataFeedback.nSymbolSeriesH4Range = keyValuePairs.FEB_1_nSymbolSeriesH4Range;
    }
    if (keyValuePairs.FEB_1_nSymbolSeriesD1State) {
      moduleData.dataFeedback.nSymbolSeriesD1State = keyValuePairs.FEB_1_nSymbolSeriesD1State === `1`;
    }
    if (keyValuePairs.FEB_1_nSymbolSeriesD1Range) {
      moduleData.dataFeedback.nSymbolSeriesD1Range = keyValuePairs.FEB_1_nSymbolSeriesD1Range;
    }
    if (keyValuePairs.FEB_1_nSymbolSeriesW1State) {
      moduleData.dataFeedback.nSymbolSeriesW1State = keyValuePairs.FEB_1_nSymbolSeriesW1State === `1`;
    }
    if (keyValuePairs.FEB_1_nSymbolSeriesW1Range) {
      moduleData.dataFeedback.nSymbolSeriesW1Range = keyValuePairs.FEB_1_nSymbolSeriesW1Range;
    }
    if (keyValuePairs.FEB_1_nSymbolSeriesMNState) {
      moduleData.dataFeedback.nSymbolSeriesMNState = keyValuePairs.FEB_1_nSymbolSeriesMNState === `1`;
    }
    if (keyValuePairs.FEB_1_nSymbolSeriesMNRange) {
      moduleData.dataFeedback.nSymbolSeriesMNRange = keyValuePairs.FEB_1_nSymbolSeriesMNRange;
    }

    if(DEBUG_LEVEL >= 2) { console.log("FEB_1"); }

    // ----------------------------------------------------------------------
    // MIS_1
    // ----------------------------------------------------------------------
    if (keyValuePairs.MIS_1_nGeneralSignalVisualization) {
      moduleData.tradeBasics.nGeneralSignalVisualization = keyValuePairs.MIS_1_nGeneralSignalVisualization === `1`;
    }
    if (keyValuePairs.MIS_1_nDrawUnequalSymbols) {
      moduleData.miscellaneous.nDrawUnequalSymbols = keyValuePairs.MIS_1_nDrawUnequalSymbols === `1`;
    }
    if (keyValuePairs.MIS_1_nDrawSecondTimeframe) {
      moduleData.miscellaneous.nDrawSecondTimeframe = keyValuePairs.MIS_1_nDrawSecondTimeframe;
    }
    if (keyValuePairs.MIS_1_nDrawChartAnalyzerPanel) {
      moduleData.miscellaneous.nDrawChartAnalyzerPanel = keyValuePairs.MIS_1_nDrawChartAnalyzerPanel === `1`;
    }

    if(DEBUG_LEVEL >= 2) { console.log("MIS_1"); }

    // ----------------------------------------------------------------------
    // TIM_1
    // ----------------------------------------------------------------------
    if (keyValuePairs.TIM_1_nVisualizeTiming) {
      moduleData.timing.nVisualizeTiming = keyValuePairs.TIM_1_nVisualizeTiming === `1`;
    }
    if (keyValuePairs.TIM_1_strTradingSeconds) {
      moduleData.timing.strTradingSeconds = keyValuePairs.TIM_1_strTradingSeconds;
    }
    if (keyValuePairs.TIM_1_strTradingMinutes) {
      moduleData.timing.strTradingMinutes = keyValuePairs.TIM_1_strTradingMinutes;
    }
    if (keyValuePairs.TIM_1_strTradingHours) {
      moduleData.timing.strTradingHours = keyValuePairs.TIM_1_strTradingHours;
    }
    if (keyValuePairs.TIM_1_strTradingDays) {
      moduleData.timing.strTradingDays = keyValuePairs.TIM_1_strTradingDays;
    }
    if (keyValuePairs.TIM_1_strTradingWeeks) {
      moduleData.timing.strTradingWeeks = keyValuePairs.TIM_1_strTradingWeeks;
    }
    if (keyValuePairs.TIM_1_strTradingMonths) {
      moduleData.timing.strTradingMonths = keyValuePairs.TIM_1_strTradingMonths;
    }
    if (keyValuePairs.TIM_1_strTradingDaysOfWeek) {
      moduleData.timing.strTradingDaysOfWeek = keyValuePairs.TIM_1_strTradingDaysOfWeek;
    }
    if (keyValuePairs.TIM_1_nIntradayMode) {
      moduleData.timing.nIntradayMode = keyValuePairs.TIM_1_nIntradayMode === `1`;
    }
    if (keyValuePairs.TIM_1_strStartIntradayTrading) {
      moduleData.timing.strStartIntradayTrading = keyValuePairs.TIM_1_strStartIntradayTrading;
    }
    if (keyValuePairs.TIM_1_strStopIntradayTrading) {
      moduleData.timing.strStopIntradayTrading = keyValuePairs.TIM_1_strStopIntradayTrading;
    }
    if (keyValuePairs.TIM_1_strDeadlineIntradayTrading) {
      moduleData.timing.strDeadlineIntradayTrading = keyValuePairs.TIM_1_strDeadlineIntradayTrading;
    }
    if (keyValuePairs.TIM_1_nDstSummerShiftedMinutes) {
      moduleData.timing.nDstSummerShiftedMinutes = keyValuePairs.TIM_1_nDstSummerShiftedMinutes;
    }

    // Parse DST Summer Shift Start
    if (keyValuePairs.TIM_1_strDstSummerShiftStart) {
      const summerStartParts = keyValuePairs.TIM_1_strDstSummerShiftStart.split(`,`);
      if (summerStartParts.length >= 4) {
        moduleData.timing.nDstSummerShiftStartNumberOfMonth = summerStartParts[0];
        moduleData.timing.nDstSummerShiftStartDayOfWeek = summerStartParts[1];
        moduleData.timing.nDstSummerShiftStartCountDayOfWeekInMonth = summerStartParts[2];
        moduleData.timing.strDstSummerShiftStartTime = summerStartParts[3];
      }
    }

    // Parse DST Summer Shift End
    if (keyValuePairs.TIM_1_strDstSummerShiftEnd) {
      const summerEndParts = keyValuePairs.TIM_1_strDstSummerShiftEnd.split(`,`);
      if (summerEndParts.length >= 4) {
        moduleData.timing.nDstSummerShiftEndNumberOfMonth = summerEndParts[0];
        moduleData.timing.nDstSummerShiftEndDayOfWeek = summerEndParts[1];
        moduleData.timing.nDstSummerShiftEndCountDayOfWeekInMonth = summerEndParts[2];
        moduleData.timing.strDstSummerShiftEndTime = summerEndParts[3];
      }
    }

    if (keyValuePairs.TIM_1_nDstWinterShiftedMinutes) {
      moduleData.timing.nDstWinterShiftedMinutes = keyValuePairs.TIM_1_nDstWinterShiftedMinutes;
    }

    // Parse DST Winter Shift Start
    if (keyValuePairs.TIM_1_strDstWinterShiftStart) {
      const winterStartParts = keyValuePairs.TIM_1_strDstWinterShiftStart.split(`,`);
      if (winterStartParts.length >= 4) {
        moduleData.timing.nDstWinterShiftStartNumberOfMonth = winterStartParts[0];
        moduleData.timing.nDstWinterShiftStartDayOfWeek = winterStartParts[1];
        moduleData.timing.nDstWinterShiftStartCountDayOfWeekInMonth = winterStartParts[2];
        moduleData.timing.strDstWinterShiftStartTime = winterStartParts[3];
      }
    }

    // Parse DST Winter Shift End
    if (keyValuePairs.TIM_1_strDstWinterShiftEnd) {
      const winterEndParts = keyValuePairs.TIM_1_strDstWinterShiftEnd.split(`,`);
      if (winterEndParts.length >= 4) {
        moduleData.timing.nDstWinterShiftEndNumberOfMonth = winterEndParts[0];
        moduleData.timing.nDstWinterShiftEndDayOfWeek = winterEndParts[1];
        moduleData.timing.nDstWinterShiftEndCountDayOfWeekInMonth = winterEndParts[2];
        moduleData.timing.strDstWinterShiftEndTime = winterEndParts[3];
      }
    }

    if(DEBUG_LEVEL >= 2) { console.log("TIM_1"); }

    // ----------------------------------------------------------------------
    // EVT_1
    // ----------------------------------------------------------------------
    if (keyValuePairs.EVT_1_nSignalInUse) {
      moduleData.news.nSignalInUse = keyValuePairs.EVT_1_nSignalInUse === `1`;
    }
    if (keyValuePairs.EVT_1_nSignalUsedFor) {
      moduleData.news.nSignalUsedFor = keyValuePairs.EVT_1_nSignalUsedFor;
    }
    if (keyValuePairs.EVT_1_nSignalVisualization) {
      moduleData.news.nSignalVisualization = keyValuePairs.EVT_1_nSignalVisualization === `1`;
    }
    if (keyValuePairs.EVT_1_nDrawTable) {
      moduleData.news.nDrawTable = keyValuePairs.EVT_1_nDrawTable === `1`;
    }
    if (keyValuePairs.EVT_1_nDrawChart) {
      moduleData.news.nDrawChart = keyValuePairs.EVT_1_nDrawChart === `1`;
    }
    if (keyValuePairs.EVT_1_nDrawKeepInCache) {
      moduleData.news.nDrawKeepInCache = keyValuePairs.EVT_1_nDrawKeepInCache;
    }
    if (keyValuePairs.EVT_1_nSignalNegation) {
      moduleData.news.nSignalNegation = keyValuePairs.EVT_1_nSignalNegation === `1`;
    }
    if (keyValuePairs.EVT_1_nShiftInSec) {
      moduleData.news.nShiftInSec = keyValuePairs.EVT_1_nShiftInSec;
    }
    if (keyValuePairs.EVT_1_nPreSignalTime) {
      moduleData.news.nPreSignalTime = keyValuePairs.EVT_1_nPreSignalTime;
    }
    if (keyValuePairs.EVT_1_nPostSignalTime) {
      moduleData.news.nPostSignalTime = keyValuePairs.EVT_1_nPostSignalTime;
    }
    if (keyValuePairs.EVT_1_nRegionAll) {
      moduleData.news.nRegionAll = keyValuePairs.EVT_1_nRegionAll === `1`;
    }
    if (keyValuePairs.EVT_1_nRegionAud) {
      moduleData.news.nRegionAud = keyValuePairs.EVT_1_nRegionAud === `1`;
    }
    if (keyValuePairs.EVT_1_nRegionBrl) {
      moduleData.news.nRegionBrl = keyValuePairs.EVT_1_nRegionBrl === `1`;
    }
    if (keyValuePairs.EVT_1_nRegionCad) {
      moduleData.news.nRegionCad = keyValuePairs.EVT_1_nRegionCad === `1`;
    }
    if (keyValuePairs.EVT_1_nRegionChf) {
      moduleData.news.nRegionChf = keyValuePairs.EVT_1_nRegionChf === `1`;
    }
    if (keyValuePairs.EVT_1_nRegionCny) {
      moduleData.news.nRegionCny = keyValuePairs.EVT_1_nRegionCny === `1`;
    }
    if (keyValuePairs.EVT_1_nRegionEur) {
      moduleData.news.nRegionEur = keyValuePairs.EVT_1_nRegionEur === `1`;
    }
    if (keyValuePairs.EVT_1_nRegionGbp) {
      moduleData.news.nRegionGbp = keyValuePairs.EVT_1_nRegionGbp === `1`;
    }
    if (keyValuePairs.EVT_1_nRegionHkd) {
      moduleData.news.nRegionHkd = keyValuePairs.EVT_1_nRegionHkd === `1`;
    }
    if (keyValuePairs.EVT_1_nRegionInr) {
      moduleData.news.nRegionInr = keyValuePairs.EVT_1_nRegionInr === `1`;
    }
    if (keyValuePairs.EVT_1_nRegionJpy) {
      moduleData.news.nRegionJpy = keyValuePairs.EVT_1_nRegionJpy === `1`;
    }
    if (keyValuePairs.EVT_1_nRegionKrw) {
      moduleData.news.nRegionKrw = keyValuePairs.EVT_1_nRegionKrw === `1`;
    }
    if (keyValuePairs.EVT_1_nRegionMxn) {
      moduleData.news.nRegionMxn = keyValuePairs.EVT_1_nRegionMxn === `1`;
    }
    if (keyValuePairs.EVT_1_nRegionNok) {
      moduleData.news.nRegionNok = keyValuePairs.EVT_1_nRegionNok === `1`;
    }
    if (keyValuePairs.EVT_1_nRegionNzd) {
      moduleData.news.nRegionNzd = keyValuePairs.EVT_1_nRegionNzd === `1`;
    }
    if (keyValuePairs.EVT_1_nRegionSek) {
      moduleData.news.nRegionSek = keyValuePairs.EVT_1_nRegionSek === `1`;
    }
    if (keyValuePairs.EVT_1_nRegionSgd) {
      moduleData.news.nRegionSgd = keyValuePairs.EVT_1_nRegionSgd === `1`;
    }
    if (keyValuePairs.EVT_1_nRegionUsd) {
      moduleData.news.nRegionUsd = keyValuePairs.EVT_1_nRegionUsd === `1`;
    }
    if (keyValuePairs.EVT_1_nRegionZar) {
      moduleData.news.nRegionZar = keyValuePairs.EVT_1_nRegionZar === `1`;
    }
    if (keyValuePairs.EVT_1_nImportanceUndefined) {
      moduleData.news.nImportanceUndefined = keyValuePairs.EVT_1_nImportanceUndefined === `1`;
    }
    if (keyValuePairs.EVT_1_nImportanceLow) {
      moduleData.news.nImportanceLow = keyValuePairs.EVT_1_nImportanceLow === `1`;
    }
    if (keyValuePairs.EVT_1_nImportanceModerate) {
      moduleData.news.nImportanceModerate = keyValuePairs.EVT_1_nImportanceModerate === `1`;
    }
    if (keyValuePairs.EVT_1_nImportanceHigh) {
      moduleData.news.nImportanceHigh = keyValuePairs.EVT_1_nImportanceHigh === `1`;
    }
    if (keyValuePairs.EVT_1_nImpactUndefined) {
      moduleData.news.nImpactUndefined = keyValuePairs.EVT_1_nImpactUndefined === `1`;
    }
    if (keyValuePairs.EVT_1_nImpactPositive) {
      moduleData.news.nImpactPositive = keyValuePairs.EVT_1_nImpactPositive === `1`;
    }
    if (keyValuePairs.EVT_1_nImpactNegative) {
      moduleData.news.nImpactNegative = keyValuePairs.EVT_1_nImpactNegative === `1`;
    }
    if (keyValuePairs.EVT_1_bActual) {
      moduleData.news.bActual = keyValuePairs.EVT_1_bActual === `1`;
    }
    else if((keyValuePairs.EVT_1_lActualMin || keyValuePairs.EVT_1_lActualMax) && (parseFloat(keyValuePairs.EVT_1_lActualMin) !== 0 || parseFloat(keyValuePairs.EVT_1_lActualMax) !== 0))
    {
      moduleData.news.bActual = true;
    }
    if (keyValuePairs.EVT_1_lActualMin) {
      moduleData.news.lActualMin = parseFromFormattedDigits(keyValuePairs.EVT_1_lActualMin);
    }
    if (keyValuePairs.EVT_1_lActualMax) {
      moduleData.news.lActualMax = parseFromFormattedDigits(keyValuePairs.EVT_1_lActualMax);
    }
    if (keyValuePairs.EVT_1_bForecast) {
      moduleData.news.bForecast = keyValuePairs.EVT_1_bForecast === `1`;
    }
    else if((keyValuePairs.EVT_1_lForecastMin || keyValuePairs.EVT_1_lForecastMax) && (parseFloat(keyValuePairs.EVT_1_lForecastMin) !== 0 || parseFloat(keyValuePairs.EVT_1_lForecastMax) !== 0))
    {
      moduleData.news.bForecast = true;
    }
    if (keyValuePairs.EVT_1_lForecastMin) {
      moduleData.news.lForecastMin = parseFromFormattedDigits(keyValuePairs.EVT_1_lForecastMin);
    }
    if (keyValuePairs.EVT_1_lForecastMax) {
      moduleData.news.lForecastMax = parseFromFormattedDigits(keyValuePairs.EVT_1_lForecastMax);
    }
    if (keyValuePairs.EVT_1_bPrevious) {
      moduleData.news.bPrevious = keyValuePairs.EVT_1_bPrevious === `1`;
    }
    else if((keyValuePairs.EVT_1_lPreviousMin || keyValuePairs.EVT_1_lPreviousMax) && (parseFloat(keyValuePairs.EVT_1_lPreviousMin) !== 0 || parseFloat(keyValuePairs.EVT_1_lPreviousMax) !== 0))
    {
      moduleData.news.bPrevious = true;
    }
    if (keyValuePairs.EVT_1_lPreviousMin) {
      moduleData.news.lPreviousMin = parseFromFormattedDigits(keyValuePairs.EVT_1_lPreviousMin);
    }
    if (keyValuePairs.EVT_1_lPreviousMax) {
      moduleData.news.lPreviousMax = parseFromFormattedDigits(keyValuePairs.EVT_1_lPreviousMax);
    }

    if(DEBUG_LEVEL >= 2) { console.log("EVT_1"); }

    // ----------------------------------------------------------------------
    // EVT_1_REL_Y
    // ----------------------------------------------------------------------
    let relIndex = 1;
    if (keyValuePairs[`EVT_1_REL_${relIndex}_nRelationCondition`]) {
      moduleData.news.valueRelations = [];
    }
    while (keyValuePairs[`EVT_1_REL_${relIndex}_nRelationCondition`]) {
      const relation = { ...NewsValueRelationsDefaults };

      if (keyValuePairs[`EVT_1_REL_${relIndex}_nRelationCondition`]) {
        relation.nRelationCondition = keyValuePairs[`EVT_1_REL_${relIndex}_nRelationCondition`];
      }

      moduleData.news.valueRelations.push(relation);
      relIndex += 1;

      if(DEBUG_LEVEL >= 2) { console.log("EVT_1_REL_Y"); }
    }

    // ----------------------------------------------------------------------
    // EVT_1_FIL_Y
    // ----------------------------------------------------------------------
    let filIndex = 1;
    if (keyValuePairs[`EVT_1_FIL_${filIndex}_nFilterType`]) {
      moduleData.news.titleFilters = [];
    }
    while (keyValuePairs[`EVT_1_FIL_${filIndex}_nFilterType`]) {
      const filter = { ...NewsTitleFiltersDefaults };

      if (keyValuePairs[`EVT_1_FIL_${filIndex}_nFilterType`]) {
        filter.nFilterType = keyValuePairs[`EVT_1_FIL_${filIndex}_nFilterType`];
      }
      if (keyValuePairs[`EVT_1_FIL_${filIndex}_strFilterString`]) {
        filter.strFilterString = keyValuePairs[`EVT_1_FIL_${filIndex}_strFilterString`];
      }

      moduleData.news.titleFilters.push(filter);
      filIndex += 1;

      if(DEBUG_LEVEL >= 2) { console.log("EVT_1_FIL_Y"); }
    }

    // ----------------------------------------------------------------------
    // INOS_X
    // ----------------------------------------------------------------------
    inosIndex = 1;
    while (keyValuePairs[`INOS_${inosIndex}_nSignalInUse`]) {
      const config = { ...IndicatorDefaults };

      if(keyValuePairs[`INOS_${inosIndex}_nSelection`])
      {
        config.nSelection = keyValuePairs[`INOS_${inosIndex}_nSelection`];

        // Override indicator specific values based on nSelection
        if (config.nSelection && ALL_CONFIGS[config.nSelection]) {
          const selectedIndicatorConfig = ALL_CONFIGS[config.nSelection];
          const currentInosIndex = inosIndex; 

          // Override default values from the selected indicator configuration
          if (selectedIndicatorConfig.defaultValues) {
            Object.keys(selectedIndicatorConfig.defaultValues).forEach(key => {
              if (Object.prototype.hasOwnProperty.call(config, key)) {
                config[key] = selectedIndicatorConfig.defaultValues[key];
              }
            });
          }
          
          // Set parameters to default values if they weren't explicitly set in keyValuePairs
          if (selectedIndicatorConfig.parameters) {
            selectedIndicatorConfig.parameters.forEach(param => {
              const paramKey = param.key;
              const keyValueKey = `INOS_${currentInosIndex}_${paramKey}`;
              
              // If this parameter wasn't found in keyValuePairs, use the default
              if (!keyValuePairs[keyValueKey] && selectedIndicatorConfig.defaultValues[paramKey]) {
                config[paramKey] = selectedIndicatorConfig.defaultValues[paramKey];
              }
            });
          }
          
          // Set string parameters to default values if they weren't explicitly set
          if (selectedIndicatorConfig.stringParameters) {
            selectedIndicatorConfig.stringParameters.forEach(param => {
              const paramKey = param.key;
              const keyValueKey = `INOS_${currentInosIndex}_${paramKey}`;
              
              // If this parameter wasn't found in keyValuePairs, use the default
              if (!keyValuePairs[keyValueKey] && selectedIndicatorConfig.defaultValues[paramKey]) {
                config[paramKey] = selectedIndicatorConfig.defaultValues[paramKey];
              }
            });
          }
        }
      }

      if(keyValuePairs[`INOS_${inosIndex}_nSignalInUse`])
      {
        config.nSignalInUse = keyValuePairs[`INOS_${inosIndex}_nSignalInUse`] === `1`;
      }
      if(keyValuePairs[`INOS_${inosIndex}_nSignalUsedFor`])
      {
        config.nSignalUsedFor = keyValuePairs[`INOS_${inosIndex}_nSignalUsedFor`];
      }
      if(keyValuePairs[`INOS_${inosIndex}_nSignalVisualization`])
      {
        config.nSignalVisualization = keyValuePairs[`INOS_${inosIndex}_nSignalVisualization`] === `1`;
      }
      if(keyValuePairs[`INOS_${inosIndex}_nDrawInChart`])
      {
        config.nDrawInChart = keyValuePairs[`INOS_${inosIndex}_nDrawInChart`] === `1`;
      }
      if(keyValuePairs[`INOS_${inosIndex}_nDrawingSlot`])
      {
        config.nDrawingSlot = keyValuePairs[`INOS_${inosIndex}_nDrawingSlot`];
      }
      if(keyValuePairs[`INOS_${inosIndex}_nLogDrawingSlot`])
      {
        config.nLogDrawingSlot = keyValuePairs[`INOS_${inosIndex}_nLogDrawingSlot`] === `1`;
      }
      if(keyValuePairs[`INOS_${inosIndex}_nSelection`])
      {
        config.nSelection = keyValuePairs[`INOS_${inosIndex}_nSelection`];
      }
      if(keyValuePairs[`INOS_${inosIndex}_strSymbol`])
      {
        config.strSymbol = keyValuePairs[`INOS_${inosIndex}_strSymbol`] === "CURRENT" ? "Current" : keyValuePairs[`INOS_${inosIndex}_strSymbol`];
      }
      if(keyValuePairs[`INOS_${inosIndex}_strExclusion`])
      {
        config.strExclusion = keyValuePairs[`INOS_${inosIndex}_strExclusion`];
      }
      if(keyValuePairs[`INOS_${inosIndex}_nTimeframe`])
      {
        config.nTimeframe = keyValuePairs[`INOS_${inosIndex}_nTimeframe`];
      }
      if(keyValuePairs[`INOS_${inosIndex}_nSeries`])
      {
        config.nSeries = keyValuePairs[`INOS_${inosIndex}_nSeries`];
      }
      if(keyValuePairs[`INOS_${inosIndex}_nShift`])
      {
        config.nShift = keyValuePairs[`INOS_${inosIndex}_nShift`];
      }
      if(keyValuePairs[`INOS_${inosIndex}_nLineIndex`])
      {
        config.nLineIndex = keyValuePairs[`INOS_${inosIndex}_nLineIndex`];
      }
      if(keyValuePairs[`INOS_${inosIndex}_dParameter1`])
      {
        config.dParameter1 = parseFromFormattedDigits(keyValuePairs[`INOS_${inosIndex}_dParameter1`]);
      }
      if(keyValuePairs[`INOS_${inosIndex}_dParameter2`])
      {
        config.dParameter2 = parseFromFormattedDigits(keyValuePairs[`INOS_${inosIndex}_dParameter2`]);
      }
      if(keyValuePairs[`INOS_${inosIndex}_dParameter3`])
      {
        config.dParameter3 = parseFromFormattedDigits(keyValuePairs[`INOS_${inosIndex}_dParameter3`]);
      }
      if(keyValuePairs[`INOS_${inosIndex}_dParameter4`])
      {
        config.dParameter4 = parseFromFormattedDigits(keyValuePairs[`INOS_${inosIndex}_dParameter4`]);
      }
      if(keyValuePairs[`INOS_${inosIndex}_dParameter5`])
      {
        config.dParameter5 = parseFromFormattedDigits(keyValuePairs[`INOS_${inosIndex}_dParameter5`]);
      }
      if(keyValuePairs[`INOS_${inosIndex}_dParameter6`])
      {
        config.dParameter6 = parseFromFormattedDigits(keyValuePairs[`INOS_${inosIndex}_dParameter6`]);
      }
      if(keyValuePairs[`INOS_${inosIndex}_dParameter7`])
      {
        config.dParameter7 = parseFromFormattedDigits(keyValuePairs[`INOS_${inosIndex}_dParameter7`]);
      }
      if(keyValuePairs[`INOS_${inosIndex}_dParameter8`])
      {
        config.dParameter8 = parseFromFormattedDigits(keyValuePairs[`INOS_${inosIndex}_dParameter8`]);
      }
      if(keyValuePairs[`INOS_${inosIndex}_dParameter9`])
      {
        config.dParameter9 = parseFromFormattedDigits(keyValuePairs[`INOS_${inosIndex}_dParameter9`]);
      }
      if(keyValuePairs[`INOS_${inosIndex}_dParameter10`])
      {
        config.dParameter10 = parseFromFormattedDigits(keyValuePairs[`INOS_${inosIndex}_dParameter10`]);
      }
      if(keyValuePairs[`INOS_${inosIndex}_dParameter11`])
      {
        config.dParameter11 = parseFromFormattedDigits(keyValuePairs[`INOS_${inosIndex}_dParameter11`]);
      }
      if(keyValuePairs[`INOS_${inosIndex}_dParameter12`])
      {
        config.dParameter12 = parseFromFormattedDigits(keyValuePairs[`INOS_${inosIndex}_dParameter12`]);
      }
      if(keyValuePairs[`INOS_${inosIndex}_dParameter13`])
      {
        config.dParameter13 = parseFromFormattedDigits(keyValuePairs[`INOS_${inosIndex}_dParameter13`]);
      }
      if(keyValuePairs[`INOS_${inosIndex}_dParameter14`])
      {
        config.dParameter14 = parseFromFormattedDigits(keyValuePairs[`INOS_${inosIndex}_dParameter14`]);
      }
      if(keyValuePairs[`INOS_${inosIndex}_dParameter15`])
      {
        config.dParameter15 = parseFromFormattedDigits(keyValuePairs[`INOS_${inosIndex}_dParameter15`]);
      }
      if(keyValuePairs[`INOS_${inosIndex}_dParameter16`])
      {
        config.dParameter16 = parseFromFormattedDigits(keyValuePairs[`INOS_${inosIndex}_dParameter16`]);
      }
      if(keyValuePairs[`INOS_${inosIndex}_dParameter17`])
      {
        config.dParameter17 = parseFromFormattedDigits(keyValuePairs[`INOS_${inosIndex}_dParameter17`]);
      }
      if(keyValuePairs[`INOS_${inosIndex}_dParameter18`])
      {
        config.dParameter18 = parseFromFormattedDigits(keyValuePairs[`INOS_${inosIndex}_dParameter18`]);
      }
      if(keyValuePairs[`INOS_${inosIndex}_dParameter19`])
      {
        config.dParameter19 = parseFromFormattedDigits(keyValuePairs[`INOS_${inosIndex}_dParameter19`]);
      }
      if(keyValuePairs[`INOS_${inosIndex}_dParameter20`])
      {
        config.dParameter20 = parseFromFormattedDigits(keyValuePairs[`INOS_${inosIndex}_dParameter20`]);
      }
      if(keyValuePairs[`INOS_${inosIndex}_dParameter21`])
      {
        config.dParameter21 = parseFromFormattedDigits(keyValuePairs[`INOS_${inosIndex}_dParameter21`]);
      }
      if(keyValuePairs[`INOS_${inosIndex}_dParameter22`])
      {
        config.dParameter22 = parseFromFormattedDigits(keyValuePairs[`INOS_${inosIndex}_dParameter22`]);
      }
      if(keyValuePairs[`INOS_${inosIndex}_dParameter23`])
      {
        config.dParameter23 = parseFromFormattedDigits(keyValuePairs[`INOS_${inosIndex}_dParameter23`]);
      }
      if(keyValuePairs[`INOS_${inosIndex}_dParameter24`])
      {
        config.dParameter24 = parseFromFormattedDigits(keyValuePairs[`INOS_${inosIndex}_dParameter24`]);
      }
      if(keyValuePairs[`INOS_${inosIndex}_dParameter25`])
      {
        config.dParameter25 = parseFromFormattedDigits(keyValuePairs[`INOS_${inosIndex}_dParameter25`]);
      }
      if(keyValuePairs[`INOS_${inosIndex}_dParameter26`])
      {
        config.dParameter26 = parseFromFormattedDigits(keyValuePairs[`INOS_${inosIndex}_dParameter26`]);
      }
      if(keyValuePairs[`INOS_${inosIndex}_dParameter27`])
      {
        config.dParameter27 = parseFromFormattedDigits(keyValuePairs[`INOS_${inosIndex}_dParameter27`]);
      }
      if(keyValuePairs[`INOS_${inosIndex}_dParameter28`])
      {
        config.dParameter28 = parseFromFormattedDigits(keyValuePairs[`INOS_${inosIndex}_dParameter28`]);
      }
      if(keyValuePairs[`INOS_${inosIndex}_dParameter29`])
      {
        config.dParameter29 = parseFromFormattedDigits(keyValuePairs[`INOS_${inosIndex}_dParameter29`]);
      }
      if(keyValuePairs[`INOS_${inosIndex}_dParameter30`])
      {
        config.dParameter30 = parseFromFormattedDigits(keyValuePairs[`INOS_${inosIndex}_dParameter30`]);
      }
      if(keyValuePairs[`INOS_${inosIndex}_dParameter31`])
      {
        config.dParameter31 = parseFromFormattedDigits(keyValuePairs[`INOS_${inosIndex}_dParameter31`]);
      }
      if(keyValuePairs[`INOS_${inosIndex}_dParameter32`])
      {
        config.dParameter32 = parseFromFormattedDigits(keyValuePairs[`INOS_${inosIndex}_dParameter32`]);
      }
      if(keyValuePairs[`INOS_${inosIndex}_strParameter1`])
      {
        config.strParameter1 = keyValuePairs[`INOS_${inosIndex}_strParameter1`];
      }
      if(keyValuePairs[`INOS_${inosIndex}_strParameter2`])
      {
        config.strParameter2 = keyValuePairs[`INOS_${inosIndex}_strParameter2`];
      }
      if(keyValuePairs[`INOS_${inosIndex}_strParameter3`])
      {
        config.strParameter3 = keyValuePairs[`INOS_${inosIndex}_strParameter3`];
      }
      if(keyValuePairs[`INOS_${inosIndex}_strParameter4`])
      {
        config.strParameter4 = keyValuePairs[`INOS_${inosIndex}_strParameter4`];
      }
      if(keyValuePairs[`INOS_${inosIndex}_strMt4CustomPath`])
      {
        config.strMt4CustomPath = keyValuePairs[`INOS_${inosIndex}_strMt4CustomPath`];
      }
      if(keyValuePairs[`INOS_${inosIndex}_strMt5CustomPath`])
      {
        config.strMt5CustomPath = keyValuePairs[`INOS_${inosIndex}_strMt5CustomPath`];
      }
      if(keyValuePairs[`INOS_${inosIndex}_nAngleCondition`])
      {
        config.nAngleCondition = keyValuePairs[`INOS_${inosIndex}_nAngleCondition`];
      }
      if(keyValuePairs[`INOS_${inosIndex}_dAngleLimit1`])
      {
        config.dAngleLimit1 = parseFromFormattedDigits(keyValuePairs[`INOS_${inosIndex}_dAngleLimit1`]);
      }
      if(keyValuePairs[`INOS_${inosIndex}_dAngleLimit2`])
      {
        config.dAngleLimit2 = parseFromFormattedDigits(keyValuePairs[`INOS_${inosIndex}_dAngleLimit2`]);
      }
      if(keyValuePairs[`INOS_${inosIndex}_nValueCondition`])
      {
        config.nValueCondition = keyValuePairs[`INOS_${inosIndex}_nValueCondition`];
      }
      if(keyValuePairs[`INOS_${inosIndex}_dValueLimit1`])
      {
        config.dValueLimit1 = parseFromFormattedDigits(keyValuePairs[`INOS_${inosIndex}_dValueLimit1`]);
      }
      if(keyValuePairs[`INOS_${inosIndex}_dValueLimit2`])
      {
        config.dValueLimit2 = parseFromFormattedDigits(keyValuePairs[`INOS_${inosIndex}_dValueLimit2`]);
      }
      if(keyValuePairs[`INOS_${inosIndex}_dForwardAdjustment`])
      {
        config.dForwardAdjustment = parseFromFormattedDigits(keyValuePairs[`INOS_${inosIndex}_dForwardAdjustment`]);
      }
      if(keyValuePairs[`INOS_${inosIndex}_nValueAnalysisFeedbackState`])
      {
        config.nValueAnalysisFeedbackState = keyValuePairs[`INOS_${inosIndex}_nValueAnalysisFeedbackState`] === `1`;
      }
      if(keyValuePairs[`INOS_${inosIndex}_nSignalAnalysisFeedbackState`])
      {
        config.nSignalAnalysisFeedbackState = keyValuePairs[`INOS_${inosIndex}_nSignalAnalysisFeedbackState`] === `1`;
      }

      // Generate unique ID
      const id = indicatorNumberToId[inosIndex];

      const name = IndicatorsBuildName(config);
      const subtitle = IndicatorsBuildSubtitle(config);
      const indicator = {
        id,
        name,
        subtitle,
        isNewlyCreated: false,
        config,
      };

      moduleData.indicators.push(indicator);
      inosIndex += 1;

      if(DEBUG_LEVEL >= 2) { console.log("INOS_X"); }
    }

    // ----------------------------------------------------------------------
    // RELIO_X
    // ----------------------------------------------------------------------
    let relioIndex = 1;
    while (keyValuePairs[`RELIO_${relioIndex}_nSignalInUse`]) {
      
      const config = { ...IndicatorCombinationsDefaults };
      
      if(keyValuePairs[`RELIO_${relioIndex}_nSignalInUse`])
      {
        config.nSignalInUse = keyValuePairs[`RELIO_${relioIndex}_nSignalInUse`] === `1`;
      }
      if(keyValuePairs[`RELIO_${relioIndex}_nSignalUsedFor`])
      {
        config.nSignalUsedFor = keyValuePairs[`RELIO_${relioIndex}_nSignalUsedFor`];
      }
      if(keyValuePairs[`RELIO_${relioIndex}_nSignalVisualization`])
      {
        config.nSignalVisualization = keyValuePairs[`RELIO_${relioIndex}_nSignalVisualization`] === `1`;
      }
      if(keyValuePairs[`RELIO_${relioIndex}_nInputInos1`])
      {
        config.nInputInos1 = keyValuePairs[`RELIO_${relioIndex}_nInputInos1`] !== "0" ? indicatorNumberToId[keyValuePairs[`RELIO_${relioIndex}_nInputInos1`]].toString() : "0";
      }
      if(keyValuePairs[`RELIO_${relioIndex}_nInputInos2`])
      {
        config.nInputInos2 = keyValuePairs[`RELIO_${relioIndex}_nInputInos2`] !== "0" ? indicatorNumberToId[keyValuePairs[`RELIO_${relioIndex}_nInputInos2`]].toString() : "0";
      }
      if(keyValuePairs[`RELIO_${relioIndex}_nSignalAnalysisFeedbackState`])
      {
        config.nSignalAnalysisFeedbackState = keyValuePairs[`RELIO_${relioIndex}_nSignalAnalysisFeedbackState`] === `1`;
      }
      if(keyValuePairs[`RELIO_${relioIndex}_SEL_1_nRelation`])
      {
        config.nRelation1 = keyValuePairs[`RELIO_${relioIndex}_SEL_1_nRelation`];
      }
      if(keyValuePairs[`RELIO_${relioIndex}_SEL_2_nRelation`])
      {
        config.nRelation2 = keyValuePairs[`RELIO_${relioIndex}_SEL_2_nRelation`];
      }

      // Generate unique ID
      let id = now + relioIndex;
      if(keyValuePairs[`RELIO_${relioIndex}_nId`])
      {
        id = keyValuePairs[`RELIO_${relioIndex}_nId`];
      }

      const relio = {
        config,
        id: parseInt(id, 10),
        isNewlyCreated: false,
        name: IndicatorCombinationsBuildName(config, moduleData.indicators),
        subtitle: IndicatorCombinationsBuildSubtitle(config),
      };
      moduleData.indicatorCombinations.push(relio);
      relioIndex += 1;

      if(DEBUG_LEVEL >= 2) { console.log("RELIO_X"); }
    }

    // ----------------------------------------------------------------------
    // CA_X
    // ----------------------------------------------------------------------
    caIndex = 1;
    while (keyValuePairs[`CA_${caIndex}_nSignalInUse`]) {

      const config = { ...ChartAnalyzersDefaults };

      if(keyValuePairs[`CA_${caIndex}_nSignalInUse`]) {
        config.nSignalInUse = keyValuePairs[`CA_${caIndex}_nSignalInUse`] === `1`;
      }
      if(keyValuePairs[`CA_${caIndex}_nSignalUsedFor`]) {
        config.nSignalUsedFor = keyValuePairs[`CA_${caIndex}_nSignalUsedFor`];
      }
      if(keyValuePairs[`CA_${caIndex}_nSignalVisualization`]) {
        config.nSignalVisualization = keyValuePairs[`CA_${caIndex}_nSignalVisualization`] === `1`;
      }
      if(keyValuePairs[`CA_${caIndex}_strSymbol`]) {
        config.strSymbol = keyValuePairs[`CA_${caIndex}_strSymbol`] === "CURRENT" ? "Current" : keyValuePairs[`CA_${caIndex}_strSymbol`];
      }
      if(keyValuePairs[`CA_${caIndex}_strExclusion`]) {
        config.strExclusion = keyValuePairs[`CA_${caIndex}_strExclusion`];
      }
      if(keyValuePairs[`CA_${caIndex}_nTimeframe`]) {
        config.nTimeframe = keyValuePairs[`CA_${caIndex}_nTimeframe`];
      }
      if(keyValuePairs[`CA_${caIndex}_nShift`]) {
        config.nShift = keyValuePairs[`CA_${caIndex}_nShift`];
      }
      if(keyValuePairs[`CA_${caIndex}_nWidth`]) {
        config.nWidth = keyValuePairs[`CA_${caIndex}_nWidth`];
      }
      if(keyValuePairs[`CA_${caIndex}_dProminence`]) {
        config.dProminence = parseFromFormattedDigits(keyValuePairs[`CA_${caIndex}_dProminence`]);
      }
      if(keyValuePairs[`CA_${caIndex}_dBreakoutFactor`]) {
        config.dBreakoutFactor = parseFromFormattedDigits(keyValuePairs[`CA_${caIndex}_dBreakoutFactor`]);
      }
      if(keyValuePairs[`CA_${caIndex}_nMidVolaMinSwings`]) {
        config.nMidVolaMinSwings = parseFromFormattedDigits(keyValuePairs[`CA_${caIndex}_nMidVolaMinSwings`]);
      }
      if(keyValuePairs[`CA_${caIndex}_dMidVolaMinROC`]) {
        config.dMidVolaMinROC = parseFromFormattedDigits(keyValuePairs[`CA_${caIndex}_dMidVolaMinROC`]);
      }
      if(keyValuePairs[`CA_${caIndex}_dMidVolaMinFilled`]) {
        config.dMidVolaMinFilled = parseFromFormattedDigits(keyValuePairs[`CA_${caIndex}_dMidVolaMinFilled`]);
      }
      if(keyValuePairs[`CA_${caIndex}_nHighVolaMinSwings`]) {
        config.nHighVolaMinSwings = parseFromFormattedDigits(keyValuePairs[`CA_${caIndex}_nHighVolaMinSwings`]);
      }
      if(keyValuePairs[`CA_${caIndex}_dHighVolaMinROC`]) {
        config.dHighVolaMinROC = parseFromFormattedDigits(keyValuePairs[`CA_${caIndex}_dHighVolaMinROC`]);
      }
      if(keyValuePairs[`CA_${caIndex}_dHighVolaMinFilled`]) {
        config.dHighVolaMinFilled = parseFromFormattedDigits(keyValuePairs[`CA_${caIndex}_dHighVolaMinFilled`]);
      }
      if(keyValuePairs[`CA_${caIndex}_nDrawBoundaries`]) {
        config.nDrawBoundaries = keyValuePairs[`CA_${caIndex}_nDrawBoundaries`] === `1`;
      }
      if(keyValuePairs[`CA_${caIndex}_nDrawExtrema`]) {
        config.nDrawExtrema = keyValuePairs[`CA_${caIndex}_nDrawExtrema`] === `1`;
      }
      if(keyValuePairs[`CA_${caIndex}_nDrawSupRes`]) {
        config.nDrawSupRes = keyValuePairs[`CA_${caIndex}_nDrawSupRes`] === `1`;
      }
      if(keyValuePairs[`CA_${caIndex}_nDrawSwingPhase`]) {
        config.nDrawSwingPhase = keyValuePairs[`CA_${caIndex}_nDrawSwingPhase`] === `1`;
      }
      if(keyValuePairs[`CA_${caIndex}_strSupResForward`]) {
        config.strSupResForward = keyValuePairs[`CA_${caIndex}_strSupResForward`];
      }
      if(keyValuePairs[`CA_${caIndex}_dSupportMultiplier`]) {
        config.dSupportMultiplier = parseFromFormattedDigits(keyValuePairs[`CA_${caIndex}_dSupportMultiplier`]);
      }
      if(keyValuePairs[`CA_${caIndex}_dResistanceMultiplier`]) {
        config.dResistanceMultiplier = parseFromFormattedDigits(keyValuePairs[`CA_${caIndex}_dResistanceMultiplier`]);
      }
      if(keyValuePairs[`CA_${caIndex}_dRegressionAnglesMin`]) {
        config.dRegressionAnglesMin = parseFromFormattedDigits(keyValuePairs[`CA_${caIndex}_dRegressionAnglesMin`]);
      }
      if(keyValuePairs[`CA_${caIndex}_dRegressionAnglesMax`]) {
        config.dRegressionAnglesMax = parseFromFormattedDigits(keyValuePairs[`CA_${caIndex}_dRegressionAnglesMax`]);
      }
      if(keyValuePairs[`CA_${caIndex}_nTradeVolatilityLow`]) {
        config.nTradeVolatilityLow = keyValuePairs[`CA_${caIndex}_nTradeVolatilityLow`] === `1`;
      }
      if(keyValuePairs[`CA_${caIndex}_nTradeVolatilityMiddle`]) {
        config.nTradeVolatilityMiddle = keyValuePairs[`CA_${caIndex}_nTradeVolatilityMiddle`] === `1`;
      }
      if(keyValuePairs[`CA_${caIndex}_nTradeVolatilityHigh`]) {
        config.nTradeVolatilityHigh = keyValuePairs[`CA_${caIndex}_nTradeVolatilityHigh`] === `1`;
      }
      if(keyValuePairs[`CA_${caIndex}_nTradeSwingPhaseOverstatement`]) {
        config.nTradeSwingPhaseOverstatement = keyValuePairs[`CA_${caIndex}_nTradeSwingPhaseOverstatement`] === `1`;
      }
      if(keyValuePairs[`CA_${caIndex}_nTradeSwingPhaseUnderstatement`]) {
        config.nTradeSwingPhaseUnderstatement = keyValuePairs[`CA_${caIndex}_nTradeSwingPhaseUnderstatement`] === `1`;
      }
      if(keyValuePairs[`CA_${caIndex}_nTradeSwingPhaseOverCorrection`]) {
        config.nTradeSwingPhaseOverCorrection = keyValuePairs[`CA_${caIndex}_nTradeSwingPhaseOverCorrection`] === `1`;
      }
      if(keyValuePairs[`CA_${caIndex}_nTradeSwingPhaseUnderCorrection`]) {
        config.nTradeSwingPhaseUnderCorrection = keyValuePairs[`CA_${caIndex}_nTradeSwingPhaseUnderCorrection`] === `1`;
      }
      if(keyValuePairs[`CA_${caIndex}_nTradeSwingPhaseUpswing`]) {
        config.nTradeSwingPhaseUpswing = keyValuePairs[`CA_${caIndex}_nTradeSwingPhaseUpswing`] === `1`;
      }
      if(keyValuePairs[`CA_${caIndex}_nTradeSwingPhaseDownswing`]) {
        config.nTradeSwingPhaseDownswing = keyValuePairs[`CA_${caIndex}_nTradeSwingPhaseDownswing`] === `1`;
      }
      if(keyValuePairs[`CA_${caIndex}_nTradeSwingPhaseUndefined`]) {
        config.nTradeSwingPhaseUndefined = keyValuePairs[`CA_${caIndex}_nTradeSwingPhaseUndefined`] === `1`;
      }
      if(keyValuePairs[`CA_${caIndex}_dCurrentSwingAngleMin`]) {
        config.dCurrentSwingAngleMin = parseFromFormattedDigits(keyValuePairs[`CA_${caIndex}_dCurrentSwingAngleMin`]);
      }
      if(keyValuePairs[`CA_${caIndex}_dCurrentSwingAngleMax`]) {
        config.dCurrentSwingAngleMax = parseFromFormattedDigits(keyValuePairs[`CA_${caIndex}_dCurrentSwingAngleMax`]);
      }
      if(keyValuePairs[`CA_${caIndex}_dCurrentSwingPosMin`]) {
        config.dCurrentSwingPosMin = parseFromFormattedDigits(keyValuePairs[`CA_${caIndex}_dCurrentSwingPosMin`]);
      }
      if(keyValuePairs[`CA_${caIndex}_dCurrentSwingPosMax`]) {
        config.dCurrentSwingPosMax = parseFromFormattedDigits(keyValuePairs[`CA_${caIndex}_dCurrentSwingPosMax`]);
      }
      if(keyValuePairs[`CA_${caIndex}_nValueAnalysisFeedbackState`]) {
        config.nValueAnalysisFeedbackState = keyValuePairs[`CA_${caIndex}_nValueAnalysisFeedbackState`] === `1`;
      }
      if(keyValuePairs[`CA_${caIndex}_nSignalAnalysisFeedbackState`]) {
        config.nSignalAnalysisFeedbackState = keyValuePairs[`CA_${caIndex}_nSignalAnalysisFeedbackState`] === `1`;
      }
      config.swingConfigurations = [];
      const chartAnalyzer = {
        config,
      };

      if(DEBUG_LEVEL >= 2) { console.log("CA_X"); }

      // Parse swing configurations for this chart analyzer
      let swingIndex = 1;
      while (keyValuePairs[`CA_${caIndex}_SWING_${swingIndex}_nNumber`]) {
        const swing = { ...ChartAnalyzersSwingConfigurationsDefaults };
        
        if(keyValuePairs[`CA_${caIndex}_SWING_${swingIndex}_nNumber`]) {
          swing.nNumber = keyValuePairs[`CA_${caIndex}_SWING_${swingIndex}_nNumber`];
        }
        if(keyValuePairs[`CA_${caIndex}_SWING_${swingIndex}_bState`]) {
          swing.bState = keyValuePairs[`CA_${caIndex}_SWING_${swingIndex}_bState`] === `1`;
        }
        else if(keyValuePairs[`CA_${caIndex}_SWING_${swingIndex}_nNumber`] && parseFloat(keyValuePairs[`CA_${caIndex}_SWING_${swingIndex}_nNumber`]) !== 0)
        {
          swing.bState = true;
        }
        if(keyValuePairs[`CA_${caIndex}_SWING_${swingIndex}_dHeightMax`]) {
          swing.dHeightMax = parseFromFormattedDigits(keyValuePairs[`CA_${caIndex}_SWING_${swingIndex}_dHeightMax`]);
        }
        if(keyValuePairs[`CA_${caIndex}_SWING_${swingIndex}_dHeightMin`]) {
          swing.dHeightMin = parseFromFormattedDigits(keyValuePairs[`CA_${caIndex}_SWING_${swingIndex}_dHeightMin`]);
        }
        if(keyValuePairs[`CA_${caIndex}_SWING_${swingIndex}_dWidthMax`]) {
          swing.dWidthMax = parseFromFormattedDigits(keyValuePairs[`CA_${caIndex}_SWING_${swingIndex}_dWidthMax`]);
        }
        if(keyValuePairs[`CA_${caIndex}_SWING_${swingIndex}_dWidthMin`]) {
          swing.dWidthMin = parseFromFormattedDigits(keyValuePairs[`CA_${caIndex}_SWING_${swingIndex}_dWidthMin`]);
        }
        if(keyValuePairs[`CA_${caIndex}_SWING_${swingIndex}_dRangeHeightMax`]) {
          swing.dRangeHeightMax = parseFromFormattedDigits(keyValuePairs[`CA_${caIndex}_SWING_${swingIndex}_dRangeHeightMax`]);
        }
        if(keyValuePairs[`CA_${caIndex}_SWING_${swingIndex}_dRangeHeightMin`]) {
          swing.dRangeHeightMin = parseFromFormattedDigits(keyValuePairs[`CA_${caIndex}_SWING_${swingIndex}_dRangeHeightMin`]);
        }
        if(keyValuePairs[`CA_${caIndex}_SWING_${swingIndex}_dRangeWidthMax`]) {
          swing.dRangeWidthMax = parseFromFormattedDigits(keyValuePairs[`CA_${caIndex}_SWING_${swingIndex}_dRangeWidthMax`]);
        }
        if(keyValuePairs[`CA_${caIndex}_SWING_${swingIndex}_dRangeWidthMin`]) {
          swing.dRangeWidthMin = parseFromFormattedDigits(keyValuePairs[`CA_${caIndex}_SWING_${swingIndex}_dRangeWidthMin`]);
        }
        if(keyValuePairs[`CA_${caIndex}_SWING_${swingIndex}_dRangeUpperPointMax`]) {
          swing.dRangeUpperPointMax = parseFromFormattedDigits(keyValuePairs[`CA_${caIndex}_SWING_${swingIndex}_dRangeUpperPointMax`]);
        }
        if(keyValuePairs[`CA_${caIndex}_SWING_${swingIndex}_dRangeUpperPointMin`]) {
          swing.dRangeUpperPointMin = parseFromFormattedDigits(keyValuePairs[`CA_${caIndex}_SWING_${swingIndex}_dRangeUpperPointMin`]);
        }
        if(keyValuePairs[`CA_${caIndex}_SWING_${swingIndex}_dRangeLowerPointMax`]) {
          swing.dRangeLowerPointMax = parseFromFormattedDigits(keyValuePairs[`CA_${caIndex}_SWING_${swingIndex}_dRangeLowerPointMax`]);
        }
        if(keyValuePairs[`CA_${caIndex}_SWING_${swingIndex}_dRangeLowerPointMin`]) {
          swing.dRangeLowerPointMin = parseFromFormattedDigits(keyValuePairs[`CA_${caIndex}_SWING_${swingIndex}_dRangeLowerPointMin`]);
        }
        if(keyValuePairs[`CA_${caIndex}_SWING_${swingIndex}_dRangeLeftPointMax`]) {
          swing.dRangeLeftPointMax = parseFromFormattedDigits(keyValuePairs[`CA_${caIndex}_SWING_${swingIndex}_dRangeLeftPointMax`]);
        }
        if(keyValuePairs[`CA_${caIndex}_SWING_${swingIndex}_dRangeLeftPointMin`]) {
          swing.dRangeLeftPointMin = parseFromFormattedDigits(keyValuePairs[`CA_${caIndex}_SWING_${swingIndex}_dRangeLeftPointMin`]);
        }
        if(keyValuePairs[`CA_${caIndex}_SWING_${swingIndex}_dRangeRightPointMax`]) {
          swing.dRangeRightPointMax = parseFromFormattedDigits(keyValuePairs[`CA_${caIndex}_SWING_${swingIndex}_dRangeRightPointMax`]);
        }
        if(keyValuePairs[`CA_${caIndex}_SWING_${swingIndex}_dRangeRightPointMin`]) {
          swing.dRangeRightPointMin = parseFromFormattedDigits(keyValuePairs[`CA_${caIndex}_SWING_${swingIndex}_dRangeRightPointMin`]);
        }

        chartAnalyzer.config.swingConfigurations.push(swing);
        swingIndex += 1;

        if(DEBUG_LEVEL >= 2) { console.log("CA_X_SWING_Y"); }
      }
     
      // Generate unique ID
      let id = chartAnalyzerNumberToId[caIndex];

      if(keyValuePairs[`CA_${caIndex}_nId`])
      {
        id = keyValuePairs[`CA_${caIndex}_nId`];
      }

      chartAnalyzer.id = parseInt(id, 10);
      chartAnalyzer.name = ChartAnalyzersBuildName(chartAnalyzer.config);
      chartAnalyzer.subtitle = ChartAnalyzersBuildSubtitle(chartAnalyzer.config);
      chartAnalyzer.isNewlyCreated = false;

      moduleData.chartAnalyzers.push(chartAnalyzer);
      caIndex += 1;
    }

    // ----------------------------------------------------------------------
    // CAS_1
    // ----------------------------------------------------------------------
    if (keyValuePairs.CAS_1_nSignalInUse) {
      if(keyValuePairs.CAS_1_nSignalInUse) {
        moduleData.candlePatterns.nSignalInUse = keyValuePairs.CAS_1_nSignalInUse === `1`;  
      }
      if(keyValuePairs.CAS_1_nSignalUsedFor) {
        moduleData.candlePatterns.nSignalUsedFor = keyValuePairs.CAS_1_nSignalUsedFor;  
      }
      if(keyValuePairs.CAS_1_nSignalVisualization) {
        moduleData.candlePatterns.nSignalVisualization = keyValuePairs.CAS_1_nSignalVisualization === `1`;
      }
      if(keyValuePairs.CAS_1_nLogResults) {
        moduleData.candlePatterns.nLogResults = keyValuePairs.CAS_1_nLogResults === `1`;  
      }
      if(keyValuePairs.CAS_1_nDrawResults) {
        moduleData.candlePatterns.nDrawResults = keyValuePairs.CAS_1_nDrawResults === `1`; 
      }
      if(keyValuePairs.CAS_1_strSymbol) {
        moduleData.candlePatterns.strSymbol = keyValuePairs.CAS_1_strSymbol === "CURRENT" ? "Current" : keyValuePairs.CAS_1_strSymbol;  
      }
      if(keyValuePairs.CAS_1_strExclusion) {
        moduleData.candlePatterns.strExclusion = keyValuePairs.CAS_1_strExclusion;  
      }
      if(keyValuePairs.CAS_1_nTimeframe) {
        moduleData.candlePatterns.nTimeframe = keyValuePairs.CAS_1_nTimeframe;  
      }
      if(keyValuePairs.CAS_1_nShift) {
        moduleData.candlePatterns.nShift = keyValuePairs.CAS_1_nShift;  
      }
      if(keyValuePairs.CAS_1_dStopLossForwardAdjustment) {
        moduleData.candlePatterns.dStopLossForwardAdjustment = parseFromFormattedDigits(keyValuePairs.CAS_1_dStopLossForwardAdjustment);  
      }
      if(keyValuePairs.CAS_1_dTakeProfitForwardAdjustment) {
        moduleData.candlePatterns.dTakeProfitForwardAdjustment = parseFromFormattedDigits(keyValuePairs.CAS_1_dTakeProfitForwardAdjustment);  
      }

      // Parse candle pattern selections (0-23)
      for (let i = 0; i <= 23; i += 1) {
        let patternState = false;
        for (let f = 0; f <= 23; f += 1)
        {
          if(parseInt(keyValuePairs[`CAS_1_SEL_${f + 1}_nPattern`], 10) === i)
          {
            patternState = true;
          }
        }
        moduleData.candlePatterns[`pattern_${i}`] = patternState;
      }

      if(DEBUG_LEVEL >= 2) { console.log("CAS_1"); }
    }

    // ----------------------------------------------------------------------
    // PAS_1
    // ----------------------------------------------------------------------
    if (keyValuePairs.PAS_1_nSignalInUse) {
      if(keyValuePairs.PAS_1_nSignalInUse) {
        moduleData.chartPatterns.nSignalInUse = keyValuePairs.PAS_1_nSignalInUse === `1`;  
      }
      if(keyValuePairs.PAS_1_nSignalUsedFor) {
        moduleData.chartPatterns.nSignalUsedFor = keyValuePairs.PAS_1_nSignalUsedFor;  
      }
      if(keyValuePairs.PAS_1_nSignalVisualization) {
        moduleData.chartPatterns.nSignalVisualization = keyValuePairs.PAS_1_nSignalVisualization === `1`;  
      }
      if(keyValuePairs.PAS_1_nLogResults) {
        moduleData.chartPatterns.nLogResults = keyValuePairs.PAS_1_nLogResults === `1`;  
      }
      if(keyValuePairs.PAS_1_nDrawResults) {
        moduleData.chartPatterns.nDrawResults = keyValuePairs.PAS_1_nDrawResults === `1`;  
      }
      if(keyValuePairs.PAS_1_strSymbol) {
        moduleData.chartPatterns.strSymbol = keyValuePairs.PAS_1_strSymbol === "CURRENT" ? "Current" : keyValuePairs.PAS_1_strSymbol;  
      }
      if(keyValuePairs.PAS_1_strExclusion) {
        moduleData.chartPatterns.strExclusion = keyValuePairs.PAS_1_strExclusion;  
      }
      if(keyValuePairs.PAS_1_nTimeframe) {
        moduleData.chartPatterns.nTimeframe = keyValuePairs.PAS_1_nTimeframe;  
      }
      if(keyValuePairs.PAS_1_nShift) {
        moduleData.chartPatterns.nShift = keyValuePairs.PAS_1_nShift;  
      }
      if(keyValuePairs.PAS_1_dStopLossForwardAdjustment) {
        moduleData.chartPatterns.dStopLossForwardAdjustment = parseFromFormattedDigits(keyValuePairs.PAS_1_dStopLossForwardAdjustment);  
      }
      if(keyValuePairs.PAS_1_dTakeProfitForwardAdjustment) {
        moduleData.chartPatterns.dTakeProfitForwardAdjustment = parseFromFormattedDigits(keyValuePairs.PAS_1_dTakeProfitForwardAdjustment);  
      }

      // Parse chart pattern selections (0-17)
      for (let i = 0; i <= 17; i += 1) {
        let patternState = false;
        for (let f = 0; f <= 17; f += 1)
        {
          if(parseInt(keyValuePairs[`PAS_1_SEL_${f + 1}_nPattern`], 10) === i)
          {
            patternState = true;
          }
        }
        moduleData.chartPatterns[`pattern_${i}`] = patternState;
      }

      if(DEBUG_LEVEL >= 2) { console.log("PAS_1"); }
    }

    // ----------------------------------------------------------------------
    // FIS_1
    // ----------------------------------------------------------------------
    if (keyValuePairs.FIS_1_nSignalInUse) {
      if(keyValuePairs.FIS_1_nSignalInUse) {
        moduleData.fibonacciPatterns.nSignalInUse = keyValuePairs.FIS_1_nSignalInUse === `1`;  
      }
      if(keyValuePairs.FIS_1_nSignalUsedFor) {
        moduleData.fibonacciPatterns.nSignalUsedFor = keyValuePairs.FIS_1_nSignalUsedFor;  
      }
      if(keyValuePairs.FIS_1_nSignalVisualization) {
        moduleData.fibonacciPatterns.nSignalVisualization = keyValuePairs.FIS_1_nSignalVisualization === `1`;  
      }
      if(keyValuePairs.FIS_1_nLogResults) {
        moduleData.fibonacciPatterns.nLogResults = keyValuePairs.FIS_1_nLogResults === `1`;  
      }
      if(keyValuePairs.FIS_1_nDrawResults) {
        moduleData.fibonacciPatterns.nDrawResults = keyValuePairs.FIS_1_nDrawResults === `1`;  
      }
      if(keyValuePairs.FIS_1_strSymbol) {
        moduleData.fibonacciPatterns.strSymbol = keyValuePairs.FIS_1_strSymbol === "CURRENT" ? "Current" : keyValuePairs.FIS_1_strSymbol;  
      }
      if(keyValuePairs.FIS_1_strExclusion) {
        moduleData.fibonacciPatterns.strExclusion = keyValuePairs.FIS_1_strExclusion;  
      }
      if(keyValuePairs.FIS_1_nTimeframe) {
        moduleData.fibonacciPatterns.nTimeframe = keyValuePairs.FIS_1_nTimeframe;  
      }
      if(keyValuePairs.FIS_1_nShift) {
        moduleData.fibonacciPatterns.nShift = keyValuePairs.FIS_1_nShift;  
      }
      if(keyValuePairs.FIS_1_dStopLossForwardAdjustment) {
        moduleData.fibonacciPatterns.dStopLossForwardAdjustment = parseFromFormattedDigits(keyValuePairs.FIS_1_dStopLossForwardAdjustment);  
      }
      if(keyValuePairs.FIS_1_dTakeProfitForwardAdjustment) {
        moduleData.fibonacciPatterns.dTakeProfitForwardAdjustment = parseFromFormattedDigits(keyValuePairs.FIS_1_dTakeProfitForwardAdjustment);  
      }

      // Parse fibonacci pattern selections (0-1)
      for (let i = 0; i <= 1; i += 1) {
        let patternState = false;
        for (let f = 0; f <= 1; f += 1)
        {
          if(parseInt(keyValuePairs[`FIS_1_SEL_${f + 1}_nPattern`], 10) === i)
          {
            patternState = true;
          }
        }
        moduleData.fibonacciPatterns[`pattern_${i}`] = patternState;
      }

      if(DEBUG_LEVEL >= 2) { console.log("FIS_1"); }
    }
  }

  if(DEBUG_LEVEL >= 1)
  {
    console.log(`----- READ -----`);
    console.log(deepSortKeys(moduleData));
    console.log(`----- READ -----`);
  }

  return moduleData;
};
